/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: unknown; output: unknown; }
  Color: { input: unknown; output: unknown; }
  DateTime: { input: unknown; output: unknown; }
  Email: { input: unknown; output: unknown; }
  InvoiceReference: { input: unknown; output: unknown; }
  JSON: { input: unknown; output: unknown; }
  LimitedString: { input: unknown; output: unknown; }
  LimitedString2: { input: unknown; output: unknown; }
  LimitedString3: { input: unknown; output: unknown; }
  LimitedString4: { input: unknown; output: unknown; }
  LimitedString5: { input: unknown; output: unknown; }
  LimitedString6: { input: unknown; output: unknown; }
  LimitedString7: { input: unknown; output: unknown; }
  LimitedString8: { input: unknown; output: unknown; }
  LimitedString9: { input: unknown; output: unknown; }
  LimitedString10: { input: unknown; output: unknown; }
  LimitedString11: { input: unknown; output: unknown; }
  LimitedString12: { input: unknown; output: unknown; }
  LimitedString13: { input: unknown; output: unknown; }
  LimitedString14: { input: unknown; output: unknown; }
  LimitedString15: { input: unknown; output: unknown; }
  LimitedString16: { input: unknown; output: unknown; }
  LimitedString17: { input: unknown; output: unknown; }
  LimitedString18: { input: unknown; output: unknown; }
  LimitedString19: { input: unknown; output: unknown; }
  LimitedString20: { input: unknown; output: unknown; }
  LimitedString21: { input: unknown; output: unknown; }
  Password: { input: unknown; output: unknown; }
  Percentage: { input: unknown; output: unknown; }
  PwsID: { input: unknown; output: unknown; }
  Upload: { input: unknown; output: unknown; }
};

export type AcceptInviteInput = {
  firstName: Scalars['LimitedString20']['input'];
  /** Unique token from invitation email used to validate and complete the invitation */
  inviteToken: Scalars['String']['input'];
  lastName: Scalars['LimitedString21']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** User access level (read, edit, admin) */
export enum AccessType {
  Admin = 'Admin',
  Edit = 'Edit',
  Read = 'Read'
}

/** Activity log tracking entity creation and modification history for audit trail and notifications */
export type ActivityFeed = {
  /** Type of activity (create, update, add, remove, invite, delete) */
  activityType: ActivityType;
  company: PartialCompany;
  createdAt: Scalars['DateTime']['output'];
  entity?: Maybe<ActivityFeedEntity>;
  /**
   * ID of the modified entity
   * @deprecated use entity instead
   */
  entityId: Scalars['PwsID']['output'];
  /**
   * Type of entity that was modified
   * @deprecated use entity instead
   */
  entityType: EntityType;
  /** Identifier grouping rows written together during the same persist event */
  groupId: Scalars['String']['output'];
  /** New value after change */
  newValue?: Maybe<Scalars['String']['output']>;
  newValueEntity?: Maybe<ActivityFeedEntity>;
  /** Previous value before change */
  oldValue?: Maybe<Scalars['String']['output']>;
  oldValueEntity?: Maybe<ActivityFeedEntity>;
  /** Origin of the change: user action or system process */
  origin: ActivityFeedOrigin;
  /** Property name that was changed */
  property?: Maybe<Scalars['String']['output']>;
  user?: Maybe<PartialUser>;
};

/** Entity referenced by an activity feed entry */
export type ActivityFeedEntity = AdCopy | AdGroup | AdGroupBudgetPlan | AdGroupDirectoryPreset | AdTemplateBanner | AdTemplateNative | AdTemplateWeb | Advertiser | Agency | BillingContact | Campaign | CampaignProgrammatic | CompanyApiToken | CompanyArchiver | CompanyWebhook | Position | Publisher | PublisherExclusionPreset | Reseller | SegmentBehavioural | SegmentCrm | TradingDesk | User | Website;

/** Activity feed changes grouped by entity and property */
export type ActivityFeedGroup = {
  /** Primary activity type for the group (create, update, or delete when present, otherwise the first item) */
  activityType: ActivityType;
  company: PartialCompany;
  /** Timestamp of the latest row in the group */
  createdAt: Scalars['DateTime']['output'];
  entity?: Maybe<ActivityFeedEntity>;
  /** Identifier shared by all rows in this group */
  groupId: Scalars['String']['output'];
  /** Individual property changes in this group */
  items: Array<ActivityFeedGroupItem>;
  /** Origin of the change: user action or system process */
  origin: ActivityFeedOrigin;
  user?: Maybe<PartialUser>;
};

/** A single property change within an activity feed group */
export type ActivityFeedGroupItem = {
  /** Type of activity for this change */
  activityType: ActivityType;
  /** New value after change */
  newValue?: Maybe<Scalars['String']['output']>;
  newValueEntity?: Maybe<ActivityFeedEntity>;
  /** Previous value before change */
  oldValue?: Maybe<Scalars['String']['output']>;
  oldValueEntity?: Maybe<ActivityFeedEntity>;
  /** Property name that was changed */
  property?: Maybe<Scalars['String']['output']>;
};

/** Origin of the change: user action or system process */
export enum ActivityFeedOrigin {
  System = 'System',
  User = 'User'
}

/** Activity type: create (new entity), update (modified property), add (list item added), remove (list item removed), invite (user invitation), delete (entity removed) */
export enum ActivityType {
  Add = 'Add',
  Create = 'Create',
  Delete = 'Delete',
  Invite = 'Invite',
  Remove = 'Remove',
  Update = 'Update'
}

/** Ad creative containing image, text, and targeting settings for display in ad positions */
export type AdCopy = {
  adCopyTags: Array<AdCopyTags>;
  /** Parent ad group this ad copy belongs to */
  adGroup: AdGroup;
  advertiserName: Scalars['LimitedString7']['output'];
  /** Sum of imported analytics statistics (sessions, revenue, etc.) between two dates (inclusive). Access follows the ad copy (parent) query permissions. */
  analyticsStats: AdCopyAnalyticsStatSum;
  callToAction: Scalars['LimitedString6']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['LimitedString5']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** The redirect URL will override the one defined at AdGroup level */
  forceRedirectUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['PwsID']['output'];
  image: Scalars['String']['output'];
  imageCheck?: Maybe<AdCopyImageCheck>;
  /** @deprecated Use imageCheck.hasText instead. */
  imageContainsText?: Maybe<Scalars['Boolean']['output']>;
  /** List of third-party impression tracking pixel URLs */
  impressionPixels: Array<Scalars['String']['output']>;
  lastValidatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Latest aggregated AB test and lifetime statistics for this ad copy, when present in stats storage */
  lifetimeStats?: Maybe<AdCopyStats>;
  name: Scalars['String']['output'];
  /** Performance stats for this ad copy */
  performanceStats: AdCopyPerformanceStats;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle status: pending is a user-info draft; pending_validation awaits team approval before activation */
  status: AdCopyStatus;
  statusUpdatedAt: Scalars['DateTime']['output'];
  /** Time-series performance metrics for this ad copy over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  title: Scalars['LimitedString4']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who validated/approved this ad copy */
  validator?: Maybe<User>;
  visualUpdatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};


/** Ad creative containing image, text, and targeting settings for display in ad positions */
export type AdCopyAnalyticsStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


/** Ad creative containing image, text, and targeting settings for display in ad positions */
export type AdCopyPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Ad creative containing image, text, and targeting settings for display in ad positions */
export type AdCopyTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};

/** Totals of imported analytics metrics for an ad copy over a date range */
export type AdCopyAnalyticsStatSum = {
  bounceRate: Scalars['Float']['output'];
  engagedSessions: Scalars['Int']['output'];
  engagementRate: Scalars['Float']['output'];
  /** Latest `at` date among imported rows in this range; null when there is no data */
  lastAt?: Maybe<Scalars['DateTime']['output']>;
  leads: Scalars['Int']['output'];
  newUsers: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  pageViews: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  sessionTimeSeconds: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type AdCopyAssistantItem = {
  adCopy: AdCopy;
  message: Scalars['String']['output'];
  stats?: Maybe<AdCopyStats>;
};

export type AdCopyConfig = {
  advertiserName: Scalars['Int']['output'];
  callToAction: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
};

export type AdCopyCreateInput = {
  advertiserName?: Scalars['LimitedString11']['input'];
  callToAction?: Scalars['LimitedString10']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  description?: Scalars['LimitedString9']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The redirect URL will override the one defined at AdGroup level */
  forceRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Filename of the image file to be uploaded for this ad copy */
  imageFilename: Scalars['String']['input'];
  /** Array of tracking pixel URLs to fire on ad impression */
  impressionPixels?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Initial status for the ad copy upon creation */
  status: AdCopyCreationStatus;
  title?: Scalars['LimitedString8']['input'];
};

/** Initial status for new ad copy: active (request serving), pending (user-info draft), or inactive (paused) */
export enum AdCopyCreationStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

/** Input for duplicating an existing ad copy with modified content and settings */
export type AdCopyDuplicateInput = {
  advertiserName?: Scalars['LimitedString19']['input'];
  callToAction?: Scalars['LimitedString18']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  description?: Scalars['LimitedString17']['input'];
  /** End date when the ad copy stops being served */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The redirect URL will override the one defined at AdGroup level */
  forceRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of tracking pixel URLs to fire on ad impression */
  impressionPixels?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  /** Start date when the ad copy becomes active and eligible for serving */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Initial status for the duplicated ad copy */
  status: AdCopyCreationStatus;
  title?: Scalars['LimitedString16']['input'];
};

/** Ad copy data needed by analytics import tooling */
export type AdCopyForAnalyticsImport = {
  adGroupId: Scalars['PwsID']['output'];
  analyticsStats: AdCopyAnalyticsStatSum;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Ad copy redirect URL override */
  forceRedirectUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: AdCopyStatus;
};

/** Image analysis result for an ad copy image (keyed by content hash) */
export type AdCopyImageCheck = {
  checkDate?: Maybe<Scalars['DateTime']['output']>;
  color1?: Maybe<Scalars['Color']['output']>;
  color2?: Maybe<Scalars['Color']['output']>;
  color3?: Maybe<Scalars['Color']['output']>;
  /** Image filename stored with the content hash */
  filename: Scalars['String']['output'];
  /** Whether promotional or marketing text was detected in the image */
  hasText: Scalars['Boolean']['output'];
  mainColor1?: Maybe<Scalars['String']['output']>;
  mainColor2?: Maybe<Scalars['String']['output']>;
  mainColor3?: Maybe<Scalars['String']['output']>;
};

export type AdCopyInput = {
  advertiserName: Scalars['LimitedString15']['input'];
  callToAction: Scalars['LimitedString14']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description: Scalars['LimitedString13']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  /** The redirect URL will override the one defined at AdGroup level */
  forceRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  id: Scalars['PwsID']['input'];
  image: Scalars['String']['input'];
  /** Array of tracking pixel URLs to fire on ad impression */
  impressionPixels?: InputMaybe<Array<Scalars['String']['input']>>;
  lastValidatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** AdCopies are validated and approved by the company's Reseller */
  status: AdCopyStatus;
  statusUpdatedAt: Scalars['DateTime']['input'];
  title: Scalars['LimitedString12']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualUpdatedAt: Scalars['DateTime']['input'];
  weight: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type AdCopyMinMaxConfig = {
  max: AdCopyConfig;
  min: AdCopyConfig;
};

export type AdCopyPerformanceStats = {
  devices: Array<AdvertiserDeviceCost>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

/** Preview of how an ad copy will appear in a specific position */
export type AdCopyPreview = {
  id: Scalars['String']['output'];
  /** Base64-encoded preview image or error message */
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Search criteria for filtering ad copies */
export type AdCopySearchQuery = {
  /** Filter ad copies by ad group ID */
  adGroupId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter ad copies by campaign ID */
  campaignId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter ad copies by company ID */
  companyId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter ad copies by IDs */
  ids?: InputMaybe<Array<Scalars['PwsID']['input']>>;
  /** Filter ad copies by market ID */
  marketId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter ad copies by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter ad copies by reseller ID */
  resellerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter ad copies by status */
  status?: InputMaybe<Array<AdCopyStatus>>;
  /** Filter ad copies by account manager user IDs (advertiser or agency account manager) */
  trafficAccountIds?: InputMaybe<Array<Scalars['PwsID']['input']>>;
};

/** Latest aggregated AB test statistics for an adcopy */
export type AdCopyStats = {
  abTestClicks: Scalars['Int']['output'];
  abTestCosts: Scalars['Float']['output'];
  /** Cost per lead since the last AB test */
  abTestCpl: Scalars['Float']['output'];
  /** Cost per order since the last AB test */
  abTestCpo: Scalars['Float']['output'];
  /** Click-through rate since the last AB test */
  abTestCtr: Scalars['Float']['output'];
  abTestImpressions: Scalars['Int']['output'];
  abTestLeads: Scalars['Int']['output'];
  /** Lead rate since the last AB test */
  abTestLr: Scalars['Float']['output'];
  /** Order rate since the last AB test */
  abTestOr: Scalars['Float']['output'];
  abTestOrderValue: Scalars['Float']['output'];
  abTestOrders: Scalars['Int']['output'];
  /** ROI */
  abTestRoi: Scalars['Float']['output'];
  abTestStartDate: Scalars['DateTime']['output'];
  adCopyId: Scalars['PwsID']['output'];
  clicks: Scalars['Int']['output'];
  costs: Scalars['Float']['output'];
  /** Cost per lead since the activation of the adcopy */
  cpl: Scalars['Float']['output'];
  /** Cost per order since the activation of the adcopy */
  cpo: Scalars['Float']['output'];
  /** Click-through rate since the activation of the adcopy */
  ctr: Scalars['Float']['output'];
  impressions: Scalars['Int']['output'];
  leads: Scalars['Int']['output'];
  /** Lead rate since the activation of the adcopy */
  lr: Scalars['Float']['output'];
  /** Order rate since the activation of the adcopy */
  or: Scalars['Float']['output'];
  orderValue: Scalars['Float']['output'];
  orders: Scalars['Int']['output'];
  /** ROI since the activation of the adcopy */
  roi: Scalars['Float']['output'];
  startedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Ad copy lifecycle status: active (serving), processing (image validation), inactive (paused), pending (user-info draft), pending_validation (awaiting team approval), rejected (failed validation), archived (deprecated), error (validation failed) */
export enum AdCopyStatus {
  Active = 'Active',
  Archived = 'Archived',
  Error = 'Error',
  Inactive = 'Inactive',
  Pending = 'Pending',
  PendingValidation = 'PendingValidation',
  Processing = 'Processing',
  Rejected = 'Rejected'
}

export type AdCopyTags = {
  adCopyId: Scalars['PwsID']['output'];
  keyword: Scalars['String']['output'];
};

export type AdCopyWithPerformance = {
  adCopyTags: Array<AdCopyTags>;
  /** Parent ad group this ad copy belongs to */
  adGroup: AdGroup;
  advertiserName: Scalars['LimitedString7']['output'];
  /** Sum of imported analytics statistics (sessions, revenue, etc.) between two dates (inclusive). Access follows the ad copy (parent) query permissions. */
  analyticsStats: AdCopyAnalyticsStatSum;
  callToAction: Scalars['LimitedString6']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['LimitedString5']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** The redirect URL will override the one defined at AdGroup level */
  forceRedirectUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['PwsID']['output'];
  image: Scalars['String']['output'];
  imageCheck?: Maybe<AdCopyImageCheck>;
  /** @deprecated Use imageCheck.hasText instead. */
  imageContainsText?: Maybe<Scalars['Boolean']['output']>;
  /** List of third-party impression tracking pixel URLs */
  impressionPixels: Array<Scalars['String']['output']>;
  lastValidatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Latest aggregated AB test and lifetime statistics for this ad copy, when present in stats storage */
  lifetimeStats?: Maybe<AdCopyStats>;
  name: Scalars['String']['output'];
  /** Performance stats for this ad copy */
  performanceStats: AdCopyPerformanceStats;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stats: AdvertiserCostDetails;
  /** Lifecycle status: pending is a user-info draft; pending_validation awaits team approval before activation */
  status: AdCopyStatus;
  statusUpdatedAt: Scalars['DateTime']['output'];
  /** Time-series performance metrics for this ad copy over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  title: Scalars['LimitedString4']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who validated/approved this ad copy */
  validator?: Maybe<User>;
  visualUpdatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};


export type AdCopyWithPerformanceAnalyticsStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type AdCopyWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type AdCopyWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};

export enum AdFormat {
  Banner = 'Banner',
  Native = 'Native',
  Web = 'Web'
}

/** Ad group containing ad copies with targeting, budget, and bidding settings within a campaign */
export type AdGroup = {
  /** Ad copies belonging to this ad group with optional status filtering */
  adCopies: Array<AdCopy>;
  /** Assistant recommendations and ad copy decisions for this ad group */
  assistant: AdGroupAssistantResult;
  authorizedCountries: Array<Country>;
  /** Websites where this ad group is blacklisted via reseller, publisher, or website exclusions (including publisher exclusion presets), with traffic percentage */
  blacklistedOn: AdGroupBlacklistedWebsites;
  /** Current budget consumption and pacing information */
  budget?: Maybe<BudgetTimed>;
  /** Amount of money we can spend on the BudgetCappingType basis */
  budgetCapping?: Maybe<Scalars['Int']['output']>;
  budgetCappingType: BudgetCapping;
  /** List of budget planned for this adgroup */
  budgetPlans: Array<AdGroupBudgetPlan>;
  campaign: Campaign;
  channelEmail: Scalars['Boolean']['output'];
  channelWeb: Scalars['Boolean']['output'];
  /** Third-party click tracking pixel URLs (SuperAdmin: read; others: always empty). Only SuperAdmin can set via create/update. */
  clickPixels: Array<Scalars['String']['output']>;
  contentStrategy: ContentStrategy;
  costType: CostType;
  costValue: Scalars['Float']['output'];
  countryBlacklistRedirectUrl?: Maybe<Scalars['String']['output']>;
  dailyBudget?: Maybe<Scalars['Int']['output']>;
  dailyBudgetType: DailyBudgetType;
  dealId?: Maybe<Scalars['String']['output']>;
  /** Bid adjustments for different device types (mobile, desktop, tablet) */
  deviceAdjustments: Array<AdGroupDeviceAdjustment>;
  /** Directory of targeted or excluded websites and ad positions */
  directory: AdGroupDirectory;
  /** Ad group directory together with every selected directory preset and its own directory-shaped inventory. Impression volumes are computed once for the whole payload. */
  directoryWithPreset: AdGroupDirectoryWithPresets;
  dspId?: Maybe<Scalars['Int']['output']>;
  /** Automatic planning of end of delivery */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  format: AdFormat;
  id: Scalars['PwsID']['output'];
  /** List of third-party impression tracking pixel URLs for this ad group */
  impressionPixels: Array<Scalars['String']['output']>;
  /** List of generated keywords from the redirect url */
  keywords: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  network: Network;
  /** Nested performance stats for this ad group and its ad copies */
  performanceStats: AdGroupPerformanceStats;
  /** Priority ID for this ad group (determines serving priority in auctions) */
  priorityId?: Maybe<Scalars['PwsID']['output']>;
  redirectUrl: Scalars['String']['output'];
  /** Automatic planning of start of delivery */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: AdGroupStatus;
  /** Audience targeting settings (age, gender, device, browser, etc.) */
  targeting?: Maybe<AdGroupTargeting>;
  /** Time-series performance metrics for this ad group over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  /** Last modification date based on activity feed */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Duration of the timeframe in which we count the nb of event */
  userCappingTimeframe?: Maybe<Scalars['String']['output']>;
  /** Type of event the capping is based on */
  userCappingType?: Maybe<UserCapping>;
  /** Max number of events in the timeframe until we hide the ad from the user */
  userCappingValue?: Maybe<Scalars['Int']['output']>;
  /** Bid adjustments for specific websites/publishers in this ad group */
  websiteAdjustments: Array<WebsiteAdjustment>;
  /** Ad group settings (SuperAdmin only) */
  settings: AdGroupSettings;
};


/** Ad group containing ad copies with targeting, budget, and bidding settings within a campaign */
export type AdGroupAdCopiesArgs = {
  pagination?: InputMaybe<Pagination>;
  status?: InputMaybe<Array<AdCopyStatus>>;
};


/** Ad group containing ad copies with targeting, budget, and bidding settings within a campaign */
export type AdGroupPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Ad group containing ad copies with targeting, budget, and bidding settings within a campaign */
export type AdGroupTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};

/** Advertiser performance metrics for one ad group within an IAB ad-product category */
export type AdGroupAdProductStats = {
  /** Ad group in this category for the period */
  adGroup: AdGroup;
  /** Metrics for this ad group broken down by ad group IAB category */
  iabCategories: Array<AdGroupAdProductTierBreakdown>;
  /** Metrics for this ad group in the period */
  stats: AdvertiserCostDetails;
  /** Metrics for this ad group broken down by publisher website */
  websites: Array<AdGroupAdProductTierWebsiteBreakdown>;
};

/** Ad groups and advertiser performance metrics grouped by IAB ad-product category name at a given tier. Ad groups with no lookup value are grouped under Unclassified. */
export type AdGroupAdProductTier = {
  /** Ad groups in this category with per-ad-group metrics for the period */
  adGroups: Array<AdGroupAdProductStats>;
  /** Metrics per user age range, each including stats for all genders */
  ageRanges: Array<AdGroupAdProductTierAgeRangeBreakdown>;
  /** IAB ad-product category name at the requested tier, or Unclassified when the ad group has no lookup value */
  category: Scalars['String']['output'];
  /** Metrics broken down by ad group IAB category (flatrecords adgroup_iab_category) */
  iabCategories: Array<AdGroupAdProductTierBreakdown>;
  /** Aggregated advertiser metrics for ad groups in this category */
  stats: AdvertiserCostDetails;
  /** Metrics broken down by publisher website (IAB category on the website entity) */
  websites: Array<AdGroupAdProductTierWebsiteBreakdown>;
};

/** Advertiser metrics for one user age range, with a per-gender breakdown */
export type AdGroupAdProductTierAgeRangeBreakdown = {
  /** Metrics broken down by gender within this age range */
  genders: Array<AdGroupAdProductTierBreakdown>;
  /** User age range on delivery, or Unknown when not set */
  name: Scalars['String']['output'];
  /** Aggregated metrics for this age range across all genders */
  stats: AdvertiserCostDetails;
};

/** Advertiser performance metrics for one dimension value within an ad-product category */
export type AdGroupAdProductTierBreakdown = {
  /** Dimension value, or Unknown when not set on the delivery row */
  name: Scalars['String']['output'];
  stats: AdvertiserCostDetails;
};

/** IAB ad-product categories and metrics for one tier depth */
export type AdGroupAdProductTierLevel = {
  /** Categories at this tier with aggregated and per-ad-group stats */
  categories: Array<AdGroupAdProductTier>;
  /** Category depth: tier 1, 2, or 3 */
  tier: AdProductTier;
};

/** Advertiser performance metrics for delivery on one publisher website within an ad-product category */
export type AdGroupAdProductTierWebsiteBreakdown = {
  stats: AdvertiserCostDetails;
  /** Publisher website where ads were delivered */
  website: Website;
};

export type AdGroupAssistantRecommendation = {
  /** Whether this rule is hidden for display purposes (rule still executes) */
  isHidden: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  recommendedChanges?: Maybe<Scalars['JSON']['output']>;
  /** Rule that generated this recommendation */
  rule?: Maybe<AssistantRuleOutput>;
  /** ID of the rule that generated this recommendation */
  ruleId: Scalars['PwsID']['output'];
};

export type AdGroupAssistantResult = {
  adCopies: Array<AdCopyAssistantItem>;
  recommendations: Array<AdGroupAssistantRecommendation>;
};

export type AdGroupAutoSegment = {
  dimension: AutoSegmentFor;
  id: Scalars['String']['output'];
  isExcluded: Scalars['Boolean']['output'];
  type: AutoSegmentType;
};

export type AdGroupAutoSegmentInput = {
  dimension?: AutoSegmentFor;
  id?: Scalars['String']['input'];
  isExcluded?: Scalars['Boolean']['input'];
  type: AutoSegmentType;
};

export type AdGroupBlacklistedWebsite = {
  /** Reasons why this website blacklisted the ad group */
  reasons: Array<BlacklistReason>;
  /** Traffic percentage based on whole adgroup traffic */
  traffic: Scalars['Percentage']['output'];
  website: Website;
};

export type AdGroupBlacklistedWebsites = {
  /** Maximum traffic percentage of all blacklisted websites based on directory traffic */
  maximumTraffic: Scalars['Percentage']['output'];
  /** List of blacklisted websites */
  websites: Array<AdGroupBlacklistedWebsite>;
};

/** Budget and performance metrics for a specific ad group on a given date */
export type AdGroupBudget = {
  accountId?: Maybe<Scalars['PwsID']['output']>;
  adGroupId: Scalars['PwsID']['output'];
  adGroupName: Scalars['String']['output'];
  advertiserId: Scalars['PwsID']['output'];
  advertiserName: Scalars['String']['output'];
  advertiserSlug: Scalars['String']['output'];
  campaignId: Scalars['PwsID']['output'];
  campaignName: Scalars['String']['output'];
  clicks: Scalars['BigInt']['output'];
  dailyBudget?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  impressions: Scalars['BigInt']['output'];
  revenue: Scalars['Float']['output'];
  salesId?: Maybe<Scalars['PwsID']['output']>;
};

/** Nature of a budget history entry: initial (values the period opened with), create (ad group creation) or update (later modification) */
export enum AdGroupBudgetChangeType {
  Create = 'Create',
  Initial = 'Initial',
  Update = 'Update'
}

/** Ad group budget and cost values left in effect by the last change of an hour during which at least one of them changed. Unchanged values are repeated so every entry holds the complete state. */
export type AdGroupBudgetHistory = {
  /** Exact moment of the change, or the start of the first day of the period for an initial entry */
  at: Scalars['DateTime']['output'];
  budgetCapping?: Maybe<Scalars['Int']['output']>;
  budgetCappingType?: Maybe<BudgetCapping>;
  /** Nature of the last change of the hour */
  changeType: AdGroupBudgetChangeType;
  costType?: Maybe<CostType>;
  costValue?: Maybe<Scalars['Float']['output']>;
  dailyBudget?: Maybe<Scalars['Int']['output']>;
  dailyBudgetType?: Maybe<DailyBudgetType>;
  /** Author of the last change of the hour; null when it was made by a system process */
  user?: Maybe<PartialUser>;
};

/** Scheduled budget overlay for an ad group, applied by the daily budget-plan cron once the campaign market local date is on or after plannedDate */
export type AdGroupBudgetPlan = {
  adGroupId: Scalars['PwsID']['output'];
  /** Amount of money we can spend on the BudgetCappingType basis */
  budgetCapping?: Maybe<Scalars['Int']['output']>;
  budgetCappingType?: Maybe<BudgetCapping>;
  changeBudgetCapping: Scalars['Boolean']['output'];
  changeCost: Scalars['Boolean']['output'];
  changeDailyBudget: Scalars['Boolean']['output'];
  changeDates: Scalars['Boolean']['output'];
  costType?: Maybe<CostType>;
  costValue?: Maybe<Scalars['Float']['output']>;
  dailyBudget?: Maybe<Scalars['Int']['output']>;
  dailyBudgetType?: Maybe<DailyBudgetType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['PwsID']['output'];
  plannedDate: Scalars['DateTime']['output'];
  processed: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AdGroupBudgetPlanCreateInput = {
  adGroupId: Scalars['PwsID']['input'];
  budgetCapping?: InputMaybe<Scalars['Int']['input']>;
  budgetCappingType?: InputMaybe<BudgetCapping>;
  changeBudgetCapping: Scalars['Boolean']['input'];
  changeCost: Scalars['Boolean']['input'];
  changeDailyBudget: Scalars['Boolean']['input'];
  changeDates: Scalars['Boolean']['input'];
  costType?: InputMaybe<CostType>;
  costValue?: InputMaybe<Scalars['Float']['input']>;
  dailyBudget?: InputMaybe<Scalars['Int']['input']>;
  dailyBudgetType?: InputMaybe<DailyBudgetType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  plannedDate: Scalars['DateTime']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdGroupBudgetPlanUpdateInput = {
  budgetCapping?: InputMaybe<Scalars['Int']['input']>;
  budgetCappingType?: InputMaybe<BudgetCapping>;
  changeBudgetCapping: Scalars['Boolean']['input'];
  changeCost: Scalars['Boolean']['input'];
  changeDailyBudget: Scalars['Boolean']['input'];
  changeDates: Scalars['Boolean']['input'];
  costType?: InputMaybe<CostType>;
  costValue?: InputMaybe<Scalars['Float']['input']>;
  dailyBudget?: InputMaybe<Scalars['Int']['input']>;
  dailyBudgetType?: InputMaybe<DailyBudgetType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['PwsID']['input'];
  plannedDate: Scalars['DateTime']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Classification used to group ad groups into tiers: IAB ad-product lookups (IAB_CONTENT) or the ad group IAB category split into main category and sub category (IAB_CATEGORY) */
export enum AdGroupClassificationSource {
  IabCategory = 'IAB_CATEGORY',
  IabContent = 'IAB_CONTENT'
}

export type AdGroupConfig = {
  budgetCapping: Scalars['Int']['output'];
  cpc: Scalars['Float']['output'];
  cpl: Scalars['Float']['output'];
  cpm: Scalars['Float']['output'];
  cpo: Scalars['Float']['output'];
  dailyBudget: Scalars['Int']['output'];
};

export type AdGroupCreateInput = {
  /** Maximum budget limit amount (interpreted based on budgetCappingType) */
  budgetCapping?: InputMaybe<Scalars['Int']['input']>;
  /** Scope for budget capping: monthly (resets each month), overall (lifetime limit), or open (unlimited) */
  budgetCappingType?: BudgetCapping;
  campaignId: Scalars['PwsID']['input'];
  channelEmail?: Scalars['Boolean']['input'];
  channelWeb?: Scalars['Boolean']['input'];
  /** Click tracking pixel URLs. Only SuperAdmin users can persist these on create; value is ignored for others. */
  clickPixels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content type preference: promotional (marketing/sales) or editorial (informational content) */
  contentStrategy?: ContentStrategy;
  costType: CostType;
  costValue: Scalars['Float']['input'];
  /** Daily spending limit (only used when dailyBudgetType is fixed) */
  dailyBudget?: InputMaybe<Scalars['Int']['input']>;
  /** Daily budget pacing strategy: open (no daily limit), fixed (spend exactly), auto (optimized pacing) */
  dailyBudgetType?: DailyBudgetType;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  format?: AdFormat;
  /** Impression tracking pixel URLs to store on the new ad group */
  impressionPixels?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  network?: Network;
  priorityId?: InputMaybe<Scalars['PwsID']['input']>;
  redirectUrl: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Bid adjustment for specific device types to optimize performance across desktop, mobile, and tablet */
export type AdGroupDeviceAdjustment = {
  deviceType: DeviceType;
  realAdjustment: Scalars['Percentage']['output'];
  /** Desired bid adjustment percentage (may differ from real if system constraints apply) */
  wantedAdjustment: Scalars['Percentage']['output'];
};

export type AdGroupDeviceAdjustmentInput = {
  deviceType: DeviceType;
  realAdjustment: Scalars['Percentage']['input'];
  /** Desired bid adjustment percentage (may differ from real if system constraints apply) */
  wantedAdjustment: Scalars['Percentage']['input'];
};

export type AdGroupDirectory = {
  /** Whether the directory contains targeted (included) or excluded websites and positions */
  type: DirectoryType;
  websites: Array<WebsiteDirectory>;
};

export type AdGroupDirectoryInput = {
  /** Whether the directory contains targeted (included) or excluded websites and positions */
  type: DirectoryType;
  websites: Array<WebsiteDirectoryInput>;
};

/** Reusable set of websites and ad positions that ad groups can select for their directory */
export type AdGroupDirectoryPreset = {
  /** Company owning this directory preset */
  company: DirectoryCompany;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  websites: Array<WebsiteDirectory>;
};

export type AdGroupDirectoryPresetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PwsID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Preset inventory as website directories. Omit to leave websites and positions untouched, pass an empty list to clear them. */
  websites?: InputMaybe<Array<WebsiteDirectoryInput>>;
};

/** Ad group directory and the inventory of every selected preset, resolved together */
export type AdGroupDirectoryWithPresets = {
  directory: AdGroupDirectory;
  presets: Array<AdGroupSelectedDirectoryPreset>;
};

export type AdGroupIabStatsAnalysis = {
  adGroupId: Scalars['PwsID']['output'];
  campaignId: Scalars['PwsID']['output'];
  clicks: Scalars['BigInt']['output'];
  conversions: Scalars['BigInt']['output'];
  iabCategory: Scalars['String']['output'];
  impressions: Scalars['BigInt']['output'];
  revenues: Scalars['Float']['output'];
};

/** Distribution of ad groups and performance metrics across IAB categories */
export type AdGroupIabRepartion = {
  adGroupCount: Scalars['BigInt']['output'];
  clicks: Scalars['BigInt']['output'];
  conversions: Scalars['BigInt']['output'];
  iab: Iab;
  impressions: Scalars['BigInt']['output'];
};

export type AdGroupInput = {
  /** Countries where ads are authorized to be displayed */
  authorizedCountries: Array<CountryInput>;
  /** Amount of money we can spend on the BudgetCappingType basis */
  budgetCapping?: InputMaybe<Scalars['Int']['input']>;
  budgetCappingType: BudgetCapping;
  channelEmail: Scalars['Boolean']['input'];
  channelWeb: Scalars['Boolean']['input'];
  /** Click tracking pixel URLs. Only SuperAdmin users can change stored values; others may send this field but it is ignored. */
  clickPixels: Array<Scalars['String']['input']>;
  contentStrategy: ContentStrategy;
  costType: CostType;
  costValue: Scalars['Float']['input'];
  countryBlacklistRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  dailyBudget?: InputMaybe<Scalars['Int']['input']>;
  dailyBudgetType: DailyBudgetType;
  dealId?: InputMaybe<Scalars['String']['input']>;
  dspId?: InputMaybe<Scalars['Int']['input']>;
  /** Automatic planning of end of delivery */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  format: AdFormat;
  id: Scalars['PwsID']['input'];
  /** List of impression tracking pixel URLs to fire when ads are displayed */
  impressionPixels: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  network: Network;
  /** Priority level for auction ranking */
  priorityId?: InputMaybe<Scalars['PwsID']['input']>;
  redirectUrl: Scalars['String']['input'];
  /** Automatic planning of start of delivery */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: AdGroupStatus;
  /** Duration of the timeframe in which we count the nb of event */
  userCappingTimeframe?: InputMaybe<Scalars['String']['input']>;
  /** Type of event the capping is based on */
  userCappingType?: InputMaybe<UserCapping>;
  /** Max number of events in the timeframe until we hide the ad from the user */
  userCappingValue?: InputMaybe<Scalars['Int']['input']>;
};

export type AdGroupLlmSuggestion = {
  actions: Array<Scalars['String']['output']>;
  description: Array<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  titles: Array<Scalars['String']['output']>;
};

export type AdGroupMinMaxConfig = {
  max: AdGroupConfig;
  min: AdGroupConfig;
};

export type AdGroupPerformanceStats = {
  adCopies: Array<AdCopyWithPerformance>;
  devices: Array<AdvertiserDeviceCost>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

export type AdGroupProfileTag = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isExcluded: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  profileCount?: Maybe<Scalars['Int']['output']>;
};

export type AdGroupProfileTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isExcluded: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  origin: Scalars['String']['input'];
  profileCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Search criteria for filtering ad groups */
export type AdGroupSearchQuery = {
  /** Filter ad groups by company ID */
  companyId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter ad groups by IDs */
  ids?: InputMaybe<Array<Scalars['PwsID']['input']>>;
  /** Filter ad groups by market ID */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Filter ad groups by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter ad groups by network type */
  network?: InputMaybe<Network>;
  /** Filter ad groups by reseller ID */
  resellerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter ad groups by status */
  status?: InputMaybe<Array<AdGroupStatus>>;
};

/** Ad group audience segment inclusion or exclusion for targeting specific user segments */
export type AdGroupSegment = {
  /** If true, users in this segment are excluded; if false, they are targeted */
  isExcluded: Scalars['Boolean']['output'];
  /** The segment (CRM or behavioral) associated with this ad group targeting rule */
  segment: Segment;
};

/** Directory preset selected by an ad group, with its inventory resolved for that ad group */
export type AdGroupSelectedDirectoryPreset = {
  /** Company owning this directory preset */
  company: DirectoryCompany;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Preset inventory, with impression volumes computed against the ad group traffic */
  websites: Array<WebsiteDirectory>;
};

/** Ad group serving status: active (delivering), no_budget_left (exhausted budget), start_soon (scheduled), ended (past end date), inactive (paused), archived (deprecated) */
export enum AdGroupStatus {
  Active = 'Active',
  Archived = 'Archived',
  Ended = 'Ended',
  Inactive = 'Inactive',
  NoBudgetLeft = 'NoBudgetLeft',
  StartSoon = 'StartSoon'
}

export type AdGroupTargeting = {
  age: AgeTargeting;
  /** Automated segments based on advertiser/campaign/publisher targeting (SuperAdmin only) */
  autoSegments: Array<AdGroupAutoSegment>;
  device: DeviceTargeting;
  gender: Array<Gender>;
  geoTargeting: GeoTargeting;
  os: OsTargeting;
  /** Estimated reach percentage and CPC for current targeting settings */
  reach: AdGroupTargetingReach;
  segments: Array<AdGroupSegment>;
  /** Profile tags for granular user targeting (SuperAdmin only) */
  tags: Array<AdGroupProfileTag>;
  /** Count of active targeting criteria applied to this ad group */
  targetingCount: Scalars['PwsID']['output'];
  time: TimeTargeting;
};

export type AdGroupTargetingInput = {
  /** Age range targeting with option to include unknown ages */
  age: AgeTargetingInput;
  /** Automatically generated behavioral segments based on user activity */
  autoSegments: Array<AdGroupAutoSegmentInput>;
  /** Device type targeting (desktop, tablet, mobile) with exclusive mode option */
  device: DeviceTargetingInput;
  gender: Array<Gender>;
  /** Geographic targeting configuration (countries, regions, or custom geographic areas) */
  geoTargeting: GeoTargetingInput;
  /** Operating system targeting (macOS, Windows, iOS, Android) with exclusive mode option */
  os: OsTargetingInput;
  /** Custom audience segments to include or exclude from targeting */
  segments: Array<AdGroupTargetingSegmentsInput>;
  /** Profile tags for advanced audience segmentation */
  tags: Array<AdGroupProfileTagInput>;
  /** Dayparting configuration specifying days of week and hours of day for ad delivery */
  time: TimeTargetingInput;
};

/** Estimated reach and cost metrics for targeting settings */
export type AdGroupTargetingReach = {
  /** Estimated cost per click. Requires cost history access. */
  cpc: Scalars['PwsID']['output'];
  /** Percentage of available impressions matching the targeting criteria */
  impressions: Scalars['PwsID']['output'];
};

export type AdGroupTargetingSegmentsInput = {
  /** Whether this segment is excluded (true) or included (false) in targeting */
  isExcluded: Scalars['Boolean']['input'];
  segmentId: Scalars['PwsID']['input'];
};

export type AdGroupWithPerformance = {
  adCopies: Array<AdCopyWithPerformance>;
  /** Assistant recommendations and ad copy decisions for this ad group */
  assistant: AdGroupAssistantResult;
  authorizedCountries: Array<Country>;
  /** Websites where this ad group is blacklisted via reseller, publisher, or website exclusions (including publisher exclusion presets), with traffic percentage */
  blacklistedOn: AdGroupBlacklistedWebsites;
  /** Current budget consumption and pacing information */
  budget?: Maybe<BudgetTimed>;
  /** Amount of money we can spend on the BudgetCappingType basis */
  budgetCapping?: Maybe<Scalars['Int']['output']>;
  budgetCappingType: BudgetCapping;
  /** List of budget planned for this adgroup */
  budgetPlans: Array<AdGroupBudgetPlan>;
  campaign: Campaign;
  channelEmail: Scalars['Boolean']['output'];
  channelWeb: Scalars['Boolean']['output'];
  /** Third-party click tracking pixel URLs (SuperAdmin: read; others: always empty). Only SuperAdmin can set via create/update. */
  clickPixels: Array<Scalars['String']['output']>;
  contentStrategy: ContentStrategy;
  costType: CostType;
  costValue: Scalars['Float']['output'];
  countryBlacklistRedirectUrl?: Maybe<Scalars['String']['output']>;
  dailyBudget?: Maybe<Scalars['Int']['output']>;
  dailyBudgetType: DailyBudgetType;
  dealId?: Maybe<Scalars['String']['output']>;
  /** Bid adjustments for different device types (mobile, desktop, tablet) */
  deviceAdjustments: Array<AdGroupDeviceAdjustment>;
  /** Directory of targeted or excluded websites and ad positions */
  directory: AdGroupDirectory;
  /** Ad group directory together with every selected directory preset and its own directory-shaped inventory. Impression volumes are computed once for the whole payload. */
  directoryWithPreset: AdGroupDirectoryWithPresets;
  dspId?: Maybe<Scalars['Int']['output']>;
  /** Automatic planning of end of delivery */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  format: AdFormat;
  id: Scalars['PwsID']['output'];
  /** List of third-party impression tracking pixel URLs for this ad group */
  impressionPixels: Array<Scalars['String']['output']>;
  /** List of generated keywords from the redirect url */
  keywords: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  network: Network;
  /** Nested performance stats for this ad group and its ad copies */
  performanceStats: AdGroupPerformanceStats;
  /** Priority ID for this ad group (determines serving priority in auctions) */
  priorityId?: Maybe<Scalars['PwsID']['output']>;
  redirectUrl: Scalars['String']['output'];
  /** Automatic planning of start of delivery */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stats: AdvertiserCostDetails;
  status: AdGroupStatus;
  /** Audience targeting settings (age, gender, device, browser, etc.) */
  targeting?: Maybe<AdGroupTargeting>;
  /** Time-series performance metrics for this ad group over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  /** Last modification date based on activity feed */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Duration of the timeframe in which we count the nb of event */
  userCappingTimeframe?: Maybe<Scalars['String']['output']>;
  /** Type of event the capping is based on */
  userCappingType?: Maybe<UserCapping>;
  /** Max number of events in the timeframe until we hide the ad from the user */
  userCappingValue?: Maybe<Scalars['Int']['output']>;
  /** Bid adjustments for specific websites/publishers in this ad group */
  websiteAdjustments: Array<WebsiteAdjustment>;
};


export type AdGroupWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type AdGroupWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};

/** Ad priority level for auction ranking, determining ad group competitiveness in bidding */
export type AdPriority = {
  id: Scalars['PwsID']['output'];
  /** If true, this is the default priority for all adgroups without a priority set */
  isDefault: Scalars['Boolean']['output'];
  /** Whether this priority can be deleted (not default, unused, and not system default) */
  isDeletable: Scalars['Boolean']['output'];
  isPowerspaceDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Numeric priority value for auction ranking (higher = better position) */
  value: Scalars['Int']['output'];
};

export type AdPriorityInput = {
  id: Scalars['PwsID']['input'];
  /** If true, this is the default priority for all adgroups without a priority set */
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  /** Numeric priority value for auction ranking (higher = better position) */
  value: Scalars['Int']['input'];
};

/** IAB ad-product category depth resolved from Druid lookups on ad groups */
export enum AdProductTier {
  Tier_1 = 'TIER_1',
  Tier_2 = 'TIER_2',
  Tier_3 = 'TIER_3'
}

/** Union type representing different ad template formats: banner (static image), native (customizable layout), or web (HTML/CSS/JS) */
export type AdTemplate = AdTemplateBanner | AdTemplateNative | AdTemplateWeb;

/** Banner ad template with fixed width and height, displays ad copy image directly without text overlay */
export type AdTemplateBanner = {
  format: AdFormat;
  height: Scalars['Int']['output'];
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Banner template performance stats. */
  performanceStats: AdTemplateBannerPerformanceStats;
  position: Position;
  status: Status;
  /** Time-series performance metrics for this banner template over a date range */
  timeseries: PublisherTimeseriesTotal;
  width: Scalars['Int']['output'];
};


/** Banner ad template with fixed width and height, displays ad copy image directly without text overlay */
export type AdTemplateBannerPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Banner ad template with fixed width and height, displays ad copy image directly without text overlay */
export type AdTemplateBannerTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type AdTemplateBannerCreateInput = {
  height: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  positionId: Scalars['PwsID']['input'];
  status: Status;
  width: Scalars['Int']['input'];
};

export type AdTemplateBannerInput = {
  format: AdFormat;
  height: Scalars['Int']['input'];
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  status: Status;
  width: Scalars['Int']['input'];
};

export type AdTemplateBannerPerformanceStats = {
  advertiserResellers: Array<PublisherResellerCost>;
  devices: Array<PublisherDeviceCost>;
  stats: PublisherCostDetails;
  zones: Array<PublisherZoneCost>;
};

export type AdTemplateBannerWithPerformance = {
  format: AdFormat;
  height: Scalars['Int']['output'];
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Banner template performance stats. */
  performanceStats: AdTemplateBannerPerformanceStats;
  position: Position;
  stats: PublisherCostDetails;
  status: Status;
  /** Time-series performance metrics for this banner template over a date range */
  timeseries: PublisherTimeseriesTotal;
  width: Scalars['Int']['output'];
  zones: Array<PublisherZoneCost>;
};


export type AdTemplateBannerWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type AdTemplateBannerWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type AdTemplateConfig = {
  imageHeight: Scalars['Int']['output'];
  imageWidth: Scalars['Int']['output'];
};

export type AdTemplateImageSize = {
  /** @deprecated Will be removed */
  adTemplateId: Scalars['PwsID']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
  zone: Scalars['Int']['output'];
};

export type AdTemplateMinMaxConfig = {
  max: AdTemplateConfig;
  min: AdTemplateConfig;
};

/** Native ad template with customizable elements (image, title, description, CTA) rendered in position zones */
export type AdTemplateNative = {
  format: AdFormat;
  height: Scalars['Int']['output'];
  id: Scalars['PwsID']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** Mobile version of a regular template */
  mobileTemplate?: Maybe<ImageTemplateDescriptor>;
  name: Scalars['String']['output'];
  /** Native template performance stats. */
  performanceStats: AdTemplateNativePerformanceStats;
  position: Position;
  status: Status;
  template: ImageTemplateDescriptor;
  timeseries: PublisherTimeseriesTotal;
  width: Scalars['Int']['output'];
};


/** Native ad template with customizable elements (image, title, description, CTA) rendered in position zones */
export type AdTemplateNativePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Native ad template with customizable elements (image, title, description, CTA) rendered in position zones */
export type AdTemplateNativeTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type AdTemplateNativeCreateInput = {
  /** Optional mobile-specific template descriptor with different layout and dimensions */
  mobileTemplate?: InputMaybe<ImageTemplateDescriptorInput>;
  name: Scalars['String']['input'];
  positionId: Scalars['PwsID']['input'];
  status: Status;
  /** Template descriptor with layout configuration, element positioning, styling, and content structure */
  template: ImageTemplateDescriptorInput;
};

export type AdTemplateNativeInput = {
  format?: AdFormat;
  id: Scalars['PwsID']['input'];
  /** Optional mobile-specific template descriptor with different layout and dimensions */
  mobileTemplate?: InputMaybe<ImageTemplateDescriptorInput>;
  name: Scalars['String']['input'];
  status: Status;
  /** Template descriptor with layout configuration, element positioning, styling, and content structure */
  template: ImageTemplateDescriptorInput;
};

export type AdTemplateNativePerformanceStats = {
  advertiserResellers: Array<PublisherResellerCost>;
  devices: Array<PublisherDeviceCost>;
  stats: PublisherCostDetails;
  zones: Array<PublisherZoneCost>;
};

export type AdTemplateNativeWithPerformance = {
  format: AdFormat;
  height: Scalars['Int']['output'];
  id: Scalars['PwsID']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** Mobile version of a regular template */
  mobileTemplate?: Maybe<ImageTemplateDescriptor>;
  name: Scalars['String']['output'];
  /** Native template performance stats. */
  performanceStats: AdTemplateNativePerformanceStats;
  position: Position;
  stats: PublisherCostDetails;
  status: Status;
  template: ImageTemplateDescriptor;
  timeseries: PublisherTimeseriesTotal;
  width: Scalars['Int']['output'];
  zones: Array<PublisherZoneCost>;
};


export type AdTemplateNativeWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type AdTemplateNativeWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

/** Search criteria for filtering ad templates */
export type AdTemplateSearchQuery = {
  /** Filter templates by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter templates by status */
  status?: InputMaybe<Array<Status>>;
};

/** Web ad template for on-site display with custom HTML, CSS, and JavaScript for dynamic rendering */
export type AdTemplateWeb = {
  css?: Maybe<Scalars['String']['output']>;
  cssSelector?: Maybe<Scalars['String']['output']>;
  cssSelectorPosition: CssSelectorPosition;
  /** Ad format type, always Web for web templates */
  format: AdFormat;
  id: Scalars['PwsID']['output'];
  js?: Maybe<Scalars['String']['output']>;
  masterTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Web template performance stats. */
  performanceStats: AdTemplateWebPerformanceStats;
  position: Position;
  status: Status;
  /** Time-series performance metrics for this web template over a date range */
  timeseries: PublisherTimeseriesTotal;
  zoneTemplate?: Maybe<Scalars['String']['output']>;
};


/** Web ad template for on-site display with custom HTML, CSS, and JavaScript for dynamic rendering */
export type AdTemplateWebPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Web ad template for on-site display with custom HTML, CSS, and JavaScript for dynamic rendering */
export type AdTemplateWebTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type AdTemplateWebCreateInput = {
  /** Custom CSS stylesheet for template styling */
  css?: InputMaybe<Scalars['String']['input']>;
  /** CSS selector targeting the DOM element where template will be injected */
  cssSelector?: InputMaybe<Scalars['String']['input']>;
  /** Position relative to CSS selector element for template injection */
  cssSelectorPosition: CssSelectorPosition;
  /** Custom JavaScript code for template behavior and interactions */
  js?: InputMaybe<Scalars['String']['input']>;
  /** Main HTML template with zone placeholders for ad insertion */
  masterTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  positionId: Scalars['PwsID']['input'];
  status: Status;
  /** Per-zone HTML template for rendering individual ads */
  zoneTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type AdTemplateWebInput = {
  css?: InputMaybe<Scalars['String']['input']>;
  cssSelector?: InputMaybe<Scalars['String']['input']>;
  cssSelectorPosition: CssSelectorPosition;
  id: Scalars['PwsID']['input'];
  js?: InputMaybe<Scalars['String']['input']>;
  masterTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Status;
  zoneTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type AdTemplateWebPerformanceStats = {
  advertiserResellers: Array<PublisherResellerCost>;
  devices: Array<PublisherDeviceCost>;
  stats: PublisherCostDetails;
  zones: Array<PublisherZoneCost>;
};

export type AdTemplateWebWithPerformance = {
  css?: Maybe<Scalars['String']['output']>;
  cssSelector?: Maybe<Scalars['String']['output']>;
  cssSelectorPosition: CssSelectorPosition;
  /** Ad format type, always Web for web templates */
  format: AdFormat;
  id: Scalars['PwsID']['output'];
  js?: Maybe<Scalars['String']['output']>;
  masterTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Web template performance stats. */
  performanceStats: AdTemplateWebPerformanceStats;
  position: Position;
  stats: PublisherCostDetails;
  status: Status;
  /** Time-series performance metrics for this web template over a date range */
  timeseries: PublisherTimeseriesTotal;
  zoneTemplate?: Maybe<Scalars['String']['output']>;
  zones: Array<PublisherZoneCost>;
};


export type AdTemplateWebWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type AdTemplateWebWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

/** Union type representing ad template formats with publisher performance stats */
export type AdTemplateWithPerformance = AdTemplateBannerWithPerformance | AdTemplateNativeWithPerformance | AdTemplateWebWithPerformance;

/** Result of adding a geographic address to targeting */
export type AddAdGroupTargetingAdressesResult = {
  /** Address that was attempted to add */
  address: Scalars['String']['output'];
  /** Reason why the address could not be added */
  invalidReason: Scalars['String']['output'];
};

/** Advertiser company that creates campaigns and buys ad inventory */
export type Advertiser = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Agency managing this advertiser (if applicable) */
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  analyticsImportParameters?: Maybe<Scalars['JSON']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  /** Auto-archive policy for inactive inventory (stored config, not resolved against parent) */
  archiverConfig: ArchiverConfig;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  /** Campaigns belonging to this advertiser with optional status filtering */
  campaigns: Array<Campaign>;
  city?: Maybe<Scalars['String']['output']>;
  /** Configuration settings for this advertiser (ad copy limits, formats, etc.) */
  config: AdvertiserConfig;
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Country where this company is registered */
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  /** Advertiser performance stats with full advertiser details and totals-only campaign/ad group/ad copy breakdowns. */
  performanceStats: AdvertiserPerformanceStats;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  /** Default priority for this advertiser's ad groups in auctions */
  priorityId?: Maybe<Scalars['PwsID']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Advertiser-specific settings (SuperAdmin only) */
  settings: AdvertiserSettings;
  slug: Scalars['String']['output'];
  status: Status;
  /** Branding and styling configuration for this company's reseller */
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** Time-series performance metrics for this advertiser over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  /** The type of the company */
  type: CompanyType;
  /** Current user permissions for this advertiser (read, edit, admin) */
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


/** Advertiser company that creates campaigns and buys ad inventory */
export type AdvertiserCampaignsArgs = {
  pagination?: InputMaybe<Pagination>;
  status?: InputMaybe<Array<Status>>;
};


/** Advertiser company that creates campaigns and buys ad inventory */
export type AdvertiserPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Advertiser company that creates campaigns and buys ad inventory */
export type AdvertiserTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type AdvertiserConfig = {
  adCopy: AdCopyMinMaxConfig;
  adGroup: AdGroupMinMaxConfig;
  global: GlobalConfig;
};

export type AdvertiserCostDetails = {
  bounceRate: Scalars['Float']['output'];
  clicks: Scalars['BigInt']['output'];
  costs: Scalars['Float']['output'];
  cpc: Scalars['Float']['output'];
  cpl: Scalars['Float']['output'];
  cpm: Scalars['Float']['output'];
  cpo: Scalars['Float']['output'];
  cpv: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  engagedSessions: Scalars['Int']['output'];
  engagementRate: Scalars['Float']['output'];
  impressions: Scalars['BigInt']['output'];
  leads: Scalars['BigInt']['output'];
  lr: Scalars['Float']['output'];
  newUsers: Scalars['Int']['output'];
  or: Scalars['Float']['output'];
  orders: Scalars['BigInt']['output'];
  pageViews: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  roi: Scalars['Float']['output'];
  sessionTimeSeconds: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type AdvertiserDeviceCost = {
  name: Scalars['String']['output'];
  stats: AdvertiserCostDetails;
};

export type AdvertiserExclusionItem = {
  advertiser: AdvertiserPublic;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Account management type: self (advertiser manages own campaigns) or managed (reseller/agency manages) */
export enum AdvertiserGestion {
  Managed = 'Managed',
  Self = 'Self'
}

export type AdvertiserPerformanceStats = {
  campaigns: Array<CampaignWithPerformance>;
  devices: Array<AdvertiserDeviceCost>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

export type AdvertiserPositionCost = {
  name: Scalars['String']['output'];
  stats: AdvertiserCostDetails;
};

export type AdvertiserPublic = {
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
};

export type AdvertiserPublisherCost = {
  name: Scalars['String']['output'];
  stats: AdvertiserCostDetails;
  websites: Array<AdvertiserWebsiteCost>;
};

export type AdvertiserResellerCost = {
  name: Scalars['String']['output'];
  publishers: Array<AdvertiserPublisherCost>;
  stats: AdvertiserCostDetails;
};

/** Ad group settings (SuperAdmin only) */
export type AdGroupSettings = {
  /** Commission rate between 0 and 1 (e.g. 0.125 for 12.5%). */
  commission?: Maybe<Scalars['Float']['output']>;
};

export type AdGroupSettingsInput = {
  /** Commission rate between 0 and 1 (e.g. 0.125 for 12.5%). */
  commission?: InputMaybe<Scalars['Float']['input']>;
};

/** Advertiser-specific settings (SuperAdmin only) */
export type AdvertiserSettings = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Associated agency company ID if advertiser is managed by an agency */
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** Linked Copper CRM company record id */
  copperId?: Maybe<Scalars['String']['output']>;
  /** Management type: self (advertiser manages own campaigns) or managed (reseller/agency manages) */
  gestion?: Maybe<AdvertiserGestion>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Business model: direct (brand advertiser), agency_performance, agency_media, or affiliation_platform */
  subType?: Maybe<AdvertiserType>;
  /** Unknown traffic rate percentage used for fraud detection and traffic quality assessment */
  unknownTrafficRate?: Maybe<Scalars['Int']['output']>;
};

export type AdvertiserSettingsInput = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Associated agency company ID if advertiser is managed by an agency */
  agencyId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Linked Copper CRM company record id */
  copperId?: InputMaybe<Scalars['String']['input']>;
  /** Management type: self (advertiser manages own campaigns) or managed (reseller/agency manages) */
  gestion?: InputMaybe<AdvertiserGestion>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Business model: direct (brand advertiser), agency_performance, agency_media, or affiliation_platform */
  subType?: InputMaybe<AdvertiserType>;
  /** Unknown traffic rate percentage used for fraud detection and traffic quality assessment */
  unknownTrafficRate?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvertiserTimeseriesCost = {
  date: Scalars['DateTime']['output'];
  stats: AdvertiserCostDetails;
};

export type AdvertiserTimeseriesTotal = {
  stats: AdvertiserCostDetails;
  timeseries: Array<AdvertiserTimeseriesCost>;
};

/** Advertiser business model: direct (brand advertiser), agency_performance (performance agency), agency_media (media agency), affiliation_platform (affiliate network) */
export enum AdvertiserType {
  AffiliationPlatform = 'AffiliationPlatform',
  AgencyMedia = 'AgencyMedia',
  AgencyPerformance = 'AgencyPerformance',
  Direct = 'Direct'
}

export type AdvertiserWebsiteCost = {
  name: Scalars['String']['output'];
  positions: Array<AdvertiserPositionCost>;
  stats: AdvertiserCostDetails;
};

export type AdvertiserWithPerformance = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  campaigns: Array<CampaignWithPerformance>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  slug: Scalars['String']['output'];
  stats: AdvertiserCostDetails;
  status: Status;
  /** Branding and styling configuration for this company's reseller */
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** The type of the company */
  type: CompanyType;
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AdvertisersPerformanceStats = {
  advertisers: Array<AdvertiserWithPerformance>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

/** Age range brackets for audience targeting (18-24, 25-34, 35-44, 45-54, 55-64, 65+) */
export enum AgeRange {
  EighteenToTwentyfourth = 'EighteenToTwentyfourth',
  FiftyfiveToSixtyfourth = 'FiftyfiveToSixtyfourth',
  FourtyfiveToFiftyfourth = 'FourtyfiveToFiftyfourth',
  SixtyfivePlus = 'SixtyfivePlus',
  ThirtyfiveToFourtyfourth = 'ThirtyfiveToFourtyfourth',
  TwentyfiveToThirtyfourth = 'TwentyfiveToThirtyfourth'
}

export type AgeTargeting = {
  range: Array<AgeRange>;
  unknown: Scalars['Boolean']['output'];
};

export type AgeTargetingInput = {
  range?: Array<AgeRange>;
  unknown?: Scalars['Boolean']['input'];
};

/** Agency company that manages multiple advertisers on behalf of clients */
export type Agency = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  /** Auto-archive policy for inactive inventory (stored config, not resolved against parent) */
  archiverConfig: ArchiverConfig;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Country where this company is registered */
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  /** Agency performance stats with full advertiser details and totals-only campaign/ad group/ad copy breakdowns. */
  performanceStats: AdvertisersPerformanceStats;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Agency-specific settings (SuperAdmin only) */
  settings: AgencySettings;
  slug: Scalars['String']['output'];
  status: Status;
  /** Branding and styling configuration for this company's reseller */
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** Time-series performance metrics aggregated across all advertisers managed by this agency over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  /** The type of the company */
  type: CompanyType;
  /** Current user permissions for this agency (read, edit, admin) */
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


/** Agency company that manages multiple advertisers on behalf of clients */
export type AgencyPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Agency company that manages multiple advertisers on behalf of clients */
export type AgencyTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

/** Agency-specific settings (SuperAdmin only) */
export type AgencySettings = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Linked Copper CRM company record id */
  copperId?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
};

export type AgencySettingsInput = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Linked Copper CRM company record id */
  copperId?: InputMaybe<Scalars['String']['input']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: InputMaybe<Scalars['PwsID']['input']>;
};

export type AnalayticsStatInput = {
  adCopyId: Scalars['PwsID']['input'];
  adGroupId: Scalars['PwsID']['input'];
  at: Scalars['DateTime']['input'];
  bounceRate: Scalars['Float']['input'];
  engagedSessions: Scalars['Int']['input'];
  engagementRate: Scalars['Float']['input'];
  leads: Scalars['Int']['input'];
  newUsers: Scalars['Int']['input'];
  orders: Scalars['Int']['input'];
  pageViews: Scalars['Int']['input'];
  revenue: Scalars['Float']['input'];
  sessionTimeSeconds: Scalars['Int']['input'];
  sessions: Scalars['Int']['input'];
  totalUsers: Scalars['Int']['input'];
};

export type AnalyticsStat = {
  adCopyId: Scalars['PwsID']['output'];
  adGroupId: Scalars['PwsID']['output'];
  at: Scalars['DateTime']['output'];
  bounceRate: Scalars['Float']['output'];
  engagedSessions: Scalars['Int']['output'];
  engagementRate: Scalars['Float']['output'];
  leads: Scalars['Int']['output'];
  newUsers: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  pageViews: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  sessionTimeSeconds: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export enum ApiTokenStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

/** Per-company auto-archive policy in months. Null inherits from parent reseller; 0 disables auto-archive for that entity type. */
export type ArchiverConfig = {
  /** Months before inactive ad copies are archived. Null inherits; 0 disables. */
  adcopyMonths?: Maybe<Scalars['Int']['output']>;
  /** Months before inactive ad groups are archived. Null inherits; 0 disables. */
  adgroupMonths?: Maybe<Scalars['Int']['output']>;
  /** Months before inactive ad templates are archived. Null inherits; 0 disables. */
  adtemplateMonths?: Maybe<Scalars['Int']['output']>;
  /** Months before inactive positions are archived. Null inherits; 0 disables. */
  positionMonths?: Maybe<Scalars['Int']['output']>;
};

export type ArchiverConfigInput = {
  /** Months before inactive ad copies are archived. Null inherits; 0 disables. */
  adcopyMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Months before inactive ad groups are archived. Null inherits; 0 disables. */
  adgroupMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Months before inactive ad templates are archived. Null inherits; 0 disables. */
  adtemplateMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Months before inactive positions are archived. Null inherits; 0 disables. */
  positionMonths?: InputMaybe<Scalars['Int']['input']>;
};

/** Unit hint for numeric assistant rule condition fields */
export enum AssistantAdgroupFieldUnit {
  Count = 'Count',
  Currency = 'Currency',
  Percent = 'Percent'
}

export type AssistantRuleCondition = {
  all?: Maybe<Array<AssistantRuleConditionValue>>;
  any?: Maybe<Array<AssistantRuleConditionValue>>;
};

export type AssistantRuleConditionFieldRef = {
  field: Scalars['String']['output'];
  params?: Maybe<Scalars['JSON']['output']>;
  scope: Scalars['String']['output'];
};

export type AssistantRuleConditionFieldRefInput = {
  field: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  scope: Scalars['String']['input'];
};

export type AssistantRuleConditionInput = {
  all?: InputMaybe<Array<AssistantRuleConditionValueInput>>;
  any?: InputMaybe<Array<AssistantRuleConditionValueInput>>;
};

/** Allowed operators for user-defined rule conditions */
export enum AssistantRuleConditionOperator {
  Between = 'Between',
  Contains = 'Contains',
  Eq = 'Eq',
  Falsy = 'Falsy',
  Gt = 'Gt',
  Gte = 'Gte',
  In = 'In',
  Intersects = 'Intersects',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  Lt = 'Lt',
  Lte = 'Lte',
  Neq = 'Neq',
  NotContains = 'NotContains',
  Truthy = 'Truthy'
}

export type AssistantRuleConditionPropertyConfig = {
  allowedOperators: Array<AssistantRuleConditionOperator>;
  field: Scalars['String']['output'];
  paramsJsonSchema?: Maybe<Scalars['JSON']['output']>;
  possibleValues?: Maybe<Array<Scalars['String']['output']>>;
  scope: Scalars['String']['output'];
  unit?: Maybe<AssistantAdgroupFieldUnit>;
  valueType: AssistantRuleConditionValueType;
};

export type AssistantRuleConditionValue = {
  compareField?: Maybe<AssistantRuleConditionFieldRef>;
  field: Scalars['String']['output'];
  operator: AssistantRuleConditionOperator;
  params?: Maybe<Scalars['JSON']['output']>;
  scope: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type AssistantRuleConditionValueInput = {
  compareField?: InputMaybe<AssistantRuleConditionFieldRefInput>;
  field: Scalars['String']['input'];
  operator: AssistantRuleConditionOperator;
  params?: InputMaybe<Scalars['JSON']['input']>;
  scope: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Runtime value type for rule condition property */
export enum AssistantRuleConditionValueType {
  Array = 'Array',
  Boolean = 'Boolean',
  Date = 'Date',
  Number = 'Number',
  String = 'String'
}

/** Entity scope for assistant rule: AdCopy or AdGroup */
export enum AssistantRuleEntity {
  AdCopy = 'AdCopy',
  AdGroup = 'AdGroup'
}

/** Importance level for assistant recommendations */
export enum AssistantRuleImportance {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

/** Assistant rule output: system rule with key or user-defined rule */
export type AssistantRuleOutput = AssistantRuleSystem | AssistantRuleUser;

export type AssistantRuleRecommendation = {
  all?: Maybe<Array<AssistantRuleRecommendationValue>>;
  any?: Maybe<Array<AssistantRuleRecommendationValue>>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Allowed actions for user-defined recommended changes */
export enum AssistantRuleRecommendationAction {
  Delete = 'Delete',
  Replace = 'Replace',
  Update = 'Update'
}

export type AssistantRuleRecommendationInput = {
  all?: InputMaybe<Array<AssistantRuleRecommendationValueInput>>;
  any?: InputMaybe<Array<AssistantRuleRecommendationValueInput>>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type AssistantRuleRecommendationValue = {
  action?: Maybe<AssistantRuleRecommendationAction>;
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type AssistantRuleRecommendationValueInput = {
  action?: InputMaybe<AssistantRuleRecommendationAction>;
  field?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** System assistant rule with predefined key mapping to code implementation */
export type AssistantRuleSystem = {
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entity: AssistantRuleEntity;
  executionOrder: Scalars['PwsID']['output'];
  id: Scalars['PwsID']['output'];
  importance: AssistantRuleImportance;
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  recommendedChanges?: Maybe<AssistantRuleRecommendation>;
  resellerId: Scalars['PwsID']['output'];
  type: AssistantRuleType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Rule type: System (built-in rules) or User (custom rules) */
export enum AssistantRuleType {
  System = 'System',
  User = 'User'
}

/** User-defined assistant rule with custom configuration */
export type AssistantRuleUser = {
  conditions?: Maybe<AssistantRuleCondition>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entity: AssistantRuleEntity;
  executionOrder: Scalars['PwsID']['output'];
  id: Scalars['PwsID']['output'];
  importance: AssistantRuleImportance;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recommendedChanges?: Maybe<AssistantRuleRecommendation>;
  resellerId: Scalars['PwsID']['output'];
  type: AssistantRuleType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum AutoSegmentFor {
  AdGroup = 'AdGroup',
  AdGroupIab = 'AdGroupIab',
  Advertiser = 'Advertiser',
  Campaign = 'Campaign',
  PositionIab = 'PositionIab',
  Publisher = 'Publisher',
  Website = 'Website'
}

export enum AutoSegmentType {
  Click = 'Click',
  Impression = 'Impression'
}

/** Auction bidding strategy (currently only max CPM supported) */
export enum BiddingStrategy {
  MaxCpm = 'MaxCpm'
}

/** Billing contact person for invoice communications and payment coordination */
export type BillingContact = {
  companyId: Scalars['PwsID']['output'];
  email: Scalars['Email']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['PwsID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type BillingContactCreateInput = {
  companyId: Scalars['PwsID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BillingContactInput = {
  companyId: Scalars['PwsID']['input'];
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['PwsID']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Reason why the ad group is blacklisted on a website */
export enum BlacklistReason {
  Advertiser = 'Advertiser',
  Campaign = 'Campaign',
  Iab = 'Iab'
}

export type Border = {
  color: Scalars['Color']['output'];
  width: Scalars['Int']['output'];
};

export type BorderInput = {
  color?: Scalars['Color']['input'];
  width?: Scalars['Int']['input'];
};

export type BorderRadius = {
  color: Scalars['Color']['output'];
  radius?: Maybe<Scalars['Int']['output']>;
  width: Scalars['Int']['output'];
};

export type BorderRadiusInput = {
  color?: Scalars['Color']['input'];
  radius?: InputMaybe<Scalars['Int']['input']>;
  width?: Scalars['Int']['input'];
};

/** Budget limit scope: open (unlimited), monthly (resets each month), period (start from date to end of adgroup), overall (lifetime limit) */
export enum BudgetCapping {
  Monthly = 'Monthly',
  Open = 'Open',
  Overall = 'Overall',
  Period = 'Period'
}

export type BudgetMeasures = {
  dayBudget?: Maybe<Scalars['Float']['output']>;
  daySpent: Scalars['Float']['output'];
  monthBudget?: Maybe<Scalars['Float']['output']>;
  monthSpent: Scalars['Float']['output'];
  overallBudget?: Maybe<Scalars['Float']['output']>;
  overallSpent: Scalars['Float']['output'];
  periodBudget?: Maybe<Scalars['Float']['output']>;
  periodSpent: Scalars['Float']['output'];
};

export type BudgetStatus = {
  dayOverspent: Scalars['Boolean']['output'];
  monthOverspent: Scalars['Boolean']['output'];
  overallOverspent: Scalars['Boolean']['output'];
  periodOverspent: Scalars['Boolean']['output'];
};

export type BudgetTimed = {
  budgetMeasures: BudgetMeasures;
  budgetStatus: BudgetStatus;
  date: Scalars['DateTime']['output'];
};

/** Advertising campaign containing ad groups, targeting an audience with conversion tracking */
export type Campaign = {
  /** Ad groups belonging to this campaign with optional status filtering */
  adGroups: Array<AdGroup>;
  advertiser: Advertiser;
  advertiserDomainName?: Maybe<Scalars['String']['output']>;
  /** Duration of validity of a click to connect it to a conversion (e.g. P30D - ISO8601) */
  conversionClickAge: ClickAge;
  iabCategory: Iab;
  id: Scalars['PwsID']['output'];
  /** Tracking reference for lead conversion events */
  leadEvent: Scalars['String']['output'];
  market: Market;
  marketId: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Tracking reference for order/purchase conversion events */
  orderEvent: Scalars['String']['output'];
  /** Campaign performance stats with full campaign details and totals-only ad group/ad copy breakdowns. */
  performanceStats: CampaignPerformanceStats;
  /** IAB category suggested from the IAB ad-product tiers of the campaign ad groups (majority vote, archived ad groups ignored), with those ad groups and their tiers. Null when there is no suggestion or it matches the category already set on the campaign */
  recommendedIabCategory?: Maybe<CampaignIabCategoryRecommendation>;
  segments: Array<Segment>;
  shortCode: Scalars['String']['output'];
  status: Status;
  /** Time-series performance metrics for this campaign over a date range */
  timeseries: AdvertiserTimeseriesTotal;
};


/** Advertising campaign containing ad groups, targeting an audience with conversion tracking */
export type CampaignAdGroupsArgs = {
  pagination?: InputMaybe<Pagination>;
  status?: InputMaybe<Array<AdGroupStatus>>;
};


/** Advertising campaign containing ad groups, targeting an audience with conversion tracking */
export type CampaignPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Advertising campaign containing ad groups, targeting an audience with conversion tracking */
export type CampaignTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

/** Ad group and the ad-product tiers used to suggest a campaign IAB category */
export type CampaignAdGroupIab = {
  adGroup: AdGroup;
  /** IAB category mapped from this ad group taxonomy */
  iabCategory: Iab;
  iabTiers: IabTiers;
};

export type CampaignCreateInput = {
  advertiserDomainName?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['PwsID']['input'];
  /** Attribution window for connecting clicks to conversions (default: 45 days) */
  conversionClickAge?: ClickAge;
  iabCategory?: Iab;
  marketId: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
};

export type CampaignExclusionItem = {
  campaign: CampaignPublic;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

/** IAB category suggested for a campaign, together with the ad groups and tiers that produced it */
export type CampaignIabCategoryRecommendation = {
  /** Ad groups and their ad-product tiers used for the suggestion */
  adGroupIabCategories: Array<CampaignAdGroupIab>;
  /** Suggested IAB category */
  iabCategory: Iab;
};

export type CampaignInput = {
  advertiserDomainName?: InputMaybe<Scalars['String']['input']>;
  /** Duration of validity of a click to connect it to a conversion (e.g. P30D - ISO8601) */
  conversionClickAge: ClickAge;
  iabCategory: Iab;
  id: Scalars['PwsID']['input'];
  marketId: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type CampaignPerformanceStats = {
  adGroups: Array<AdGroupWithPerformance>;
  devices: Array<AdvertiserDeviceCost>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

/** Programmatic campaign using RTB/DSP for automated bidding and inventory selection */
export type CampaignProgrammatic = {
  companyId: Scalars['PwsID']['output'];
  dsp: Scalars['String']['output'];
  id: Scalars['PwsID']['output'];
  /** Inventory items belonging to this campaign with optional status filtering */
  inventory: Array<Inventory>;
  market: Market;
  marketId: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Open auction (true) or private deal (false) - currently only open auction supported */
  open: Scalars['Boolean']['output'];
  /** Campaign performance stats with full campaign details and totals-only inventory breakdowns. */
  performanceStats: CampaignProgrammaticPerformanceStats;
  status: Status;
  /** Time-series performance metrics for this campaign over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  tradingDesk: Company;
};


/** Programmatic campaign using RTB/DSP for automated bidding and inventory selection */
export type CampaignProgrammaticInventoryArgs = {
  pagination?: InputMaybe<Pagination>;
  status?: InputMaybe<Array<AdGroupStatus>>;
};


/** Programmatic campaign using RTB/DSP for automated bidding and inventory selection */
export type CampaignProgrammaticPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Programmatic campaign using RTB/DSP for automated bidding and inventory selection */
export type CampaignProgrammaticTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type CampaignProgrammaticInput = {
  companyId: Scalars['PwsID']['input'];
  dsp: Scalars['String']['input'];
  id: Scalars['PwsID']['input'];
  marketId: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  /** Open auction (true) or private deal (false) - currently only open auction supported */
  open: Scalars['Boolean']['input'];
};

export type CampaignProgrammaticPerformanceStats = {
  devices: Array<AdvertiserDeviceCost>;
  inventories: Array<InventoryWithPerformance>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

/** Search criteria for filtering programmatic campaigns */
export type CampaignProgrammaticSearchQuery = {
  /** Filter campaigns by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter campaigns by status */
  status?: InputMaybe<Array<Status>>;
  /** Filter campaigns by trading desk ID */
  tradingDeskId?: InputMaybe<Scalars['PwsID']['input']>;
};

export type CampaignProgrammaticWithPerformance = {
  companyId: Scalars['PwsID']['output'];
  dsp: Scalars['String']['output'];
  id: Scalars['PwsID']['output'];
  inventories: Array<InventoryWithPerformance>;
  /** Inventory items belonging to this campaign with optional status filtering */
  inventory: Array<Inventory>;
  market: Market;
  marketId: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Open auction (true) or private deal (false) - currently only open auction supported */
  open: Scalars['Boolean']['output'];
  /** Campaign performance stats with full campaign details and totals-only inventory breakdowns. */
  performanceStats: CampaignProgrammaticPerformanceStats;
  stats: AdvertiserCostDetails;
  status: Status;
  /** Time-series performance metrics for this campaign over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  tradingDesk: Company;
};


export type CampaignProgrammaticWithPerformanceInventoryArgs = {
  pagination?: InputMaybe<Pagination>;
  status?: InputMaybe<Array<AdGroupStatus>>;
};


export type CampaignProgrammaticWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type CampaignProgrammaticWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type CampaignPublic = {
  advertiserDomainName?: Maybe<Scalars['String']['output']>;
  iabCategory: Iab;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
};

/** Search criteria for filtering campaigns */
export type CampaignSearchQuery = {
  /** Filter campaigns by company ID */
  companyId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter campaigns by IAB category */
  iabCategory?: InputMaybe<Iab>;
  /** Filter campaigns by market ID */
  marketId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter campaigns by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter campaigns by reseller ID */
  resellerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter campaigns by status */
  status?: InputMaybe<Array<Status>>;
};

export type CampaignWithPerformance = {
  adGroups: Array<AdGroupWithPerformance>;
  advertiser: Advertiser;
  advertiserDomainName?: Maybe<Scalars['String']['output']>;
  /** Duration of validity of a click to connect it to a conversion (e.g. P30D - ISO8601) */
  conversionClickAge: ClickAge;
  iabCategory: Iab;
  id: Scalars['PwsID']['output'];
  /** Tracking reference for lead conversion events */
  leadEvent: Scalars['String']['output'];
  market: Market;
  marketId: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Tracking reference for order/purchase conversion events */
  orderEvent: Scalars['String']['output'];
  /** Campaign performance stats with full campaign details and totals-only ad group/ad copy breakdowns. */
  performanceStats: CampaignPerformanceStats;
  /** IAB category suggested from the IAB ad-product tiers of the campaign ad groups (majority vote, archived ad groups ignored), with those ad groups and their tiers. Null when there is no suggestion or it matches the category already set on the campaign */
  recommendedIabCategory?: Maybe<CampaignIabCategoryRecommendation>;
  segments: Array<Segment>;
  shortCode: Scalars['String']['output'];
  stats: AdvertiserCostDetails;
  status: Status;
  /** Time-series performance metrics for this campaign over a date range */
  timeseries: AdvertiserTimeseriesTotal;
};


export type CampaignWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type CampaignWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

/** Ad delivery channel: email (newsletter/transactional) or web (on-site display) */
export enum ChannelType {
  Email = 'Email',
  Web = 'Web'
}

export type Circle = {
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  border: Border;
  left: Scalars['Int']['output'];
  radius: Scalars['Int']['output'];
  top: Scalars['Int']['output'];
  type: Element;
};

export type CircleInput = {
  backgroundColor?: InputMaybe<Scalars['Color']['input']>;
  border?: BorderInput;
  left?: Scalars['Int']['input'];
  radius?: Scalars['Int']['input'];
  top?: Scalars['Int']['input'];
  type: Element;
};

/** Attribution window for connecting clicks to conversions (P30M=30 minutes, P3D=3 days, P30D=30 days, etc.) */
export enum ClickAge {
  Invalid = 'Invalid',
  Older = 'Older',
  P3D = 'P3D',
  P15D = 'P15D',
  P30D = 'P30D',
  P30M = 'P30M',
  P45D = 'P45D',
  P60D = 'P60D'
}

/** Base company entity representing advertisers, publishers, agencies, resellers, and trading desks with billing and permission information */
export type Company = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  slug: Scalars['String']['output'];
  status: Status;
  /** Branding and styling configuration for this company's reseller */
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** The type of the company */
  type: CompanyType;
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CompanyApiToken = {
  createdAt: Scalars['DateTime']['output'];
  status: ApiTokenStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Per-company auto-archive policy in months. Null inherits from parent reseller; 0 disables auto-archive for that entity type. */
export type CompanyArchiver = {
  /** Months before inactive ad copies are archived. Null inherits; 0 disables. */
  adcopyMonths?: Maybe<Scalars['Int']['output']>;
  /** Months before inactive ad groups are archived. Null inherits; 0 disables. */
  adgroupMonths?: Maybe<Scalars['Int']['output']>;
  /** Months before inactive ad templates are archived. Null inherits; 0 disables. */
  adtemplateMonths?: Maybe<Scalars['Int']['output']>;
  id: Scalars['PwsID']['output'];
  /** Months before inactive positions are archived. Null inherits; 0 disables. */
  positionMonths?: Maybe<Scalars['Int']['output']>;
};

export type CompanyCreateBillingContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCreateInput = {
  accountingId?: InputMaybe<Scalars['String']['input']>;
  addressLine1: Scalars['String']['input'];
  /** Associated agency company ID. Applied only when creating an advertiser; ignored for other company types. */
  agencyId?: InputMaybe<Scalars['PwsID']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** Optional billing contact for the new company. Requires admin access on the created company. */
  billingContact?: InputMaybe<CompanyCreateBillingContactInput>;
  city: Scalars['String']['input'];
  country: CountryInput;
  /** Currency used for invoicing and payments (currently EUR only) */
  currency?: InputMaybe<Currency>;
  fax?: InputMaybe<Scalars['String']['input']>;
  genericName: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  /** Language for invoice generation */
  invoiceLanguage?: InputMaybe<InvoiceLanguage>;
  /** Legal entity that will issue invoices (Welcome Media SAS or Powerspace SAS) */
  invoicingCompany?: InputMaybe<InvoicingCompany>;
  name: Scalars['String']['input'];
  /** Payment terms in ISO8601 duration format (e.g., P15D = 15 days, P30D = 30 days) */
  paymentTerm?: InputMaybe<PaymentTerm>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resellerId: Scalars['PwsID']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** The type of company being created (publisher, advertiser, reseller, agency, or trading desk) */
  type: CompanyType;
  /** Optional user to create for the new company. Use sendInvitation to invite via email or omit for a disabled stub. */
  user?: InputMaybe<CompanyCreateUserInput>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type CompanyCreateUserInput = {
  accessType: AccessType;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** When true, sends an invitation email with token. When false, creates a disabled user without email. */
  sendInvitation?: InputMaybe<Scalars['Boolean']['input']>;
  status: UserStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyInput = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: InputMaybe<Scalars['PwsID']['input']>;
  accountingId?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  country: CountryInput;
  /** The currency for company invoices */
  currency?: InputMaybe<Currency>;
  fax?: InputMaybe<Scalars['String']['input']>;
  genericName: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PwsID']['input'];
  invoiceLanguage?: InputMaybe<InvoiceLanguage>;
  invoicingCompany?: InputMaybe<InvoicingCompany>;
  kpis?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** The payment terms of the company */
  paymentTerm?: InputMaybe<PaymentTerm>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationId?: InputMaybe<Scalars['String']['input']>;
  resellerId: Scalars['PwsID']['input'];
  rootDomain?: InputMaybe<Scalars['String']['input']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: InputMaybe<Scalars['PwsID']['input']>;
  slug: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** The type of the company */
  type: CompanyType;
  vatId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyPermission = {
  adCopyDates: Scalars['Boolean']['output'];
  adgroupAutoSegments: Scalars['Boolean']['output'];
  /** Allow budget capping on ad groups. */
  adgroupBudgetCapping: Scalars['Boolean']['output'];
  adgroupCpl: Scalars['Boolean']['output'];
  adgroupCpm: Scalars['Boolean']['output'];
  adgroupCustomcpcs: Scalars['Boolean']['output'];
  /** Require a start date and an end date on ad groups. */
  adgroupDatesRequired: Scalars['Boolean']['output'];
  adgroupDevicetargeting: Scalars['Boolean']['output'];
  adgroupExclusions: Scalars['Boolean']['output'];
  adgroupGeotargeting: Scalars['Boolean']['output'];
  /** Allow monthly budget capping on ad groups. */
  adgroupMonthlyBudgetCapping: Scalars['Boolean']['output'];
  /** Allow open (unlimited) budget capping on ad groups. */
  adgroupOpenBudgetCapping: Scalars['Boolean']['output'];
  /** Allow open daily budget on ad groups. */
  adgroupOpenDailyBudget: Scalars['Boolean']['output'];
  /** Allow overall budget capping on ad groups. */
  adgroupOverallBudgetCapping: Scalars['Boolean']['output'];
  adgroupPriority: Scalars['Boolean']['output'];
  adgroupReportwebsites: Scalars['Boolean']['output'];
  adgroupSegments: Scalars['Boolean']['output'];
  adgroupTimetargeting: Scalars['Boolean']['output'];
  adgroupUsertargeting: Scalars['Boolean']['output'];
  api: Scalars['Boolean']['output'];
  banner: Scalars['Boolean']['output'];
  /** Whether feature permissions can be updated on this company (false when inherited from a parent company). */
  editable: Scalars['Boolean']['output'];
  positionAdvancedsettings: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
  websiteExclusions: Scalars['Boolean']['output'];
};

export type CompanyPermissionInput = {
  adCopyDates: Scalars['Boolean']['input'];
  adgroupAutoSegments: Scalars['Boolean']['input'];
  /** Allow budget capping on ad groups. */
  adgroupBudgetCapping: Scalars['Boolean']['input'];
  adgroupCpl: Scalars['Boolean']['input'];
  adgroupCpm: Scalars['Boolean']['input'];
  adgroupCustomcpcs: Scalars['Boolean']['input'];
  /** Require a start date and an end date on ad groups. */
  adgroupDatesRequired: Scalars['Boolean']['input'];
  adgroupDevicetargeting: Scalars['Boolean']['input'];
  adgroupExclusions: Scalars['Boolean']['input'];
  adgroupGeotargeting: Scalars['Boolean']['input'];
  /** Allow monthly budget capping on ad groups. */
  adgroupMonthlyBudgetCapping: Scalars['Boolean']['input'];
  /** Allow open (unlimited) budget capping on ad groups. */
  adgroupOpenBudgetCapping: Scalars['Boolean']['input'];
  /** Allow open daily budget on ad groups. */
  adgroupOpenDailyBudget: Scalars['Boolean']['input'];
  /** Allow overall budget capping on ad groups. */
  adgroupOverallBudgetCapping: Scalars['Boolean']['input'];
  adgroupPriority: Scalars['Boolean']['input'];
  adgroupReportwebsites: Scalars['Boolean']['input'];
  adgroupSegments: Scalars['Boolean']['input'];
  adgroupTimetargeting: Scalars['Boolean']['input'];
  adgroupUsertargeting: Scalars['Boolean']['input'];
  api: Scalars['Boolean']['input'];
  banner: Scalars['Boolean']['input'];
  /** Whether feature permissions can be updated on this company (false when inherited from a parent company). */
  editable?: Scalars['Boolean']['input'];
  positionAdvancedsettings: Scalars['Boolean']['input'];
  web: Scalars['Boolean']['input'];
  websiteExclusions: Scalars['Boolean']['input'];
};

/** Search criteria for filtering companies */
export type CompanySearchQuery = {
  /** Filter companies by agency ID */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Filter companies by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter companies by reseller IDs */
  resellerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter companies by status */
  status?: InputMaybe<Array<Status>>;
  /** Filter companies by type (Advertiser, Publisher, Agency, etc.) */
  type?: InputMaybe<CompanyType>;
};

/** Company type: Publisher (supplies ad inventory), Advertiser (buys ads), Agency (manages advertisers), Reseller (platform operator), TradingDesk (programmatic buyer) */
export enum CompanyType {
  Advertiser = 'Advertiser',
  Agency = 'Agency',
  Publisher = 'Publisher',
  Reseller = 'Reseller',
  TradingDesk = 'TradingDesk'
}

export type CompanyWebhook = {
  companyId: Scalars['PwsID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['PwsID']['output'];
  types: Array<CompanyWebhookType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Webhook event type subscribed by a company */
export enum CompanyWebhookType {
  AdGroupStatus = 'AdGroupStatus'
}

/** Content type: promotional (marketing/sales), editorial (informational content) */
export enum ContentStrategy {
  Editorial = 'Editorial',
  Promotional = 'Promotional'
}

/** Company in Copper CRM */
export type CopperCompany = {
  address?: Maybe<CopperCompanyAddress>;
  assignee?: Maybe<CopperOpportunityAssignee>;
  customFields: Array<CopperOpportunityCustomField>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  emailDomain?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumbers: Array<CopperCompanyPhoneNumber>;
  primaryContact?: Maybe<CopperCompanyPrimaryContact>;
  socials: Array<CopperCompanySocial>;
  websites: Array<CopperCompanyWebsite>;
};

/** Postal address of a Copper company */
export type CopperCompanyAddress = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** Copper company advertiser type from the Type d'annonceur custom field */
export enum CopperCompanyAdvertiserType {
  AgenceMedia = 'AgenceMedia',
  AgencePerformance = 'AgencePerformance',
  Direct = 'Direct'
}

/** Phone number on a Copper company */
export type CopperCompanyPhoneNumber = {
  category?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
};

/** Primary contact person on a Copper company */
export type CopperCompanyPrimaryContact = {
  address?: Maybe<CopperCompanyAddress>;
  customFields: Array<CopperOpportunityCustomField>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  emails: Array<CopperPersonEmail>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  interactionCount?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumbers: Array<CopperCompanyPhoneNumber>;
  socials: Array<CopperCompanySocial>;
  tags: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  websites: Array<CopperCompanyWebsite>;
};

/** Filters for searching Copper CRM companies */
export type CopperCompanySearchParams = {
  /** Filter companies by Type d'annonceur custom field. Also includes companies with no Type d'annonceur value. When omitted, companies of any advertiser type are returned. */
  advertiserTypes?: InputMaybe<Array<CopperCompanyAdvertiserType>>;
  /** When true, exclude companies that already have the PowerSpace company id custom field set. Defaults to true. */
  excludeLinkedCompanies?: Scalars['Boolean']['input'];
  /** Filter companies by name using a case-insensitive substring match. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Social profile on a Copper company */
export type CopperCompanySocial = {
  category?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Website on a Copper company */
export type CopperCompanyWebsite = {
  category?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Sales opportunity from Copper CRM */
export type CopperOpportunity = {
  assignee?: Maybe<CopperOpportunityAssignee>;
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<CopperCompany>;
  customFields: Array<CopperOpportunityCustomField>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  dateLastContacted?: Maybe<Scalars['DateTime']['output']>;
  dateLeadCreated?: Maybe<Scalars['DateTime']['output']>;
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  monetaryUnit?: Maybe<Scalars['String']['output']>;
  monetaryValue?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pipeline?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

/** Copper user assigned to an opportunity */
export type CopperOpportunityAssignee = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Resolved custom field on a Copper opportunity */
export type CopperOpportunityCustomField = {
  dateValue?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Copper opportunity priority filter */
export enum CopperOpportunityPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  None = 'None'
}

/** Filters for searching Copper CRM opportunities */
export type CopperOpportunitySearchParams = {
  /** Filter by Copper company record id. Lists opportunities linked to that company. */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** When true, exclude opportunities whose Copper company already has the PowerSpace company id custom field set. Defaults to true. */
  excludeLinkedCompanies?: Scalars['Boolean']['input'];
  /** Filter by opportunity priority. */
  priorities?: InputMaybe<Array<CopperOpportunityPriority>>;
  /** Filter by pipeline stage name (matches the stage field on opportunities). */
  stages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by opportunity status. Defaults to Open when omitted. */
  statuses?: InputMaybe<Array<CopperOpportunityStatus>>;
};

/** Copper opportunity status filter */
export enum CopperOpportunityStatus {
  Abandoned = 'Abandoned',
  Lost = 'Lost',
  Open = 'Open',
  Won = 'Won'
}

/** Email on a Copper person */
export type CopperPersonEmail = {
  category?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
};

export enum CostDetailsDimensions {
  Channel = 'Channel',
  DemandSource = 'DemandSource',
  Market = 'Market',
  Network = 'Network'
}

export type CostDetailsFilter = {
  dimension: CostDetailsDimensions;
  values: Array<Scalars['String']['input']>;
};

/** Pricing model: CPC (cost per click), CPL (cost per lead), CPM (cost per thousand impressions), CPO (cost per order) */
export enum CostType {
  Cpc = 'Cpc',
  Cpl = 'Cpl',
  Cpm = 'Cpm',
  Cpo = 'Cpo'
}

/** Country with ISO code and label, used in market definitions and geographic targeting */
export type Country = {
  /** ISO 3166-1 alpha-2 country code (e.g., FR, US, GB) */
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CountryInput = {
  /** ISO 3166-1 alpha-2 country code (e.g., FR, US, GB) */
  code: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** Result of bulk ad copy creation with successes and errors */
export type CreateAdCopiesResult = {
  /** Error messages for failed ad copy creations */
  errors: Array<Scalars['String']['output']>;
  /** Successfully created ad copies */
  success: Array<AdCopy>;
};

export type CreateAssistantUserRuleInput = {
  conditions: AssistantRuleConditionInput;
  description?: InputMaybe<Scalars['String']['input']>;
  entity: AssistantRuleEntity;
  executionOrder?: InputMaybe<Scalars['Int']['input']>;
  importance?: InputMaybe<AssistantRuleImportance>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  recommendedChanges?: InputMaybe<AssistantRuleRecommendationInput>;
  resellerId: Scalars['PwsID']['input'];
};

/** DOM injection position relative to CSS selector: after (append after element), before (insert before element), replace (replace element) */
export enum CssSelectorPosition {
  After = 'After',
  Before = 'Before',
  Replace = 'Replace'
}

/** Supported currencies for invoicing and payments (EUR) */
export enum Currency {
  Eur = 'EUR'
}

/** Daily budget pacing strategy: open (no daily limit), fixed (spend exactly), auto (optimized pacing) */
export enum DailyBudgetType {
  Auto = 'Auto',
  Fixed = 'Fixed',
  Open = 'Open'
}

/** Day of week for dayparting/scheduling (1=Monday, 7=Sunday) */
export enum Day {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DemandSource = {
  /** Demand-side platform (DSP) identifier for programmatic ad buying */
  dsp: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Exchange seat identifier from the trading desk platform */
  seat: Scalars['String']['output'];
  seatId?: Maybe<Scalars['PwsID']['output']>;
};

export type DemandSourceInput = {
  /** Demand-side platform (DSP) identifier for programmatic ad buying */
  dsp: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  /** Exchange seat identifier from the trading desk platform */
  seat: Scalars['String']['input'];
  seatId?: InputMaybe<Scalars['PwsID']['input']>;
};

export type DeviceTargeting = {
  exclusive: Scalars['Boolean']['output'];
  type: Array<DeviceType>;
};

export type DeviceTargetingInput = {
  exclusive?: Scalars['Boolean']['input'];
  type?: Array<DeviceType>;
};

/** Device type for targeting (desktop, tablet, mobile, unknown) */
export enum DeviceType {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
  Tablet = 'Tablet',
  Unknown = 'Unknown'
}

/** Company summary used in directory payloads */
export type DirectoryCompany = {
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
};

export type DirectorySearchQuery = {
  iabCategory?: InputMaybe<Iab>;
  name?: InputMaybe<Scalars['String']['input']>;
  reseller?: InputMaybe<Scalars['PwsID']['input']>;
  /** Restrict the search to these websites. An empty list matches nothing. */
  websiteIds?: InputMaybe<Array<Scalars['PwsID']['input']>>;
};

/** Type of usage of the websites and positions inside the directory */
export enum DirectoryType {
  Excluded = 'Excluded',
  Targeted = 'Targeted'
}

export type DomainExclusionItem = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  domain: Scalars['String']['output'];
};

export enum Element {
  Circle = 'Circle',
  Ellipse = 'Ellipse',
  Image = 'Image',
  Line = 'Line',
  Rectangle = 'Rectangle',
  RichText = 'RichText',
  Triangle = 'Triangle'
}

export type Ellipse = {
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  border: Border;
  left: Scalars['Int']['output'];
  radiusX: Scalars['Int']['output'];
  radiusY: Scalars['Int']['output'];
  top: Scalars['Int']['output'];
  type: Element;
};

export type EllipseInput = {
  backgroundColor?: InputMaybe<Scalars['Color']['input']>;
  border?: BorderInput;
  left?: Scalars['Int']['input'];
  radiusX?: Scalars['Int']['input'];
  radiusY?: Scalars['Int']['input'];
  top?: Scalars['Int']['input'];
  type: Element;
};

/** Entity types tracked in activity feed (ad copy, campaign, user, company, position, etc.) */
export enum EntityType {
  AdCopy = 'AdCopy',
  AdGroup = 'AdGroup',
  AdGroupBudgetPlan = 'AdGroupBudgetPlan',
  AdGroupDirectoryPreset = 'AdGroupDirectoryPreset',
  AdGroupTargeting = 'AdGroupTargeting',
  AdTemplate = 'AdTemplate',
  AdTemplateBanner = 'AdTemplateBanner',
  AdTemplateImage = 'AdTemplateImage',
  AdTemplateNative = 'AdTemplateNative',
  AdTemplateWeb = 'AdTemplateWeb',
  AdgroupCustomCost = 'AdgroupCustomCost',
  AdgroupDirectory = 'AdgroupDirectory',
  AdgroupNetworkExtension = 'AdgroupNetworkExtension',
  AdgroupWebsiteDirectory = 'AdgroupWebsiteDirectory',
  AdgroupWebsiteExclusion = 'AdgroupWebsiteExclusion',
  Advertiser = 'Advertiser',
  Agency = 'Agency',
  BillingContact = 'BillingContact',
  Campaign = 'Campaign',
  Company = 'Company',
  CompanyApiToken = 'CompanyApiToken',
  CompanyArchiver = 'CompanyArchiver',
  CompanyWebhook = 'CompanyWebhook',
  InventorySelection = 'InventorySelection',
  Position = 'Position',
  PositionEmail = 'PositionEmail',
  PositionWeb = 'PositionWeb',
  ProgrammaticCampaign = 'ProgrammaticCampaign',
  Publisher = 'Publisher',
  PublisherExclusionPreset = 'PublisherExclusionPreset',
  Reseller = 'Reseller',
  Segment = 'Segment',
  SegmentBehavioural = 'SegmentBehavioural',
  SegmentFile = 'SegmentFile',
  TradingDesk = 'TradingDesk',
  User = 'User',
  Website = 'Website',
  WebsiteCampaignExclusion = 'WebsiteCampaignExclusion',
  WebsiteDomainExclusion = 'WebsiteDomainExclusion',
  WebsiteIabExclusion = 'WebsiteIabExclusion'
}

export type FontConfiguration = {
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  bold: Scalars['Boolean']['output'];
  color: Scalars['Color']['output'];
  family: Scalars['String']['output'];
  italic: Scalars['Boolean']['output'];
  size: Scalars['Int']['output'];
  underline: Scalars['Boolean']['output'];
  uppercase: Scalars['Boolean']['output'];
};

export type FontConfigurationInput = {
  backgroundColor?: InputMaybe<Scalars['Color']['input']>;
  bold?: Scalars['Boolean']['input'];
  color?: Scalars['Color']['input'];
  family?: Scalars['String']['input'];
  italic?: Scalars['Boolean']['input'];
  size?: Scalars['Int']['input'];
  underline?: Scalars['Boolean']['input'];
  uppercase?: Scalars['Boolean']['input'];
};

export type FontOverride = {
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  bold?: Maybe<Scalars['Boolean']['output']>;
  characterIndex: Scalars['Int']['output'];
  color?: Maybe<Scalars['Color']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  italic?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  underline?: Maybe<Scalars['Boolean']['output']>;
  uppercase?: Maybe<Scalars['Boolean']['output']>;
};

export type FontOverrideInput = {
  backgroundColor?: InputMaybe<Scalars['Color']['input']>;
  bold?: InputMaybe<Scalars['Boolean']['input']>;
  characterIndex?: Scalars['Int']['input'];
  color?: InputMaybe<Scalars['Color']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  italic?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  underline?: InputMaybe<Scalars['Boolean']['input']>;
  uppercase?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormatsConfig = {
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

/** User gender for audience targeting (male, female, unknown) */
export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Unknown = 'Unknown'
}

export type GeoLocation = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeoLocationInput = {
  latitude?: Scalars['Float']['input'];
  longitude?: Scalars['Float']['input'];
};

export type GeoTargeting = {
  cities: Array<TargetingCircle>;
  countries: Array<Scalars['String']['output']>;
  departements: Array<TargetingZone>;
  geoExclusive: Scalars['Boolean']['output'];
  regions: Array<TargetingZone>;
};

export type GeoTargetingInput = {
  cities?: Array<TargetingCircleInput>;
  countries?: Array<Scalars['String']['input']>;
  departements?: Array<TargetingZoneInput>;
  geoExclusive?: Scalars['Boolean']['input'];
  regions?: Array<TargetingZoneInput>;
};

/** Aggregated budget and performance metrics across all ad groups for a given time period */
export type GlobalBudgets = {
  clicks: Scalars['BigInt']['output'];
  dailyBudget: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  impressions: Scalars['BigInt']['output'];
  revenue: Scalars['Float']['output'];
};

export type GlobalConfig = {
  formats: Array<FormatsConfig>;
  maxDiffRatio: Scalars['Float']['output'];
  network: Network;
};

/** The granularity of the wanted grapph on current zimezonee */
export enum GraphGranularity {
  All = 'All',
  Day = 'Day',
  Hour = 'Hour',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export enum HorizontalAlign {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right'
}

/** The IAB categories */
export enum Iab {
  Iab1 = 'IAB1',
  Iab1_1 = 'IAB1_1',
  Iab1_2 = 'IAB1_2',
  Iab1_3 = 'IAB1_3',
  Iab1_4 = 'IAB1_4',
  Iab1_5 = 'IAB1_5',
  Iab1_6 = 'IAB1_6',
  Iab1_7 = 'IAB1_7',
  Iab2 = 'IAB2',
  Iab2_1 = 'IAB2_1',
  Iab2_2 = 'IAB2_2',
  Iab2_3 = 'IAB2_3',
  Iab2_4 = 'IAB2_4',
  Iab2_5 = 'IAB2_5',
  Iab2_6 = 'IAB2_6',
  Iab2_7 = 'IAB2_7',
  Iab2_8 = 'IAB2_8',
  Iab2_9 = 'IAB2_9',
  Iab2_10 = 'IAB2_10',
  Iab2_11 = 'IAB2_11',
  Iab2_12 = 'IAB2_12',
  Iab2_13 = 'IAB2_13',
  Iab2_14 = 'IAB2_14',
  Iab2_15 = 'IAB2_15',
  Iab2_16 = 'IAB2_16',
  Iab2_17 = 'IAB2_17',
  Iab2_18 = 'IAB2_18',
  Iab2_19 = 'IAB2_19',
  Iab2_20 = 'IAB2_20',
  Iab2_21 = 'IAB2_21',
  Iab2_22 = 'IAB2_22',
  Iab2_23 = 'IAB2_23',
  Iab3 = 'IAB3',
  Iab3_1 = 'IAB3_1',
  Iab3_2 = 'IAB3_2',
  Iab3_3 = 'IAB3_3',
  Iab3_4 = 'IAB3_4',
  Iab3_5 = 'IAB3_5',
  Iab3_6 = 'IAB3_6',
  Iab3_7 = 'IAB3_7',
  Iab3_8 = 'IAB3_8',
  Iab3_9 = 'IAB3_9',
  Iab3_10 = 'IAB3_10',
  Iab3_11 = 'IAB3_11',
  Iab3_12 = 'IAB3_12',
  Iab4 = 'IAB4',
  Iab4_1 = 'IAB4_1',
  Iab4_2 = 'IAB4_2',
  Iab4_3 = 'IAB4_3',
  Iab4_4 = 'IAB4_4',
  Iab4_5 = 'IAB4_5',
  Iab4_6 = 'IAB4_6',
  Iab4_7 = 'IAB4_7',
  Iab4_8 = 'IAB4_8',
  Iab4_9 = 'IAB4_9',
  Iab4_10 = 'IAB4_10',
  Iab4_11 = 'IAB4_11',
  Iab5 = 'IAB5',
  Iab5_1 = 'IAB5_1',
  Iab5_2 = 'IAB5_2',
  Iab5_3 = 'IAB5_3',
  Iab5_4 = 'IAB5_4',
  Iab5_5 = 'IAB5_5',
  Iab5_6 = 'IAB5_6',
  Iab5_7 = 'IAB5_7',
  Iab5_8 = 'IAB5_8',
  Iab5_9 = 'IAB5_9',
  Iab5_10 = 'IAB5_10',
  Iab5_11 = 'IAB5_11',
  Iab5_12 = 'IAB5_12',
  Iab5_13 = 'IAB5_13',
  Iab5_14 = 'IAB5_14',
  Iab5_15 = 'IAB5_15',
  Iab6 = 'IAB6',
  Iab6_1 = 'IAB6_1',
  Iab6_2 = 'IAB6_2',
  Iab6_3 = 'IAB6_3',
  Iab6_4 = 'IAB6_4',
  Iab6_5 = 'IAB6_5',
  Iab6_6 = 'IAB6_6',
  Iab6_7 = 'IAB6_7',
  Iab6_8 = 'IAB6_8',
  Iab6_9 = 'IAB6_9',
  Iab7 = 'IAB7',
  Iab7_1 = 'IAB7_1',
  Iab7_2 = 'IAB7_2',
  Iab7_3 = 'IAB7_3',
  Iab7_4 = 'IAB7_4',
  Iab7_5 = 'IAB7_5',
  Iab7_6 = 'IAB7_6',
  Iab7_7 = 'IAB7_7',
  Iab7_8 = 'IAB7_8',
  Iab7_9 = 'IAB7_9',
  Iab7_10 = 'IAB7_10',
  Iab7_11 = 'IAB7_11',
  Iab7_12 = 'IAB7_12',
  Iab7_13 = 'IAB7_13',
  Iab7_14 = 'IAB7_14',
  Iab7_15 = 'IAB7_15',
  Iab7_16 = 'IAB7_16',
  Iab7_17 = 'IAB7_17',
  Iab7_18 = 'IAB7_18',
  Iab7_19 = 'IAB7_19',
  Iab7_20 = 'IAB7_20',
  Iab7_21 = 'IAB7_21',
  Iab7_22 = 'IAB7_22',
  Iab7_23 = 'IAB7_23',
  Iab7_24 = 'IAB7_24',
  Iab7_25 = 'IAB7_25',
  Iab7_26 = 'IAB7_26',
  Iab7_27 = 'IAB7_27',
  Iab7_28 = 'IAB7_28',
  Iab7_29 = 'IAB7_29',
  Iab7_30 = 'IAB7_30',
  Iab7_31 = 'IAB7_31',
  Iab7_32 = 'IAB7_32',
  Iab7_33 = 'IAB7_33',
  Iab7_34 = 'IAB7_34',
  Iab7_35 = 'IAB7_35',
  Iab7_36 = 'IAB7_36',
  Iab7_37 = 'IAB7_37',
  Iab7_38 = 'IAB7_38',
  Iab7_39 = 'IAB7_39',
  Iab7_40 = 'IAB7_40',
  Iab7_41 = 'IAB7_41',
  Iab7_42 = 'IAB7_42',
  Iab7_43 = 'IAB7_43',
  Iab7_44 = 'IAB7_44',
  Iab7_45 = 'IAB7_45',
  Iab8 = 'IAB8',
  Iab8_1 = 'IAB8_1',
  Iab8_2 = 'IAB8_2',
  Iab8_3 = 'IAB8_3',
  Iab8_4 = 'IAB8_4',
  Iab8_5 = 'IAB8_5',
  Iab8_6 = 'IAB8_6',
  Iab8_7 = 'IAB8_7',
  Iab8_8 = 'IAB8_8',
  Iab8_9 = 'IAB8_9',
  Iab8_10 = 'IAB8_10',
  Iab8_11 = 'IAB8_11',
  Iab8_12 = 'IAB8_12',
  Iab8_13 = 'IAB8_13',
  Iab8_14 = 'IAB8_14',
  Iab8_15 = 'IAB8_15',
  Iab8_16 = 'IAB8_16',
  Iab8_17 = 'IAB8_17',
  Iab8_18 = 'IAB8_18',
  Iab9 = 'IAB9',
  Iab9_1 = 'IAB9_1',
  Iab9_2 = 'IAB9_2',
  Iab9_3 = 'IAB9_3',
  Iab9_4 = 'IAB9_4',
  Iab9_5 = 'IAB9_5',
  Iab9_6 = 'IAB9_6',
  Iab9_7 = 'IAB9_7',
  Iab9_8 = 'IAB9_8',
  Iab9_9 = 'IAB9_9',
  Iab9_10 = 'IAB9_10',
  Iab9_11 = 'IAB9_11',
  Iab9_12 = 'IAB9_12',
  Iab9_13 = 'IAB9_13',
  Iab9_14 = 'IAB9_14',
  Iab9_15 = 'IAB9_15',
  Iab9_16 = 'IAB9_16',
  Iab9_17 = 'IAB9_17',
  Iab9_18 = 'IAB9_18',
  Iab9_19 = 'IAB9_19',
  Iab9_20 = 'IAB9_20',
  Iab9_21 = 'IAB9_21',
  Iab9_22 = 'IAB9_22',
  Iab9_23 = 'IAB9_23',
  Iab9_24 = 'IAB9_24',
  Iab9_25 = 'IAB9_25',
  Iab9_26 = 'IAB9_26',
  Iab9_27 = 'IAB9_27',
  Iab9_28 = 'IAB9_28',
  Iab9_29 = 'IAB9_29',
  Iab9_30 = 'IAB9_30',
  Iab9_31 = 'IAB9_31',
  Iab10 = 'IAB10',
  Iab10_1 = 'IAB10_1',
  Iab10_2 = 'IAB10_2',
  Iab10_3 = 'IAB10_3',
  Iab10_4 = 'IAB10_4',
  Iab10_5 = 'IAB10_5',
  Iab10_6 = 'IAB10_6',
  Iab10_7 = 'IAB10_7',
  Iab10_8 = 'IAB10_8',
  Iab10_9 = 'IAB10_9',
  Iab11 = 'IAB11',
  Iab11_1 = 'IAB11_1',
  Iab11_2 = 'IAB11_2',
  Iab11_3 = 'IAB11_3',
  Iab11_4 = 'IAB11_4',
  Iab11_5 = 'IAB11_5',
  Iab12 = 'IAB12',
  Iab12_1 = 'IAB12_1',
  Iab12_2 = 'IAB12_2',
  Iab12_3 = 'IAB12_3',
  Iab13 = 'IAB13',
  Iab13_1 = 'IAB13_1',
  Iab13_2 = 'IAB13_2',
  Iab13_3 = 'IAB13_3',
  Iab13_4 = 'IAB13_4',
  Iab13_5 = 'IAB13_5',
  Iab13_6 = 'IAB13_6',
  Iab13_7 = 'IAB13_7',
  Iab13_8 = 'IAB13_8',
  Iab13_9 = 'IAB13_9',
  Iab13_10 = 'IAB13_10',
  Iab13_11 = 'IAB13_11',
  Iab13_12 = 'IAB13_12',
  Iab14 = 'IAB14',
  Iab14_1 = 'IAB14_1',
  Iab14_2 = 'IAB14_2',
  Iab14_3 = 'IAB14_3',
  Iab14_4 = 'IAB14_4',
  Iab14_5 = 'IAB14_5',
  Iab14_6 = 'IAB14_6',
  Iab14_7 = 'IAB14_7',
  Iab14_8 = 'IAB14_8',
  Iab15 = 'IAB15',
  Iab15_1 = 'IAB15_1',
  Iab15_2 = 'IAB15_2',
  Iab15_3 = 'IAB15_3',
  Iab15_4 = 'IAB15_4',
  Iab15_5 = 'IAB15_5',
  Iab15_6 = 'IAB15_6',
  Iab15_7 = 'IAB15_7',
  Iab15_8 = 'IAB15_8',
  Iab15_9 = 'IAB15_9',
  Iab15_10 = 'IAB15_10',
  Iab16 = 'IAB16',
  Iab16_1 = 'IAB16_1',
  Iab16_2 = 'IAB16_2',
  Iab16_3 = 'IAB16_3',
  Iab16_4 = 'IAB16_4',
  Iab16_5 = 'IAB16_5',
  Iab16_6 = 'IAB16_6',
  Iab16_7 = 'IAB16_7',
  Iab17 = 'IAB17',
  Iab17_1 = 'IAB17_1',
  Iab17_2 = 'IAB17_2',
  Iab17_3 = 'IAB17_3',
  Iab17_4 = 'IAB17_4',
  Iab17_5 = 'IAB17_5',
  Iab17_6 = 'IAB17_6',
  Iab17_7 = 'IAB17_7',
  Iab17_8 = 'IAB17_8',
  Iab17_9 = 'IAB17_9',
  Iab17_10 = 'IAB17_10',
  Iab17_11 = 'IAB17_11',
  Iab17_12 = 'IAB17_12',
  Iab17_13 = 'IAB17_13',
  Iab17_14 = 'IAB17_14',
  Iab17_15 = 'IAB17_15',
  Iab17_16 = 'IAB17_16',
  Iab17_17 = 'IAB17_17',
  Iab17_18 = 'IAB17_18',
  Iab17_19 = 'IAB17_19',
  Iab17_20 = 'IAB17_20',
  Iab17_21 = 'IAB17_21',
  Iab17_22 = 'IAB17_22',
  Iab17_23 = 'IAB17_23',
  Iab17_24 = 'IAB17_24',
  Iab17_25 = 'IAB17_25',
  Iab17_26 = 'IAB17_26',
  Iab17_27 = 'IAB17_27',
  Iab17_28 = 'IAB17_28',
  Iab17_29 = 'IAB17_29',
  Iab17_30 = 'IAB17_30',
  Iab17_31 = 'IAB17_31',
  Iab17_32 = 'IAB17_32',
  Iab17_33 = 'IAB17_33',
  Iab17_34 = 'IAB17_34',
  Iab17_35 = 'IAB17_35',
  Iab17_36 = 'IAB17_36',
  Iab17_37 = 'IAB17_37',
  Iab17_38 = 'IAB17_38',
  Iab17_39 = 'IAB17_39',
  Iab17_40 = 'IAB17_40',
  Iab17_41 = 'IAB17_41',
  Iab17_42 = 'IAB17_42',
  Iab17_43 = 'IAB17_43',
  Iab17_44 = 'IAB17_44',
  Iab18 = 'IAB18',
  Iab18_1 = 'IAB18_1',
  Iab18_2 = 'IAB18_2',
  Iab18_3 = 'IAB18_3',
  Iab18_4 = 'IAB18_4',
  Iab18_5 = 'IAB18_5',
  Iab18_6 = 'IAB18_6',
  Iab19 = 'IAB19',
  Iab19_1 = 'IAB19_1',
  Iab19_2 = 'IAB19_2',
  Iab19_3 = 'IAB19_3',
  Iab19_4 = 'IAB19_4',
  Iab19_5 = 'IAB19_5',
  Iab19_6 = 'IAB19_6',
  Iab19_7 = 'IAB19_7',
  Iab19_8 = 'IAB19_8',
  Iab19_9 = 'IAB19_9',
  Iab19_10 = 'IAB19_10',
  Iab19_11 = 'IAB19_11',
  Iab19_12 = 'IAB19_12',
  Iab19_13 = 'IAB19_13',
  Iab19_14 = 'IAB19_14',
  Iab19_15 = 'IAB19_15',
  Iab19_16 = 'IAB19_16',
  Iab19_17 = 'IAB19_17',
  Iab19_18 = 'IAB19_18',
  Iab19_19 = 'IAB19_19',
  Iab19_20 = 'IAB19_20',
  Iab19_21 = 'IAB19_21',
  Iab19_22 = 'IAB19_22',
  Iab19_23 = 'IAB19_23',
  Iab19_24 = 'IAB19_24',
  Iab19_25 = 'IAB19_25',
  Iab19_26 = 'IAB19_26',
  Iab19_27 = 'IAB19_27',
  Iab19_28 = 'IAB19_28',
  Iab19_29 = 'IAB19_29',
  Iab19_30 = 'IAB19_30',
  Iab19_31 = 'IAB19_31',
  Iab19_32 = 'IAB19_32',
  Iab19_33 = 'IAB19_33',
  Iab19_34 = 'IAB19_34',
  Iab19_35 = 'IAB19_35',
  Iab19_36 = 'IAB19_36',
  Iab20 = 'IAB20',
  Iab20_1 = 'IAB20_1',
  Iab20_2 = 'IAB20_2',
  Iab20_3 = 'IAB20_3',
  Iab20_4 = 'IAB20_4',
  Iab20_5 = 'IAB20_5',
  Iab20_6 = 'IAB20_6',
  Iab20_7 = 'IAB20_7',
  Iab20_8 = 'IAB20_8',
  Iab20_9 = 'IAB20_9',
  Iab20_10 = 'IAB20_10',
  Iab20_11 = 'IAB20_11',
  Iab20_12 = 'IAB20_12',
  Iab20_13 = 'IAB20_13',
  Iab20_14 = 'IAB20_14',
  Iab20_15 = 'IAB20_15',
  Iab20_16 = 'IAB20_16',
  Iab20_17 = 'IAB20_17',
  Iab20_18 = 'IAB20_18',
  Iab20_19 = 'IAB20_19',
  Iab20_20 = 'IAB20_20',
  Iab20_21 = 'IAB20_21',
  Iab20_22 = 'IAB20_22',
  Iab20_23 = 'IAB20_23',
  Iab20_24 = 'IAB20_24',
  Iab20_25 = 'IAB20_25',
  Iab20_26 = 'IAB20_26',
  Iab20_27 = 'IAB20_27',
  Iab21 = 'IAB21',
  Iab21_1 = 'IAB21_1',
  Iab21_2 = 'IAB21_2',
  Iab21_3 = 'IAB21_3',
  Iab22 = 'IAB22',
  Iab22_1 = 'IAB22_1',
  Iab22_2 = 'IAB22_2',
  Iab22_3 = 'IAB22_3',
  Iab22_4 = 'IAB22_4',
  Iab23 = 'IAB23',
  Iab23_1 = 'IAB23_1',
  Iab23_2 = 'IAB23_2',
  Iab23_3 = 'IAB23_3',
  Iab23_4 = 'IAB23_4',
  Iab23_5 = 'IAB23_5',
  Iab23_6 = 'IAB23_6',
  Iab23_7 = 'IAB23_7',
  Iab23_8 = 'IAB23_8',
  Iab23_9 = 'IAB23_9',
  Iab23_10 = 'IAB23_10',
  Iab24 = 'IAB24',
  Iab25 = 'IAB25',
  Iab25_1 = 'IAB25_1',
  Iab25_2 = 'IAB25_2',
  Iab25_3 = 'IAB25_3',
  Iab25_4 = 'IAB25_4',
  Iab25_5 = 'IAB25_5',
  Iab25_6 = 'IAB25_6',
  Iab25_7 = 'IAB25_7',
  Iab26 = 'IAB26',
  Iab26_1 = 'IAB26_1',
  Iab26_2 = 'IAB26_2',
  Iab26_3 = 'IAB26_3',
  Iab26_4 = 'IAB26_4'
}

export type IabExclusionItem = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  iabCategory: Iab;
};

/** IAB taxonomy used to classify content, ad products, audiences, OpenRTB categories, or GARM */
export enum IabTaxonomyType {
  AdProduct = 'AdProduct',
  Audience = 'Audience',
  Category = 'Category',
  Content = 'Content',
  Garm = 'Garm'
}

/** IAB taxonomy tiers */
export type IabTiers = {
  /** OpenRTB category referenced by this taxonomy node */
  iabCategory?: Maybe<Iab>;
  /** Taxonomy node id */
  iabId: Scalars['String']['output'];
  /** Taxonomy node tier */
  tier: Scalars['Int']['output'];
  /** Top-level tier id */
  tier1Id?: Maybe<Scalars['String']['output']>;
  /** Top-level tier name */
  tier1Name?: Maybe<Scalars['String']['output']>;
  /** Second-level tier id */
  tier2Id?: Maybe<Scalars['String']['output']>;
  /** Second-level tier name */
  tier2Name?: Maybe<Scalars['String']['output']>;
  /** Third-level tier id */
  tier3Id?: Maybe<Scalars['String']['output']>;
  /** Third-level tier name */
  tier3Name?: Maybe<Scalars['String']['output']>;
  /** Fourth-level tier id */
  tier4Id?: Maybe<Scalars['String']['output']>;
  /** Fourth-level tier name */
  tier4Name?: Maybe<Scalars['String']['output']>;
  /** Fifth-level tier id */
  tier5Id?: Maybe<Scalars['String']['output']>;
  /** Fifth-level tier name */
  tier5Name?: Maybe<Scalars['String']['output']>;
  /** Sixth-level tier id */
  tier6Id?: Maybe<Scalars['String']['output']>;
  /** Sixth-level tier name */
  tier6Name?: Maybe<Scalars['String']['output']>;
  type: IabTaxonomyType;
};

export type Image = {
  height: Scalars['Int']['output'];
  left: Scalars['Int']['output'];
  top: Scalars['Int']['output'];
  type: Element;
  width: Scalars['Int']['output'];
};

export type ImageCanvas = {
  backgroundColor: Scalars['String']['output'];
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type ImageCanvasInput = {
  backgroundColor?: Scalars['String']['input'];
  backgroundImageUrl?: InputMaybe<Scalars['String']['input']>;
  height?: Scalars['Int']['input'];
  width?: Scalars['Int']['input'];
};

export type ImageInput = {
  height?: Scalars['Int']['input'];
  left?: Scalars['Int']['input'];
  top?: Scalars['Int']['input'];
  type: Element;
  width?: Scalars['Int']['input'];
};

export type ImageTemplateDescriptor = {
  canvas: ImageCanvas;
  elements: Array<ImageTemplateElements>;
};

export type ImageTemplateDescriptorInput = {
  /** Canvas configuration with width, height, background color, and optional background image URL */
  canvas: ImageCanvasInput;
  /** Array of template elements (shapes, images, text) positioned on the canvas */
  elements: Array<ImageTemplateElementsInput>;
};

export type ImageTemplateElements = Circle | Ellipse | Image | Line | Rectangle | RichText | Triangle;

export type ImageTemplateElementsInput = {
  circle?: InputMaybe<CircleInput>;
  ellipse?: InputMaybe<EllipseInput>;
  image?: InputMaybe<ImageInput>;
  line?: InputMaybe<LineInput>;
  rectangle?: InputMaybe<RectangleInput>;
  richText?: InputMaybe<RichTextInput>;
  triangle?: InputMaybe<TriangleInput>;
};

export type ImpersonationTokenResult = {
  actorId: Scalars['PwsID']['output'];
  expiresAt: Scalars['DateTime']['output'];
  slug: Scalars['String']['output'];
  targetUserId: Scalars['PwsID']['output'];
  token: Scalars['String']['output'];
};

export type InvalidFlatrecordStat = {
  invalidReason: Scalars['String']['output'];
  leads: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
};

/** Open marketplace inventory for programmatic campaigns, representing available ad space from multiple publishers */
export type Inventory = {
  campaign: Campaign;
  channelEmail: Scalars['Boolean']['output'];
  channelWeb: Scalars['Boolean']['output'];
  contentStrategy: ContentStrategy;
  dealId?: Maybe<Scalars['String']['output']>;
  dspId?: Maybe<Scalars['Int']['output']>;
  /** Automatic planning of end of delivery */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  format: AdFormat;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  network: Network;
  /** Inventory performance stats with aggregated metrics. */
  performanceStats: AdGroupPerformanceStats;
  /** Priority level for auction ranking */
  priorityId?: Maybe<Scalars['PwsID']['output']>;
  /** Automatic planning of start of delivery */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: AdGroupStatus;
  /** Time-series performance metrics for this inventory item over a date range */
  timeseries: AdvertiserTimeseriesTotal;
};


/** Open marketplace inventory for programmatic campaigns, representing available ad space from multiple publishers */
export type InventoryPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Open marketplace inventory for programmatic campaigns, representing available ad space from multiple publishers */
export type InventoryTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type InventoryWithPerformance = {
  campaign: Campaign;
  channelEmail: Scalars['Boolean']['output'];
  channelWeb: Scalars['Boolean']['output'];
  contentStrategy: ContentStrategy;
  dealId?: Maybe<Scalars['String']['output']>;
  dspId?: Maybe<Scalars['Int']['output']>;
  /** Automatic planning of end of delivery */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  format: AdFormat;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  network: Network;
  /** Inventory performance stats with aggregated metrics. */
  performanceStats: AdGroupPerformanceStats;
  /** Priority level for auction ranking */
  priorityId?: Maybe<Scalars['PwsID']['output']>;
  /** Automatic planning of start of delivery */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stats: AdvertiserCostDetails;
  status: AdGroupStatus;
  /** Time-series performance metrics for this inventory item over a date range */
  timeseries: AdvertiserTimeseriesTotal;
};


export type InventoryWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type InventoryWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type InvoiceAdjustmentItem = {
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceAdjustmentItemInput = {
  description: Scalars['String']['input'];
  total: Scalars['Float']['input'];
};

export type InvoiceAdvertiser = {
  advertiser: Advertiser;
  advertiserId: Scalars['PwsID']['output'];
  advertiserName: Scalars['String']['output'];
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  agencyName?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  dueDate: Scalars['DateTime']['output'];
  issuerName: Scalars['String']['output'];
  /** Invoice line items grouped by ad group with costs, impressions, clicks, leads, orders, CPC, and CPM metrics */
  items: Array<InvoiceAdvertiserItems>;
  /** Additional recipient name (e.g., agency for advertiser invoice) */
  otherRecipientName?: Maybe<Scalars['String']['output']>;
  paid: Paid;
  period: Scalars['DateTime']['output'];
  recipientName: Scalars['String']['output'];
  reference: Scalars['InvoiceReference']['output'];
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  resellerName: Scalars['String']['output'];
  status: InvoiceStatus;
  tax: Tax;
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceAdvertiserItem = {
  adGroupId: Scalars['PwsID']['output'];
  adGroupName: Scalars['String']['output'];
  campaignId: Scalars['PwsID']['output'];
  campaignName: Scalars['String']['output'];
  clicks: Scalars['Int']['output'];
  cpc: Scalars['Float']['output'];
  cpm: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  impressions: Scalars['Int']['output'];
  leads: Scalars['Int']['output'];
  market: Market;
  network: Network;
  orders: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Union type representing invoice line items for advertisers: either campaign/ad group performance items or manual adjustment items */
export type InvoiceAdvertiserItems = InvoiceAdjustmentItem | InvoiceAdvertiserItem;

/** Search criteria for filtering advertiser invoices */
export type InvoiceAdvertiserSearchQuery = {
  /** Filter invoices by advertiser ID */
  advertiserId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter invoices by billing period (month/year) */
  period?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter invoices by reference (exact match) */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Filter invoices by status (pending, validated, paid) */
  status?: InputMaybe<InvoiceStatus>;
};

/** Available languages for invoice generation (French, English) */
export enum InvoiceLanguage {
  En = 'en',
  Fr = 'fr'
}

export type InvoicePublisher = {
  amount: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  dueDate: Scalars['DateTime']['output'];
  issuerName: Scalars['String']['output'];
  /** Invoice line items grouped by website with costs and performance metrics */
  items: Array<InvoicePublisherItems>;
  /** Additional recipient name (e.g., agency for advertiser invoice) */
  otherRecipientName?: Maybe<Scalars['String']['output']>;
  paid: Paid;
  period: Scalars['DateTime']['output'];
  publisher: Publisher;
  publisherId: Scalars['PwsID']['output'];
  publisherName: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  reference: Scalars['InvoiceReference']['output'];
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  resellerName: Scalars['String']['output'];
  status: InvoiceStatus;
  tax: Tax;
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoicePublisherItem = {
  createdAt: Scalars['DateTime']['output'];
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  websiteName: Scalars['String']['output'];
};

/** Union type representing invoice line items for publishers: either website performance items or manual adjustment items */
export type InvoicePublisherItems = InvoiceAdjustmentItem | InvoicePublisherItem;

/** Search criteria for filtering publisher invoices */
export type InvoicePublisherSearchQuery = {
  /** Filter invoices by billing period (month/year) */
  period?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter invoices by publisher ID */
  publisherId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter invoices by reference (exact match) */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Filter invoices by status (pending, validated, paid) */
  status?: InputMaybe<InvoiceStatus>;
};

/** Invoice payment status: pending (awaiting validation), validated (approved, awaiting payment), paid (payment received) */
export enum InvoiceStatus {
  Paid = 'Paid',
  Pending = 'Pending',
  Validated = 'Validated'
}

/** Legal entity that will issue invoices (Welcome Media SAS or Powerspace SAS) */
export enum InvoicingCompany {
  PowerspaceSas = 'PowerspaceSAS',
  WelcomeMediaSas = 'WelcomeMediaSAS'
}

/** Language entity with ISO code used in markets and user preferences */
export type Language = {
  /** ISO 639-1 language code (e.g., en, fr, it) */
  code: Scalars['String']['output'];
  id: Scalars['PwsID']['output'];
  label: Scalars['String']['output'];
};

export type Line = {
  bottom: Scalars['Int']['output'];
  color: Scalars['Color']['output'];
  left: Scalars['Int']['output'];
  right: Scalars['Int']['output'];
  top: Scalars['Int']['output'];
  type: Element;
};

export type LineInput = {
  bottom?: Scalars['Int']['input'];
  color?: Scalars['Color']['input'];
  left?: Scalars['Int']['input'];
  right?: Scalars['Int']['input'];
  top?: Scalars['Int']['input'];
  type: Element;
};

export type LoginResult = {
  /** When true, the user must update their password before using the application. */
  mustChangePassword: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** Geographic market defined by country and language combination (e.g., France-French, Canada-English) */
export type Market = {
  /** Country this market targets */
  country: Country;
  id: Scalars['PwsID']['output'];
  language: Language;
};

/** Search criteria for filtering markets */
export type MarketSearchQuery = {
  /** Filter markets by ISO country code (e.g., FR, US) */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Filter markets by ISO language code (e.g., en, fr) */
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  /** Accept a user invitation by setting password and completing profile. No authentication required. */
  acceptInvite?: Maybe<Scalars['Boolean']['output']>;
  /** Add geographic locations to ad group targeting by address. Uses Google Maps geocoding. Returns invalid addresses. Requires Edit permission. */
  addAdGroupTargetingAdresses?: Maybe<Array<AddAdGroupTargetingAdressesResult>>;
  /** Add websites/positions to the ad group directory without removing existing ones. Requires edit access. */
  addToDirectory: Scalars['Boolean']['output'];
  /** Add bid adjustments for additional websites/publishers without removing existing ones. Requires edit access. */
  addToWebsiteAdjustments: Scalars['Boolean']['output'];
  /** Archive an advertiser and all its campaign ad groups. Requires edit access. */
  archiveAdvertiser: Scalars['Boolean']['output'];
  /** Archive an agency and all managed advertiser ad groups. Requires edit access. */
  archiveAgency: Scalars['Boolean']['output'];
  /** Archive a campaign and all its ad groups. Requires edit access. */
  archiveCampaign: Scalars['Boolean']['output'];
  /** Archive a programmatic campaign and all its inventory. Requires edit access. */
  archiveProgrammaticCampaign: Scalars['Boolean']['output'];
  /** Archive a publisher and all its website positions. Requires edit access. */
  archivePublisher: Scalars['Boolean']['output'];
  /** Archive a reseller and all advertiser, publisher, and trading desk delivery resources. Requires edit access. */
  archiveReseller: Scalars['Boolean']['output'];
  /** Archive a trading desk and all its programmatic campaign inventory. Requires edit access. */
  archiveTradingDesk: Scalars['Boolean']['output'];
  /** Archive a website and all its ad positions. Requires edit access. */
  archiveWebsite: Scalars['Boolean']['output'];
  /** Request a password reset email. Always returns true for security (does not reveal if email exists). */
  askResetUserPassword: Scalars['Boolean']['output'];
  /** Assign an exclusion preset to a reseller or publisher. Requires publisher blacklist preset access. */
  assignExclusionPresetToCompany: Scalars['Boolean']['output'];
  /** Assign an exclusion preset to a website. Requires publisher blacklist preset access. */
  assignPublisherExclusionPresetToWebsite: Scalars['Boolean']['output'];
  /** Duplicate an existing ad group with all its settings, targeting, and active ad copies. Returns new ad group ID. Requires Edit permission. */
  copyAdGroup?: Maybe<Scalars['PwsID']['output']>;
  /** Duplicate an existing position with all its settings. Returns new position ID. Requires Edit permission. */
  copyPosition: Scalars['PwsID']['output'];
  /** Create multiple ad copies with images in bulk. Returns successes and errors separately. Requires edit access. */
  createAdCopies: CreateAdCopiesResult;
  /** Create a new ad group within a campaign. Requires edit access. */
  createAdGroup?: Maybe<AdGroup>;
  /** Create a new plan to change the adgroups budget */
  createAdGroupBudgetPlan?: Maybe<AdGroupBudgetPlan>;
  /** Create an empty directory preset owned by a reseller, advertiser, or agency company. Requires advertiser directory preset access. */
  createAdGroupDirectoryPreset: AdGroupDirectoryPreset;
  /** Create a new banner ad template with fixed width and height. Requires edit access to the position. */
  createAdTemplateBanner: AdTemplateBanner;
  /** Create a new native ad template with customizable elements and optional mobile version. Supports background image uploads. Requires edit access to the position. */
  createAdTemplateNative: AdTemplateNative;
  /** Create a new web ad template with custom HTML, CSS, and JavaScript. Requires edit access to the position. */
  createAdTemplateWeb: AdTemplateWeb;
  /** Generate advertiser invoices for a completed billing period. Creates invoices grouped by advertiser with ad group line items. SuperAdmin or Reseller only. */
  createAdvertiserInvoices?: Maybe<Scalars['Boolean']['output']>;
  /** Generate a new API token for a company. Requires admin access to the company. */
  createApiToken: CompanyApiToken;
  /** Create a custom user-defined assistant rule */
  createAssistantUserRule: AssistantRuleUser;
  /** Create a new billing contact for invoice communications. Requires admin access. */
  createBillingContact?: Maybe<BillingContact>;
  /** Create a new campaign with lead and order tracking events. Requires edit access. */
  createCampaign: Campaign;
  /** Create a new company (advertiser, publisher, agency, reseller, or trading desk). Requires edit access. Creating an agency requires SuperAdmin. */
  createCompany?: Maybe<Company>;
  /** Create a new ad position on a website. Requires edit access. */
  createPosition: Position;
  /** Create a new programmatic campaign. Requires edit access. */
  createProgrammaticCampaign: CampaignProgrammatic;
  /** Create an exclusion preset for a publisher or reseller. Requires publisher blacklist preset access. */
  createPublisherExclusionPreset: PublisherExclusionPreset;
  /** Generate publisher invoices for a completed billing period. Creates invoices for all publishers above minimum amount threshold. SuperAdmin or Reseller only. */
  createPublisherInvoices?: Maybe<Scalars['Boolean']['output']>;
  /** Create a new behavioral segment with rules defining user behavior criteria. Requires edit access to the campaign. */
  createSegmentBehavioural: SegmentBehavioural;
  /** Create a new CRM segment by uploading a file containing user emails or identifiers. Requires edit access to the campaign. */
  createSegmentCrm: SegmentCrm;
  /** Accept terms and conditions for the logged-in user's company. Creates a new acceptance record if version differs from current, otherwise returns existing acceptance. */
  createTermsAndCondition?: Maybe<TermsAndConditionApproval>;
  /** Create a new user. A provided password creates an active user; an omitted password creates a disabled user. Requires admin access to the company. */
  createUser?: Maybe<User>;
  /** Create a new website for a publisher. Requires edit access. */
  createWebsite?: Maybe<Website>;
  /** Deletes plans for an adgroup at a specified date. */
  deleteAdGroupBudgetPlan?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a directory preset, along with its items and any ad group selection of it. Requires advertiser directory preset access. */
  deleteAdGroupDirectoryPreset: Scalars['Boolean']['output'];
  /** Delete an ad template. Requires edit access to the position. */
  deleteAdTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a custom user-defined assistant rule */
  deleteAssistantUserRule: Scalars['Boolean']['output'];
  /** Delete a billing contact. Requires admin access. */
  deleteBillingContact?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a company webhook. Requires edit access. */
  deleteCompanyWebhook: Scalars['Boolean']['output'];
  /** Delete an exclusion preset. Requires publisher blacklist preset access. */
  deletePublisherExclusionPreset: Scalars['Boolean']['output'];
  /** Delete a behavioral segment. If segment is processing, marks as deleting. Requires edit access. */
  deleteSegmentBehavioural?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a CRM segment. If segment is processing, marks as deleting and triggers async deletion. Requires edit access. */
  deleteSegmentCrm?: Maybe<Scalars['Boolean']['output']>;
  /** Delete (deactivate) a user. Requires admin access. Users cannot delete themselves. */
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** Disable an assistant rule for a specific ad group. */
  disableAssistantRule: Scalars['Boolean']['output'];
  /**
   * Duplicate an existing ad copy with optional overrides and new image. Requires edit access.
   * @deprecated Use createAdCopies with an existing imageFilename instead.
   */
  duplicateAdCopy: AdCopy;
  /** Duplicate an existing ad template with a new name. Creates a copy with active status. Requires edit access to the position. */
  duplicateAdTemplate: AdTemplate;
  /** Enable a previously disabled assistant rule for a specific ad group. */
  enableAssistantRule: Scalars['Boolean']['output'];
  /** Import analytics statistics data for ad groups and ad copies. Validates ad group and ad copy existence before saving. Requires SuperAdmin role. */
  importAnalyticsData: Array<AnalyticsStat>;
  /** Invite a new user via email. User must accept invitation to activate account. Requires admin access. */
  inviteUser?: Maybe<User>;
  /** Authenticate a user with email and password. Returns JWT token and company slug. */
  login: LoginResult;
  /** For internal use only: Authenticate with Google OAuth and create a readonly API token. Token has read-only access regardless of user permissions. Returns JWT token and company slug. */
  loginApiWithGoogle: LoginResult;
  /** Authenticate a user with Google OAuth. Links Google account on first use. Returns JWT token and company slug. */
  loginWithGoogle: LoginResult;
  /** Record payment for a validated publisher invoice. Marks as paid if full amount, otherwise remains validated. Reseller only. Requires SuperAdmin permission. */
  paidPublisherInvoice?: Maybe<Scalars['Boolean']['output']>;
  /** Resend invitation email for a user with a pending invite. Requires admin access. */
  resendInvite?: Maybe<User>;
  /** Reset user password using a reset token received via email */
  resetPassword: Scalars['Boolean']['output'];
  /** Replace the set of directory presets selected by this ad group. Presets may be owned by the advertiser, its agency, its reseller, or Powerspace. Pass an empty list to deselect them all. Requires advertiser directory preset access. */
  selectAdGroupDirectoryPresets: Scalars['Boolean']['output'];
  /** Issue a read-only impersonation token for an active non-superadmin user. Requires the original superadmin token in the authorization header. */
  startImpersonation: ImpersonationTokenResult;
  /** Unassign an exclusion preset from a reseller or publisher. Requires publisher blacklist preset access. */
  unassignExclusionPresetFromCompany: Scalars['Boolean']['output'];
  /** Unassign an exclusion preset from a website. Requires publisher blacklist preset access. */
  unassignPublisherExclusionPresetFromWebsite: Scalars['Boolean']['output'];
  /** Update an existing ad copy including text fields, status, and optionally replace the image. Requires edit access. */
  updateAdCopy: AdCopy;
  /** Update only the status of an ad copy. Requires edit access. */
  updateAdCopyStatus: AdCopy;
  /** Update an existing ad group. Requires edit access. */
  updateAdGroup: AdGroup;
  /** Update ad group settings. SuperAdmin only. */
  updateAdGroupSettings: AdGroupSettings;
  /** Create a new plan to change the adgroups budget */
  updateAdGroupBudgetPlan?: Maybe<AdGroupBudgetPlan>;
  /** Update a directory preset. Pass the preset id and optional name and/or websites inventory. Omitting websites leaves them untouched, passing an empty list clears them. Requires advertiser directory preset access. */
  updateAdGroupDirectoryPreset: Scalars['Boolean']['output'];
  /** Set the IAB ad-product taxonomy of an ad group. Requires edit access. */
  updateAdGroupIabAdProduct: Scalars['Boolean']['output'];
  /** Update an existing banner ad template. Prevents deactivating the last active template. Requires edit access. */
  updateAdTemplateBanner: AdTemplateBanner;
  /** Update an existing native ad template including optional mobile version and background images. Prevents deactivating the last active template. Requires edit access. */
  updateAdTemplateNative: AdTemplateNative;
  /** Update an existing web ad template. Prevents deactivating the last active template. Requires edit access. */
  updateAdTemplateWeb: AdTemplateWeb;
  /** Update ad group targeting settings including demographics, devices, geo, and segments. Requires edit access. */
  updateAdgroupTargeting?: Maybe<Scalars['Boolean']['output']>;
  /** Update advertiser-specific settings such as agency association. SuperAdmin only. */
  updateAdvertiserSettings: AdvertiserSettings;
  /** Update agency-specific settings such as account and sales managers. SuperAdmin only. */
  updateAgencySettings: AgencySettings;
  /** Update auto-archive policy for a reseller, advertiser, or publisher. Requires Admin access. */
  updateArchiverConfig: ArchiverConfig;
  /** Update assistant rule configuration or toggle active state */
  updateAssistantRule: AssistantRuleOutput;
  /** Update an existing billing contact. Requires admin access. */
  updateBillingContact: BillingContact;
  /** Update an existing campaign. Requires edit access. */
  updateCampaign: Campaign;
  /** Requires Admin permission. */
  updateCompany: Company;
  /** Update company-wide feature permissions (e.g., web, banner, API access). SuperAdmin only. */
  updateCompanyPermissions: Company;
  /** Create or update a webhook URL for a company. Requires edit access. */
  updateCompanyWebhook: CompanyWebhook;
  /** Enable or disable demand sources (SSPs/DSPs) for a position. Requires edit access. */
  updateDemandSources?: Maybe<Scalars['Boolean']['output']>;
  /** Update bid adjustments for different device types (mobile, desktop, tablet). Requires edit access. */
  updateDeviceAdjustments: Scalars['Boolean']['output'];
  /** Replace the ad group directory with targeted or excluded websites/positions. Requires edit access. */
  updateDirectory: Scalars['Boolean']['output'];
  /** Update an existing ad position. Requires edit access. */
  updatePosition: Position;
  /** Update custom domain settings for a position. Requires edit access. */
  updatePositionCustomDomain?: Maybe<PositionCustomDomain>;
  /** Update ad zone configuration and template assignments for a position. Requires edit access. */
  updatePositionZones: Array<PositionZone>;
  /** Update the revenue share of multiple positions at once. SuperAdmin only. */
  updatePositionsRevenueShare: Scalars['Boolean']['output'];
  /** Update an existing programmatic campaign. Requires edit access. */
  updateProgrammaticCampaign: CampaignProgrammatic;
  /** Update the list of advertisers excluded from this publisher. Requires edit access. */
  updatePublisherAdvertiserExclusions: Scalars['Boolean']['output'];
  /** Update the list of campaigns excluded from this publisher. Requires edit access. */
  updatePublisherCampaignExclusions: Scalars['Boolean']['output'];
  /** Update the list of advertiser domains excluded from this publisher. Requires edit access. */
  updatePublisherDomainExclusions: Scalars['Boolean']['output'];
  /** Update an exclusion preset name and exclusion lists. Requires publisher blacklist preset access. */
  updatePublisherExclusionPreset: PublisherExclusionPreset;
  /** Update the list of IAB categories excluded from this publisher. Requires edit access. */
  updatePublisherIabExclusions: Scalars['Boolean']['output'];
  /** Update a publisher invoice by adding adjustment items (credits, discounts, etc.). Cannot update paid invoices. SuperAdmin or Reseller only. */
  updatePublisherInvoice?: Maybe<InvoicePublisher>;
  /** Update publisher-specific settings such as account and sales managers. SuperAdmin only. */
  updatePublisherSettings: PublisherSettings;
  /** Update advertiser exclusions for a reseller. Campaigns from excluded advertisers will not be shown. Requires edit access. */
  updateResellerAdvertiserExclusions: Scalars['Boolean']['output'];
  /** Update allowed banner sizes for a reseller. Requires SuperAdmin access. */
  updateResellerBannerSizes: Reseller;
  /** Update campaign exclusions for a reseller. Excluded campaigns will not be shown. Requires edit access. */
  updateResellerCampaignExclusions: Scalars['Boolean']['output'];
  /** Requires Edit permission. */
  updateResellerDomainExclusions: Scalars['Boolean']['output'];
  /** Requires Edit permission. */
  updateResellerIabExclusions: Scalars['Boolean']['output'];
  /** Requires Edit permission. */
  updateResellerPriorities: Scalars['Boolean']['output'];
  /** Update reseller-specific settings such as account and sales managers. SuperAdmin only. */
  updateResellerSettings: ResellerSettings;
  /** Update an existing behavioral segment including name, duration, archived status, and rules. Requires edit access. */
  updateSegmentBehavioural: SegmentBehavioural;
  /** Update an existing CRM segment (name and archived status). Requires edit access. */
  updateSegmentCrm: SegmentCrm;
  /** Update user profile. Users can edit their own profile or admins can edit any user in their company. */
  updateUser: User;
  /** Update user password. Users can only change their own password. */
  updateUserPassword: Scalars['Boolean']['output'];
  /** Update an existing website. Requires edit access. */
  updateWebsite: Website;
  /** Replace bid adjustments for specific websites/publishers. Requires edit access. */
  updateWebsiteAdjustments: Scalars['Boolean']['output'];
  /** Update the list of advertisers excluded from this website. Requires edit access. */
  updateWebsiteAdvertiserExclusions: Scalars['Boolean']['output'];
  /** Update the list of campaigns excluded from this website. Requires edit access. */
  updateWebsiteCampaignExclusions: Scalars['Boolean']['output'];
  /** Update the list of advertiser domains excluded from this website. Requires edit access. */
  updateWebsiteDomainExclusions: Scalars['Boolean']['output'];
  /** Change the IAB category of a website. Requires edit access. */
  updateWebsiteIabCategory: Website;
  /** Update the list of IAB categories excluded from this website. Requires edit access. */
  updateWebsiteIabExclusions: Scalars['Boolean']['output'];
  /** Validate a pending publisher invoice and send it via email. Changes status to validated. Reseller only. Requires SuperAdmin permission. */
  validatePublisherInvoice?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptInviteArgs = {
  acceptInvite: AcceptInviteInput;
};


export type MutationAddAdGroupTargetingAdressesArgs = {
  adGroupId: Scalars['PwsID']['input'];
  addresses: Array<Scalars['String']['input']>;
  clearPrevious?: Scalars['Boolean']['input'];
  radius?: Scalars['Int']['input'];
};


export type MutationAddToDirectoryArgs = {
  adGroupId: Scalars['PwsID']['input'];
  toAdd: Array<WebsiteDirectoryInput>;
};


export type MutationAddToWebsiteAdjustmentsArgs = {
  adGroupId: Scalars['PwsID']['input'];
  toAdd: Array<WebsiteAdjustmentInput>;
};


export type MutationArchiveAdvertiserArgs = {
  advertiserId: Scalars['PwsID']['input'];
};


export type MutationArchiveAgencyArgs = {
  agencyId: Scalars['PwsID']['input'];
};


export type MutationArchiveCampaignArgs = {
  campaignId: Scalars['PwsID']['input'];
};


export type MutationArchiveProgrammaticCampaignArgs = {
  campaignId: Scalars['PwsID']['input'];
};


export type MutationArchivePublisherArgs = {
  publisherId: Scalars['PwsID']['input'];
};


export type MutationArchiveResellerArgs = {
  resellerId: Scalars['PwsID']['input'];
};


export type MutationArchiveTradingDeskArgs = {
  tradingDeskId: Scalars['PwsID']['input'];
};


export type MutationArchiveWebsiteArgs = {
  websiteId: Scalars['PwsID']['input'];
};


export type MutationAskResetUserPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationAssignExclusionPresetToCompanyArgs = {
  companyId: Scalars['PwsID']['input'];
  presetId: Scalars['PwsID']['input'];
};


export type MutationAssignPublisherExclusionPresetToWebsiteArgs = {
  presetId: Scalars['PwsID']['input'];
  websiteId: Scalars['PwsID']['input'];
};


export type MutationCopyAdGroupArgs = {
  adGroupId: Scalars['PwsID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};


export type MutationCopyPositionArgs = {
  name: Scalars['String']['input'];
  positionId: Scalars['PwsID']['input'];
};


export type MutationCreateAdCopiesArgs = {
  adGroupId: Scalars['PwsID']['input'];
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  newAdCopies: Array<AdCopyCreateInput>;
};


export type MutationCreateAdGroupArgs = {
  newAdGroup: AdGroupCreateInput;
};


export type MutationCreateAdGroupBudgetPlanArgs = {
  plan: AdGroupBudgetPlanCreateInput;
};


export type MutationCreateAdGroupDirectoryPresetArgs = {
  companyId: Scalars['PwsID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateAdTemplateBannerArgs = {
  newAdTemplate: AdTemplateBannerCreateInput;
};


export type MutationCreateAdTemplateNativeArgs = {
  mobileBackground?: InputMaybe<Scalars['Upload']['input']>;
  newAdTemplate: AdTemplateNativeCreateInput;
  normalBackground?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateAdTemplateWebArgs = {
  newAdTemplate: AdTemplateWebCreateInput;
};


export type MutationCreateAdvertiserInvoicesArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationCreateApiTokenArgs = {
  companyId: Scalars['PwsID']['input'];
};


export type MutationCreateAssistantUserRuleArgs = {
  input: CreateAssistantUserRuleInput;
};


export type MutationCreateBillingContactArgs = {
  newBillingContact: BillingContactCreateInput;
};


export type MutationCreateCampaignArgs = {
  newCampaign: CampaignCreateInput;
};


export type MutationCreateCompanyArgs = {
  newCompany: CompanyCreateInput;
};


export type MutationCreatePositionArgs = {
  newPosition: PositionCreateInput;
};


export type MutationCreateProgrammaticCampaignArgs = {
  newCampaign: CampaignCreateInput;
};


export type MutationCreatePublisherExclusionPresetArgs = {
  companyId: Scalars['PwsID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreatePublisherInvoicesArgs = {
  minAmount: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationCreateSegmentBehaviouralArgs = {
  campaignId: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  rules: Array<SegmentBehaviouralRuleInput>;
};


export type MutationCreateSegmentCrmArgs = {
  campaignId: Scalars['PwsID']['input'];
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateTermsAndConditionArgs = {
  newTermsAndCondition: TermsAndConditionApprovalCreateInput;
};


export type MutationCreateUserArgs = {
  newUser: UserCreateInput;
};


export type MutationCreateWebsiteArgs = {
  newWebsite: WebsiteCreateInput;
};


export type MutationDeleteAdGroupBudgetPlanArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDeleteAdGroupDirectoryPresetArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDeleteAdTemplateArgs = {
  adTemplateId: Scalars['PwsID']['input'];
  positionId: Scalars['PwsID']['input'];
};


export type MutationDeleteAssistantUserRuleArgs = {
  ruleId: Scalars['PwsID']['input'];
};


export type MutationDeleteBillingContactArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDeleteCompanyWebhookArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDeletePublisherExclusionPresetArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDeleteSegmentBehaviouralArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDeleteSegmentCrmArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['PwsID']['input'];
};


export type MutationDisableAssistantRuleArgs = {
  adGroupId: Scalars['PwsID']['input'];
  ruleId: Scalars['PwsID']['input'];
};


export type MutationDuplicateAdCopyArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['PwsID']['input'];
  override: AdCopyDuplicateInput;
};


export type MutationDuplicateAdTemplateArgs = {
  adTemplateId: Scalars['PwsID']['input'];
  newName: Scalars['String']['input'];
  positionId: Scalars['PwsID']['input'];
};


export type MutationEnableAssistantRuleArgs = {
  adGroupId: Scalars['PwsID']['input'];
  ruleId: Scalars['PwsID']['input'];
};


export type MutationImportAnalyticsDataArgs = {
  analyticsData: Array<AnalayticsStatInput>;
  analyticsImportParameters?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationInviteUserArgs = {
  newUser: UserInviteInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe?: Scalars['Boolean']['input'];
};


export type MutationLoginApiWithGoogleArgs = {
  idToken: Scalars['String']['input'];
  rememberMe?: Scalars['Boolean']['input'];
};


export type MutationLoginWithGoogleArgs = {
  idToken: Scalars['String']['input'];
  rememberMe?: Scalars['Boolean']['input'];
};


export type MutationPaidPublisherInvoiceArgs = {
  amount: Scalars['Float']['input'];
  date: Scalars['DateTime']['input'];
  reference: Scalars['String']['input'];
};


export type MutationResendInviteArgs = {
  userId: Scalars['PwsID']['input'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};


export type MutationSelectAdGroupDirectoryPresetsArgs = {
  adGroupId: Scalars['PwsID']['input'];
  presetIds: Array<Scalars['PwsID']['input']>;
};


export type MutationStartImpersonationArgs = {
  userId: Scalars['PwsID']['input'];
};


export type MutationUnassignExclusionPresetFromCompanyArgs = {
  companyId: Scalars['PwsID']['input'];
  presetId: Scalars['PwsID']['input'];
};


export type MutationUnassignPublisherExclusionPresetFromWebsiteArgs = {
  presetId: Scalars['PwsID']['input'];
  websiteId: Scalars['PwsID']['input'];
};


export type MutationUpdateAdCopyArgs = {
  adCopy: AdCopyInput;
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationUpdateAdCopyStatusArgs = {
  adCopyId: Scalars['PwsID']['input'];
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  status: AdCopyStatus;
};


export type MutationUpdateAdGroupSettingsArgs = {
  adGroupId: Scalars['PwsID']['input'];
  settings: AdGroupSettingsInput;
};


export type MutationUpdateAdGroupArgs = {
  adGroup: AdGroupInput;
};


export type MutationUpdateAdGroupBudgetPlanArgs = {
  plan: AdGroupBudgetPlanUpdateInput;
};


export type MutationUpdateAdGroupDirectoryPresetArgs = {
  preset: AdGroupDirectoryPresetInput;
};


export type MutationUpdateAdGroupIabAdProductArgs = {
  adGroupId: Scalars['PwsID']['input'];
  iabId: Scalars['String']['input'];
};


export type MutationUpdateAdTemplateBannerArgs = {
  adTemplate: AdTemplateBannerInput;
};


export type MutationUpdateAdTemplateNativeArgs = {
  adTemplate: AdTemplateNativeInput;
  mobileBackground?: InputMaybe<Scalars['Upload']['input']>;
  normalBackground?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationUpdateAdTemplateWebArgs = {
  adTemplate: AdTemplateWebInput;
};


export type MutationUpdateAdgroupTargetingArgs = {
  adGroupId: Scalars['PwsID']['input'];
  targeting: AdGroupTargetingInput;
};


export type MutationUpdateAdvertiserSettingsArgs = {
  advertiserId: Scalars['PwsID']['input'];
  settings: AdvertiserSettingsInput;
};


export type MutationUpdateAgencySettingsArgs = {
  agencyId: Scalars['PwsID']['input'];
  settings: AgencySettingsInput;
};


export type MutationUpdateArchiverConfigArgs = {
  companyId: Scalars['PwsID']['input'];
  config: ArchiverConfigInput;
};


export type MutationUpdateAssistantRuleArgs = {
  input: UpdateAssistantRuleInput;
};


export type MutationUpdateBillingContactArgs = {
  billingContact: BillingContactInput;
};


export type MutationUpdateCampaignArgs = {
  campaign: CampaignInput;
};


export type MutationUpdateCompanyArgs = {
  company: CompanyInput;
};


export type MutationUpdateCompanyPermissionsArgs = {
  companyId: Scalars['PwsID']['input'];
  permissions: CompanyPermissionInput;
};


export type MutationUpdateCompanyWebhookArgs = {
  companyId: Scalars['PwsID']['input'];
  types: Array<CompanyWebhookType>;
  url: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateDemandSourcesArgs = {
  demandSources: Array<DemandSourceInput>;
  positionId: Scalars['PwsID']['input'];
};


export type MutationUpdateDeviceAdjustmentsArgs = {
  adGroupId: Scalars['PwsID']['input'];
  adjustments: Array<AdGroupDeviceAdjustmentInput>;
};


export type MutationUpdateDirectoryArgs = {
  adGroupId: Scalars['PwsID']['input'];
  directory: Array<WebsiteDirectoryInput>;
  type: DirectoryType;
};


export type MutationUpdatePositionArgs = {
  position: PositionInput;
};


export type MutationUpdatePositionCustomDomainArgs = {
  customDomain?: InputMaybe<Scalars['String']['input']>;
  positionId: Scalars['PwsID']['input'];
};


export type MutationUpdatePositionZonesArgs = {
  positionId: Scalars['PwsID']['input'];
  zones: Array<PositionZoneInput>;
};


export type MutationUpdatePositionsRevenueShareArgs = {
  positionIds: Array<Scalars['PwsID']['input']>;
  revenueShare: Scalars['Float']['input'];
};


export type MutationUpdateProgrammaticCampaignArgs = {
  campaign: CampaignProgrammaticInput;
};


export type MutationUpdatePublisherAdvertiserExclusionsArgs = {
  advertiserExclusions: Array<Scalars['PwsID']['input']>;
  publisherId: Scalars['PwsID']['input'];
};


export type MutationUpdatePublisherCampaignExclusionsArgs = {
  campaignExclusions: Array<Scalars['PwsID']['input']>;
  publisherId: Scalars['PwsID']['input'];
};


export type MutationUpdatePublisherDomainExclusionsArgs = {
  domainExclusions: Array<Scalars['LimitedString']['input']>;
  publisherId: Scalars['PwsID']['input'];
};


export type MutationUpdatePublisherExclusionPresetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  excludedCampaignIds: Array<Scalars['PwsID']['input']>;
  excludedCompanyIds: Array<Scalars['PwsID']['input']>;
  excludedIABCategories: Array<Iab>;
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdatePublisherIabExclusionsArgs = {
  iabExclusions: Array<Iab>;
  publisherId: Scalars['PwsID']['input'];
};


export type MutationUpdatePublisherInvoiceArgs = {
  adjustments: Array<InvoiceAdjustmentItemInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};


export type MutationUpdatePublisherSettingsArgs = {
  publisherId: Scalars['PwsID']['input'];
  settings: PublisherSettingsInput;
};


export type MutationUpdateResellerAdvertiserExclusionsArgs = {
  advertiserExclusions: Array<Scalars['PwsID']['input']>;
  resellerId: Scalars['PwsID']['input'];
};


export type MutationUpdateResellerBannerSizesArgs = {
  bannerSizes: Array<SizeInput>;
  resellerId: Scalars['PwsID']['input'];
};


export type MutationUpdateResellerCampaignExclusionsArgs = {
  campaignExclusions: Array<Scalars['PwsID']['input']>;
  resellerId: Scalars['PwsID']['input'];
};


export type MutationUpdateResellerDomainExclusionsArgs = {
  domainExclusions: Array<Scalars['LimitedString2']['input']>;
  resellerId: Scalars['PwsID']['input'];
};


export type MutationUpdateResellerIabExclusionsArgs = {
  iabExclusions: Array<Iab>;
  resellerId: Scalars['PwsID']['input'];
};


export type MutationUpdateResellerPrioritiesArgs = {
  priorities: Array<AdPriorityInput>;
  resellerId: Scalars['PwsID']['input'];
};


export type MutationUpdateResellerSettingsArgs = {
  resellerId: Scalars['PwsID']['input'];
  settings: ResellerSettingsInput;
};


export type MutationUpdateSegmentBehaviouralArgs = {
  rules: Array<SegmentBehaviouralRuleInput>;
  segment: SegmentBehaviouralInput;
};


export type MutationUpdateSegmentCrmArgs = {
  segment: SegmentCrmInput;
};


export type MutationUpdateUserArgs = {
  user: UserInput;
};


export type MutationUpdateUserPasswordArgs = {
  newPassword: Scalars['Password']['input'];
  user: UserInput;
};


export type MutationUpdateWebsiteArgs = {
  website: WebsiteInput;
};


export type MutationUpdateWebsiteAdjustmentsArgs = {
  adGroupId: Scalars['PwsID']['input'];
  adjustments: Array<WebsiteAdjustmentInput>;
};


export type MutationUpdateWebsiteAdvertiserExclusionsArgs = {
  advertiserExclusions: Array<Scalars['PwsID']['input']>;
  websiteId: Scalars['PwsID']['input'];
};


export type MutationUpdateWebsiteCampaignExclusionsArgs = {
  campaignExclusions: Array<Scalars['PwsID']['input']>;
  websiteId: Scalars['PwsID']['input'];
};


export type MutationUpdateWebsiteDomainExclusionsArgs = {
  domainExclusions: Array<Scalars['LimitedString3']['input']>;
  websiteId: Scalars['PwsID']['input'];
};


export type MutationUpdateWebsiteIabCategoryArgs = {
  iabCategory: Iab;
  websiteId: Scalars['PwsID']['input'];
};


export type MutationUpdateWebsiteIabExclusionsArgs = {
  iabExclusions: Array<Iab>;
  websiteId: Scalars['PwsID']['input'];
};


export type MutationValidatePublisherInvoiceArgs = {
  reference: Scalars['String']['input'];
};

/** The network types */
export enum Network {
  Ecommerce = 'Ecommerce',
  Eshopper = 'Eshopper',
  Media = 'Media'
}

export type OsTargeting = {
  exclusive: Scalars['Boolean']['output'];
  type: Array<OsType>;
};

export type OsTargetingInput = {
  exclusive?: Scalars['Boolean']['input'];
  type?: Array<OsType>;
};

/** Operating system for targeting (macOS, Windows, iOS, Android, unknown) */
export enum OsType {
  Android = 'Android',
  Ios = 'Ios',
  Macos = 'Macos',
  Unknown = 'Unknown',
  Windows = 'Windows'
}

export type Pagination = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** Payment details for an invoice */
export type Paid = {
  amount: Scalars['Float']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
};

export type PartialCompany = {
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: CompanyType;
};

export type PartialUser = {
  /** The company this user belongs to */
  company: PartialCompany;
  firstName: Scalars['String']['output'];
  id: Scalars['PwsID']['output'];
  lastName: Scalars['String']['output'];
};

export type PasswordAlert = {
  /** Days remaining before password expiry. Zero when expired. Null when password lifetime is disabled. */
  daysRemaining?: Maybe<Scalars['Int']['output']>;
  /** When the current password expires. Null when password lifetime is disabled. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** When true, the user must update their password before using the application. */
  mustChangePassword: Scalars['Boolean']['output'];
};

export type PasswordSettings = {
  maxLength: Scalars['Int']['output'];
  /** Maximum password age in days. Zero disables password expiry. */
  maxLifetimeDays: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
  requireLowercase: Scalars['Boolean']['output'];
  requireNumber: Scalars['Boolean']['output'];
  requireSpecial: Scalars['Boolean']['output'];
  requireUppercase: Scalars['Boolean']['output'];
};

/** Payment terms in ISO8601 duration format (P15D = 15 days, P30D = 30 days, etc.) */
export enum PaymentTerm {
  P15D = 'P15D',
  P30D = 'P30D',
  P45D = 'P45D',
  P60D = 'P60D'
}

export type Position = {
  acceptEditorial: Scalars['Boolean']['output'];
  acceptPromotional: Scalars['Boolean']['output'];
  /** Ad templates that can serve in this position */
  adTemplates: Array<AdTemplate>;
  biddingStrategy: BiddingStrategy;
  channelType: ChannelType;
  /** Minimum CPM floor price for bids on this position */
  cpmFloor?: Maybe<Scalars['Float']['output']>;
  customDomain?: Maybe<PositionCustomDomain>;
  /** Programmatic deal ID for private marketplace transactions */
  dealId?: Maybe<Scalars['String']['output']>;
  /** Demand sources (SSPs/DSPs) enabled for this position */
  demandSources: Array<DemandSource>;
  iabCategory?: Maybe<Iab>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Number of ad zones available in this position for multi-zone placements */
  nbZone: Scalars['Int']['output'];
  network: Network;
  /** Fallback image URL to display when no ad is available */
  passbackImage?: Maybe<Scalars['String']['output']>;
  /** Fallback JavaScript code to execute when no ad is available */
  passbackJs?: Maybe<Scalars['String']['output']>;
  /** Fallback URL to redirect to when no ad is available */
  passbackLink?: Maybe<Scalars['String']['output']>;
  /** Position performance stats with totals-only ad template breakdowns. */
  performanceStats: PositionPerformanceStats;
  /** Audience demographics and population statistics for this position */
  population: PublisherPopulation;
  positionType?: Maybe<PositionType>;
  /** Revenue share percentage for the publisher (0-1 range) */
  revenueShare: Scalars['Float']['output'];
  shortCode: Scalars['String']['output'];
  /** Supply-side platform (SSP) identifier for programmatic ad delivery */
  sspId?: Maybe<Scalars['Int']['output']>;
  status: Status;
  subchannelType: SubChannelType;
  /** Time-series revenue metrics for this position over a date range */
  timeseries: PublisherTimeseriesTotal;
  website: Website;
  /** Ad zones configured for this position with their assigned templates */
  zones: Array<PositionZone>;
};


export type PositionAdTemplatesArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery?: InputMaybe<AdTemplateSearchQuery>;
};


export type PositionPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type PositionTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type PositionAdjustment = {
  channelType: ChannelType;
  iabCategory?: Maybe<Iab>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Actual applied bid adjustment percentage after validation */
  realAdjustment?: Maybe<Scalars['Percentage']['output']>;
  /** Desired bid adjustment percentage for this position */
  wantedAdjustment?: Maybe<Scalars['Percentage']['output']>;
};

export type PositionAdjustmentInput = {
  channelType: ChannelType;
  iabCategory?: InputMaybe<Iab>;
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  /** Actual applied bid adjustment percentage after validation */
  realAdjustment?: InputMaybe<Scalars['Percentage']['input']>;
  /** Desired bid adjustment percentage for this position */
  wantedAdjustment?: InputMaybe<Scalars['Percentage']['input']>;
};

export type PositionConfig = {
  zones: Scalars['Int']['output'];
};

export type PositionCreateInput = {
  channelType: ChannelType;
  cpmFloor?: InputMaybe<Scalars['Float']['input']>;
  iabCategory?: InputMaybe<Iab>;
  name: Scalars['String']['input'];
  /** Number of ad zones available in this position for multi-zone placements */
  nbZone: Scalars['Int']['input'];
  network: Network;
  positionType?: InputMaybe<PositionType>;
  /** Revenue share percentage for the publisher (0-1 range) */
  revenueShare: Scalars['Float']['input'];
  subchannelType: SubChannelType;
  websiteId: Scalars['PwsID']['input'];
};

export type PositionCustomDomain = {
  createdAt: Scalars['DateTime']['output'];
  creationProgress: SslCreationProgress;
  domain: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  sslStatus: SslStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Ad position summary with basic info and impression metrics for directory listings */
export type PositionDirectory = {
  adTemplateSizes?: Maybe<Array<AdTemplateImageSize>>;
  channelType: ChannelType;
  iabCategory?: Maybe<Iab>;
  id: Scalars['PwsID']['output'];
  /** Total impression count for this position. Only visible to super admins. */
  impressions: Scalars['Float']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PositionDirectoryInput = {
  channelType: ChannelType;
  iabCategory?: InputMaybe<Iab>;
  id: Scalars['PwsID']['input'];
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type PositionInput = {
  acceptEditorial?: Scalars['Boolean']['input'];
  acceptPromotional?: Scalars['Boolean']['input'];
  biddingStrategy?: BiddingStrategy;
  channelType?: ChannelType;
  /** Minimum CPM floor price for bids on this position */
  cpmFloor?: InputMaybe<Scalars['Float']['input']>;
  /** Programmatic deal ID for private marketplace transactions */
  dealId?: InputMaybe<Scalars['String']['input']>;
  iabCategory?: InputMaybe<Iab>;
  id?: Scalars['PwsID']['input'];
  name?: Scalars['String']['input'];
  /** Number of ad zones available in this position for multi-zone placements */
  nbZone?: Scalars['Int']['input'];
  network?: Network;
  /** Fallback image URL to display when no ad is available */
  passbackImage?: InputMaybe<Scalars['String']['input']>;
  /** Fallback JavaScript code to execute when no ad is available */
  passbackJs?: InputMaybe<Scalars['String']['input']>;
  /** Fallback URL to redirect to when no ad is available */
  passbackLink?: InputMaybe<Scalars['String']['input']>;
  positionType?: InputMaybe<PositionType>;
  /** Revenue share percentage for the publisher (0-1 range) */
  revenueShare?: Scalars['Float']['input'];
  shortCode?: Scalars['String']['input'];
  /** Supply-side platform (SSP) identifier for programmatic ad delivery */
  sspId?: InputMaybe<Scalars['Int']['input']>;
  status?: Status;
  subchannelType?: SubChannelType;
};

export type PositionMinMaxConfig = {
  max: PositionConfig;
  min: PositionConfig;
};

export type PositionPerformanceStats = {
  adTemplates: Array<AdTemplateWithPerformance>;
  advertiserResellers: Array<PublisherResellerCost>;
  devices: Array<PublisherDeviceCost>;
  stats: PublisherCostDetails;
  zones: Array<PublisherZoneCost>;
};

/** Search criteria for filtering ad positions */
export type PositionSearchQuery = {
  /** Filter positions by channel type (Email/Web) */
  channelType?: InputMaybe<ChannelType>;
  /** Filter positions by IAB category */
  iabCategory?: InputMaybe<Iab>;
  /** Filter positions by market ID */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Filter positions by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter positions by network type */
  network?: InputMaybe<Network>;
  /** Filter positions by reseller ID */
  resellerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter positions by status */
  status?: InputMaybe<Array<Status>>;
  /** Filter positions by subchannel type */
  subchannelType?: InputMaybe<SubChannelType>;
};

/** Visual placement type on web pages (in content, in feed, recommendation widget, side content) */
export enum PositionType {
  InContent = 'InContent',
  InFeed = 'InFeed',
  RecommandationWidget = 'RecommandationWidget',
  SideContent = 'SideContent'
}

export type PositionWithPerformance = {
  acceptEditorial: Scalars['Boolean']['output'];
  acceptPromotional: Scalars['Boolean']['output'];
  adTemplates: Array<AdTemplateWithPerformance>;
  biddingStrategy: BiddingStrategy;
  channelType: ChannelType;
  /** Minimum CPM floor price for bids on this position */
  cpmFloor?: Maybe<Scalars['Float']['output']>;
  customDomain?: Maybe<PositionCustomDomain>;
  /** Programmatic deal ID for private marketplace transactions */
  dealId?: Maybe<Scalars['String']['output']>;
  /** Demand sources (SSPs/DSPs) enabled for this position */
  demandSources: Array<DemandSource>;
  iabCategory?: Maybe<Iab>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Number of ad zones available in this position for multi-zone placements */
  nbZone: Scalars['Int']['output'];
  network: Network;
  /** Fallback image URL to display when no ad is available */
  passbackImage?: Maybe<Scalars['String']['output']>;
  /** Fallback JavaScript code to execute when no ad is available */
  passbackJs?: Maybe<Scalars['String']['output']>;
  /** Fallback URL to redirect to when no ad is available */
  passbackLink?: Maybe<Scalars['String']['output']>;
  /** Position performance stats with totals-only ad template breakdowns. */
  performanceStats: PositionPerformanceStats;
  /** Audience demographics and population statistics for this position */
  population: PublisherPopulation;
  positionType?: Maybe<PositionType>;
  /** Revenue share percentage for the publisher (0-1 range) */
  revenueShare: Scalars['Float']['output'];
  shortCode: Scalars['String']['output'];
  /** Supply-side platform (SSP) identifier for programmatic ad delivery */
  sspId?: Maybe<Scalars['Int']['output']>;
  stats: PublisherCostDetails;
  status: Status;
  subchannelType: SubChannelType;
  /** Time-series revenue metrics for this position over a date range */
  timeseries: PublisherTimeseriesTotal;
  website: Website;
  /** Ad zones configured for this position with their assigned templates */
  zones: Array<PositionZone>;
};


export type PositionWithPerformancePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


export type PositionWithPerformanceTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type PositionZone = {
  /** Ad templates assigned to this zone */
  templates: PositionZoneTemplate;
  /** Zone number within the position (1-based index) */
  zone: Scalars['Int']['output'];
};

export type PositionZoneInput = {
  templates: PositionZoneTemplateInput;
  /** Zone number within the position (1-based index) */
  zone: Scalars['Int']['input'];
};

export type PositionZoneTemplate = {
  banners?: Maybe<Array<AdTemplateBanner>>;
  natives?: Maybe<Array<AdTemplateNative>>;
};

export type PositionZoneTemplateInput = {
  bannerId?: InputMaybe<Scalars['PwsID']['input']>;
  nativeId?: InputMaybe<Scalars['PwsID']['input']>;
};

/** Budget and performance data for Powerspace, including global aggregates and per-ad-group breakdowns */
export type PowerspaceBudgets = {
  adGroups: Array<AdGroupBudget>;
  global: Array<GlobalBudgets>;
};

/** Demand source metrics showing impressions by publisher and advertiser reseller combinations */
export type PowerspaceDemandSources = {
  advertiserResellerId?: Maybe<Scalars['PwsID']['output']>;
  advertiserResellerName?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  impressions: Scalars['BigInt']['output'];
  publisherResellerId: Scalars['PwsID']['output'];
  publisherResellerName: Scalars['String']['output'];
};

/** Profile tag for audience targeting based on user attributes from external data sources */
export type ProfileTag = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Data source or provider of this profile tag */
  origin: Scalars['String']['output'];
  /** Number of user profiles with this tag */
  profileCount: Scalars['Int']['output'];
};

/** Publisher company that provides ad inventory through websites and ad positions */
export type Publisher = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** List of specific advertisers excluded from running on this publisher, with creation date */
  advertiserExclusions: Array<AdvertiserExclusionItem>;
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  /** Auto-archive policy for inactive inventory (stored config, not resolved against parent) */
  archiverConfig: ArchiverConfig;
  /** Exclusion presets assigned to this publisher */
  assignedExclusionPresets: Array<PublisherExclusionPreset>;
  /** Exclusion presets available for this publisher: owned by the publisher, its reseller, and Powerspace when the current user is from Powerspace */
  availableExclusionPresets: Array<PublisherExclusionPreset>;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  /** List of specific campaigns excluded from running on this publisher, with creation date */
  campaignExclusions: Array<CampaignExclusionItem>;
  city?: Maybe<Scalars['String']['output']>;
  /** Configuration settings for this publisher (template limits, formats, etc.) */
  config: PublisherConfig;
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Country where this company is registered */
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  /** List of excluded advertiser domains that cannot run on this publisher, with creation date */
  domainExclusions: Array<DomainExclusionItem>;
  /** Exclusion presets owned by this publisher */
  exclusionPresets: Array<PublisherExclusionPreset>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  /** List of excluded IAB categories that cannot run on this publisher, with creation date */
  iabExclusions: Array<IabExclusionItem>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  /** Publisher performance stats with full publisher details and totals-only website/position/ad template breakdowns. */
  performanceStats: PublisherPerformanceStats;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  /** Audience demographics and population statistics for this publisher */
  population: PublisherPopulation;
  registrationId?: Maybe<Scalars['String']['output']>;
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  slug: Scalars['String']['output'];
  status: Status;
  /** Branding and styling configuration for this company's reseller */
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** Time-series revenue metrics for this publisher over a date range */
  timeseries: PublisherTimeseriesTotal;
  /** The type of the company */
  type: CompanyType;
  /** Current user permissions for this publisher (read, edit, admin) */
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  /** Websites belonging to this publisher */
  websites: Array<Website>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


/** Publisher company that provides ad inventory through websites and ad positions */
export type PublisherPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Publisher company that provides ad inventory through websites and ad positions */
export type PublisherTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type PublisherAdvertiserCost = {
  campaigns: Array<PublisherCampaignCost>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  stats: PublisherCostDetails;
};

export type PublisherCampaignCost = {
  id?: Maybe<Scalars['PwsID']['output']>;
  name: Scalars['String']['output'];
  stats: PublisherCostDetails;
};

export type PublisherConfig = {
  adTemplate: AdTemplateMinMaxConfig;
  global: GlobalConfig;
  position: PositionMinMaxConfig;
  revShare: Scalars['Int']['output'];
};

export type PublisherCostDetails = {
  clicks: Scalars['BigInt']['output'];
  commissions: Scalars['Float']['output'];
  cpc: Scalars['Float']['output'];
  cpm: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  displays: Scalars['BigInt']['output'];
  impressions: Scalars['BigInt']['output'];
  leads: Scalars['BigInt']['output'];
  rpm: Scalars['Float']['output'];
};

export type PublisherDeviceCost = {
  name: Scalars['String']['output'];
  stats: PublisherCostDetails;
};

/** A preset for site level exclusions */
export type PublisherExclusionPreset = {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Excluded companies for this preset */
  excludedCampaigns: Array<Campaign>;
  /** Excluded companies for this preset */
  excludedCompanies: Array<Company>;
  /** Excluded companies for this preset */
  excludedIABCategories: Array<Iab>;
  id: Scalars['PwsID']['output'];
  /** Name of this preset */
  name: Scalars['String']['output'];
  /** Company that owns this exclusion preset */
  owner: Company;
  updatedAt: Scalars['DateTime']['output'];
};

export type PublisherPerformanceStats = {
  advertiserResellers: Array<PublisherResellerCost>;
  devices: Array<PublisherDeviceCost>;
  stats: PublisherCostDetails;
  websites: Array<WebsiteWithPerformance>;
  zones: Array<PublisherZoneCost>;
};

export type PublisherPopulation = {
  ageRange: Array<PublisherPopulationGroup>;
  deviceType: Array<PublisherPopulationGroup>;
  gender: Array<PublisherPopulationGroup>;
  os: Array<PublisherPopulationGroup>;
};

export type PublisherPopulationGroup = {
  clicks: Scalars['Int']['output'];
  conversions: Scalars['Int']['output'];
  impressions: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  revenues: Scalars['Float']['output'];
};

export type PublisherResellerCost = {
  advertisers: Array<PublisherAdvertiserCost>;
  name: Scalars['String']['output'];
  stats: PublisherCostDetails;
};

/** Publisher-specific settings (SuperAdmin only) */
export type PublisherSettings = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
};

export type PublisherSettingsInput = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: InputMaybe<Scalars['PwsID']['input']>;
};

export type PublisherTimeseriesCost = {
  date: Scalars['DateTime']['output'];
  stats: PublisherCostDetails;
};

export type PublisherTimeseriesTotal = {
  stats: PublisherCostDetails;
  timeseries: Array<PublisherTimeseriesCost>;
};

export type PublisherWithPerformance = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  slug: Scalars['String']['output'];
  stats: PublisherCostDetails;
  status: Status;
  /** Branding and styling configuration for this company's reseller */
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** The type of the company */
  type: CompanyType;
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  websites: Array<WebsiteWithPerformance>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PublisherZoneCost = {
  name: Scalars['String']['output'];
  stats: PublisherCostDetails;
};

export type Query = {
  /** Get an account (user) by ID. Requires read access or must be the same user. Aggregates advertiser data for Powerspace accounts. */
  account: User;
  /** Loads the ad copies needed by analytics import tooling for an advertiser, with lifetime and imported analytics statistics preloaded in batches. Requires SuperAdmin. */
  adCopiesForAnalyticsImport: Array<AdCopyForAnalyticsImport>;
  /** Get a single ad copy by ID. Requires read access to the advertiser. */
  adCopy: AdCopy;
  /** Get the minimum image size requirements for ad copies based on reseller configuration */
  adCopyMinSize: Size;
  /** Get a single ad group by ID. Requires read access to the advertiser. */
  adGroup: AdGroup;
  /** Ad group budget and cost values over the last days, reconstructed from the activity feed. Day and hour boundaries follow the timezone of the campaign market. One entry is returned per hour during which a value changed, dated at the exact moment of the last change of that hour and holding the complete state it left; hours without a change are not returned. An ad group created before the period also gets an initial entry, at the start of its first day, holding the values it opened with. */
  adGroupBudgetHistory: Array<AdGroupBudgetHistory>;
  /** List directory presets for a company. Requires advertiser directory preset access. For an advertiser, includes advertiser, agency, and reseller presets. Powerspace presets are included only for Powerspace users. For a reseller or agency, returns only presets owned by that company. */
  adGroupDirectoryPresets: Array<AdGroupDirectoryPreset>;
  /** Generate visual previews of how active ad copies will appear in a specific position */
  adGroupPreview: Array<AdCopyPreview>;
  /** Get a single ad template by ID. Returns banner, native, or web template based on position channel type. Requires read access to the position. */
  adTemplate: AdTemplate;
  /** Get maximum image dimensions allowed for ad templates based on reseller configuration */
  adTemplateImageMaxSize: Size;
  /** Requires Edit permission. */
  adTemplateNativePreview?: Maybe<Scalars['String']['output']>;
  /** Get an advertiser by slug or ID. Requires read access to the advertiser. */
  advertiser: Advertiser;
  /** Get an advertiser invoice by reference. Requires admin access to the advertiser. */
  advertiserInvoice: InvoiceAdvertiser;
  /** Get an agency by slug or ID. Requires read access to the agency. */
  agency: Agency;
  /** Loads frontend parameters used to decode the latest analytics import advertiser file. Requires SuperAdmin. */
  analyticsImportParameters?: Maybe<Scalars['JSON']['output']>;
  /** Ask LLM service about titles, keywords, description, cta. Requires AI assistant access. */
  askAdgroupSuggestions: AdGroupLlmSuggestion;
  /** Get available AssistantRule user-condition properties and their allowed operators */
  assistantRuleConditionProperties: Array<AssistantRuleConditionPropertyConfig>;
  /** Get all assistant rules for a reseller */
  assistantRules: Array<AssistantRuleOutput>;
  /** Get list of valid banner sizes for a reseller */
  bannerSizes: Array<Size>;
  /** Get a single campaign by ID. Requires read access to the advertiser. */
  campaign: Campaign;
  /** Get a single programmatic campaign by ID. Requires read access to the advertiser. */
  campaignProgrammatic: CampaignProgrammatic;
  /** Get a company by slug or ID. Requires read access to the company. */
  company: Company;
  /** Check whether a company already exists for the given name, reseller, and optional agency. Uses the same slug derivation and prefix rules as createCompany. Requires edit access on the reseller. */
  companyExists: Scalars['Boolean']['output'];
  /** Get a company from Copper CRM by id. Requires SuperAdmin permission. */
  copperCompany: CopperCompany;
  getCountries: Array<Country>;
  /** Get list of available fonts for native ad template text elements */
  getFontList: Array<Scalars['String']['output']>;
  getInvalidFlatrecordStats: Array<InvalidFlatrecordStat>;
  getLanguages: Array<Language>;
  /** Get a single inventory item by ID. Requires read access to the advertiser. */
  inventory: Inventory;
  me: User;
  /** Password expiry alert for the logged-in user. */
  passwordAlert: PasswordAlert;
  /** Password policy for signup, invite, reset, and change-password screens. */
  passwordSettings: PasswordSettings;
  /** Get a single ad position by ID. Requires read access to the publisher. */
  position: Position;
  /** Get the Powerspace reseller. Only accessible to users belonging to Powerspace (company ID 1). */
  powerspace: Reseller;
  profileTagOrigins: Array<Scalars['String']['output']>;
  /** Get a publisher by slug or ID. Requires read access to the publisher. */
  publisher: Publisher;
  /** Fetch an exclusion preset by id */
  publisherExclusionPreset: PublisherExclusionPreset;
  /** Get a publisher invoice by reference. Requires admin access to the publisher. */
  publisherInvoice: InvoicePublisher;
  /** Get a reseller by slug or ID. Requires read access or must be the same reseller. */
  reseller: Reseller;
  /** Search activity feed entries with filtering by company, entity type, user, and pagination. Results are restricted to companies the user has access to. */
  searchActivityFeed: Array<ActivityFeed>;
  /** Search activity feed entries grouped by entity and property with filtering by company, entity type, user, and pagination. Results are restricted to companies the user has access to. */
  searchActivityFeedGrouped: Array<ActivityFeedGroup>;
  /** Search ad copies with optional status and account manager filters */
  searchAdCopies: Array<AdCopy>;
  searchAdGroups: Array<AdGroup>;
  /** Search for advertiser invoices with filtering and pagination. Requires admin access to advertisers. */
  searchAdvertiserInvoices: Array<InvoiceAdvertiser>;
  searchAdvertisers: Array<Advertiser>;
  searchCampaigns: Array<Campaign>;
  /** Search for companies (advertisers, publishers, agencies) with filtering and pagination */
  searchCompanies: Array<Company>;
  /** Search companies in Copper CRM. Requires SuperAdmin permission. */
  searchCopperCompanies: Array<CopperCompany>;
  /** Search opportunities in Copper CRM. Requires SuperAdmin permission. */
  searchCopperOpportunities: Array<CopperOpportunity>;
  /** Search for websites/positions included in the ad group directory (targeted or excluded) */
  searchInDirectory: Array<WebsiteDirectory>;
  /** Search for markets with filtering by country and/or language */
  searchMarkets: Array<Market>;
  /** Search for available websites/positions NOT in the ad group directory */
  searchOutsideDirectory: Array<WebsiteDirectory>;
  searchPositions: Array<Position>;
  /** Search for programmatic campaigns with filtering and pagination */
  searchProgrammaticCampaigns: Array<CampaignProgrammatic>;
  /** Search for publisher invoices with filtering and pagination. Requires admin access to publishers. */
  searchPublisherInvoices: Array<InvoicePublisher>;
  /** Search Mailjet send records. Provide recipientEmail and/or invoiceReference. Invoice filter requires super-admin on the publisher; recipient filter requires reseller admin. */
  searchSentEmails: Array<SentEmail>;
  /** Search for profile tags by name with optional origin filtering and pagination */
  searchTags: Array<ProfileTag>;
  /** Search for users with filtering and pagination */
  searchUsers: Array<User>;
  searchWebsites: Array<Website>;
  /** Get a behavioral segment by ID */
  segmentBehavioural: SegmentBehavioural;
  /** Get a CRM segment by ID. Requires read access to the campaign. */
  segmentCrm: SegmentCrm;
  /** Calculate estimated reach and cost for proposed targeting settings in a market before saving. Requires cost history access. */
  simulateReach: AdGroupTargetingReach;
  tags: Array<ProfileTag>;
  /** Calculate estimated reach and cost for proposed targeting settings before saving */
  targetingReach: AdGroupTargetingReach;
  /** Get a trading desk by slug or ID. Requires read access to the trading desk. */
  tradingDesk: TradingDesk;
  /** Get a user by email or ID. Requires admin access or must be the same user. */
  user: User;
  /** Check whether a user already exists for the given email. Requires admin access. */
  userExists: Scalars['Boolean']['output'];
  /** Sample webhook payloads for each available event type. */
  webhookExample: Array<WebhookExample>;
  /** Get a single website by ID */
  website: Website;
};


export type QueryAccountArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryAdCopiesForAnalyticsImportArgs = {
  advertiserId: Scalars['PwsID']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryAdCopyArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryAdCopyMinSizeArgs = {
  reseller: Scalars['PwsID']['input'];
};


export type QueryAdGroupArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryAdGroupBudgetHistoryArgs = {
  adGroupId: Scalars['PwsID']['input'];
  days: Scalars['Int']['input'];
};


export type QueryAdGroupDirectoryPresetsArgs = {
  companyId: Scalars['PwsID']['input'];
};


export type QueryAdGroupPreviewArgs = {
  adGroupId: Scalars['PwsID']['input'];
  positionId: Scalars['PwsID']['input'];
};


export type QueryAdTemplateArgs = {
  id: Scalars['PwsID']['input'];
  positionId: Scalars['PwsID']['input'];
};


export type QueryAdTemplateImageMaxSizeArgs = {
  reseller: Scalars['PwsID']['input'];
};


export type QueryAdTemplateNativePreviewArgs = {
  advertisement?: InputMaybe<Scalars['PwsID']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  template: ImageTemplateDescriptorInput;
};


export type QueryAdvertiserArgs = {
  id?: InputMaybe<Scalars['PwsID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvertiserInvoiceArgs = {
  reference: Scalars['String']['input'];
};


export type QueryAgencyArgs = {
  id?: InputMaybe<Scalars['PwsID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsImportParametersArgs = {
  advertiserId: Scalars['PwsID']['input'];
};


export type QueryAskAdgroupSuggestionsArgs = {
  adGroupId: Scalars['PwsID']['input'];
  languageOutput: Scalars['String']['input'];
  userInstructions: Scalars['String']['input'];
};


export type QueryAssistantRulesArgs = {
  resellerId: Scalars['PwsID']['input'];
};


export type QueryBannerSizesArgs = {
  resellerId?: InputMaybe<Scalars['PwsID']['input']>;
};


export type QueryCampaignArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryCampaignProgrammaticArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryCompanyArgs = {
  id?: InputMaybe<Scalars['PwsID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyExistsArgs = {
  agencyId?: InputMaybe<Scalars['PwsID']['input']>;
  name: Scalars['String']['input'];
  resellerId: Scalars['PwsID']['input'];
};


export type QueryCopperCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetInvalidFlatrecordStatsArgs = {
  adGroupId: Scalars['PwsID']['input'];
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryInventoryArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryPositionArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryPublisherArgs = {
  id?: InputMaybe<Scalars['PwsID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublisherExclusionPresetArgs = {
  id: Scalars['PwsID']['input'];
};


export type QueryPublisherInvoiceArgs = {
  reference: Scalars['InvoiceReference']['input'];
};


export type QueryResellerArgs = {
  id?: InputMaybe<Scalars['PwsID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchActivityFeedArgs = {
  companyId?: InputMaybe<Scalars['PwsID']['input']>;
  entityType?: InputMaybe<EntityType>;
  origin?: InputMaybe<Array<ActivityFeedOrigin>>;
  pagination?: InputMaybe<Pagination>;
  userId?: InputMaybe<Scalars['PwsID']['input']>;
};


export type QuerySearchActivityFeedGroupedArgs = {
  companyId?: InputMaybe<Scalars['PwsID']['input']>;
  entityType?: InputMaybe<EntityType>;
  origin?: InputMaybe<Array<ActivityFeedOrigin>>;
  pagination?: InputMaybe<Pagination>;
  userId?: InputMaybe<Scalars['PwsID']['input']>;
};


export type QuerySearchAdCopiesArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: AdCopySearchQuery;
};


export type QuerySearchAdGroupsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: AdGroupSearchQuery;
};


export type QuerySearchAdvertiserInvoicesArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: InvoiceAdvertiserSearchQuery;
};


export type QuerySearchAdvertisersArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QuerySearchCampaignsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: CampaignSearchQuery;
};


export type QuerySearchCompaniesArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: CompanySearchQuery;
};


export type QuerySearchCopperCompaniesArgs = {
  pagination?: InputMaybe<Pagination>;
  params?: InputMaybe<CopperCompanySearchParams>;
};


export type QuerySearchCopperOpportunitiesArgs = {
  pagination?: InputMaybe<Pagination>;
  params?: InputMaybe<CopperOpportunitySearchParams>;
};


export type QuerySearchInDirectoryArgs = {
  adGroupId: Scalars['PwsID']['input'];
  pagination?: InputMaybe<Pagination>;
  searchQuery: DirectorySearchQuery;
};


export type QuerySearchMarketsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: MarketSearchQuery;
};


export type QuerySearchOutsideDirectoryArgs = {
  adGroupId: Scalars['PwsID']['input'];
  pagination?: InputMaybe<Pagination>;
  searchQuery: DirectorySearchQuery;
};


export type QuerySearchPositionsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: PositionSearchQuery;
};


export type QuerySearchProgrammaticCampaignsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: CampaignProgrammaticSearchQuery;
};


export type QuerySearchPublisherInvoicesArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: InvoicePublisherSearchQuery;
};


export type QuerySearchSentEmailsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: SentEmailSearchQuery;
};


export type QuerySearchTagsArgs = {
  origin?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  query: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: UserSearchQuery;
};


export type QuerySearchWebsitesArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery: WebsiteSearchQuery;
};


export type QuerySegmentBehaviouralArgs = {
  id: Scalars['PwsID']['input'];
};


export type QuerySegmentCrmArgs = {
  id: Scalars['PwsID']['input'];
};


export type QuerySimulateReachArgs = {
  adFormat?: InputMaybe<AdFormat>;
  directory?: InputMaybe<AdGroupDirectoryInput>;
  market: Scalars['PwsID']['input'];
  network?: InputMaybe<Network>;
  targeting: AdGroupTargetingInput;
};


export type QueryTargetingReachArgs = {
  adGroupId: Scalars['PwsID']['input'];
  targeting: AdGroupTargetingInput;
};


export type QueryTradingDeskArgs = {
  id?: InputMaybe<Scalars['PwsID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['PwsID']['input']>;
};


export type QueryUserExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryWebsiteArgs = {
  id: Scalars['PwsID']['input'];
};

export type Rectangle = {
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  border: BorderRadius;
  height: Scalars['Int']['output'];
  left: Scalars['Int']['output'];
  top: Scalars['Int']['output'];
  type: Element;
  width: Scalars['Int']['output'];
};

export type RectangleInput = {
  backgroundColor?: InputMaybe<Scalars['Color']['input']>;
  border?: BorderRadiusInput;
  height?: Scalars['Int']['input'];
  left?: Scalars['Int']['input'];
  top?: Scalars['Int']['input'];
  type: Element;
  width?: Scalars['Int']['input'];
};

/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type Reseller = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  /** Account users associated with Powerspace. Can be filtered by status. */
  accounts: Array<User>;
  /** Ad groups and advertiser performance metrics grouped by IAB ad-product category at tiers 1, 2, and 3 (Druid lookups). Tier 3 falls back to tier 2 then tier 1 when missing. Ad groups with no lookup value are included under Unclassified. SuperAdmin only. */
  adGroupAdProductTiers: Array<AdGroupAdProductTierLevel>;
  adGroupIABStatsAnalysis: Array<AdGroupIabStatsAnalysis>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** List of specific advertisers excluded from running on this reseller, with creation date */
  advertiserExclusions: Array<AdvertiserExclusionItem>;
  /** Nested advertiser performance stats for this reseller */
  advertiserPerformanceStats: ResellerAdvertiserPerformanceStats;
  advertiserTimeseries: AdvertiserTimeseriesTotal;
  advertisers: Array<Advertiser>;
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  /** Auto-archive policy for inactive inventory (stored config, not resolved against parent) */
  archiverConfig: ArchiverConfig;
  /** Exclusion presets assigned to this reseller */
  assignedExclusionPresets: Array<PublisherExclusionPreset>;
  /** Exclusion presets available for this reseller: owned by the reseller, and Powerspace when the current user is from Powerspace */
  availableExclusionPresets: Array<PublisherExclusionPreset>;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Allowed banner dimensions for this reseller. Falls back to global defaults when unset. */
  bannerSizes?: Maybe<Array<Size>>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  /** Budget and performance data for Powerspace, including daily budgets, revenue, impressions, and clicks. Can be filtered by sales and account IDs. */
  budgets: PowerspaceBudgets;
  /** List of specific campaigns excluded from running on this reseller, with creation date */
  campaignExclusions: Array<CampaignExclusionItem>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Country where this company is registered */
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  /** Demand source metrics showing impressions by publisher reseller and advertiser reseller combinations, including unfilled impressions. */
  demandSources: Array<PowerspaceDemandSources>;
  /** List of excluded advertiser domains that cannot run on this reseller, with creation date */
  domainExclusions: Array<DomainExclusionItem>;
  /** Exclusion presets owned by this reseller */
  exclusionPresets: Array<PublisherExclusionPreset>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  /** List of excluded IAB categories that cannot run on this reseller, with creation date */
  iabExclusions: Array<IabExclusionItem>;
  /** Distribution of ad groups and performance metrics (impressions, clicks, conversions) across IAB categories for Powerspace. */
  iabRepartition: Array<AdGroupIabRepartion>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  /** Publisher audience population statistics for Powerspace over a date range */
  population: PublisherPopulation;
  priorities: Array<AdPriority>;
  /** Nested publisher performance stats for this reseller */
  publisherPerformanceStats: ResellerPublisherPerformanceStats;
  publisherPopulation: PublisherPopulation;
  publisherTimeseries: PublisherTimeseriesTotal;
  publishers: Array<Publisher>;
  registrationId?: Maybe<Scalars['String']['output']>;
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales users associated with Powerspace. Can be filtered by status. */
  sales: Array<User>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Reseller-specific settings (SuperAdmin only) */
  settings: ResellerSettings;
  slug: Scalars['String']['output'];
  status: Status;
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** The type of the company */
  type: CompanyType;
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerAccountsArgs = {
  status?: InputMaybe<UserStatus>;
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerAdGroupAdProductTiersArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  source?: AdGroupClassificationSource;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerAdGroupIabStatsAnalysisArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerAdvertiserPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerAdvertiserTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerBudgetsArgs = {
  accountIds?: InputMaybe<Array<Scalars['PwsID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  saleIds?: InputMaybe<Array<Scalars['PwsID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerDemandSourcesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerIabRepartitionArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerPopulationArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerPublisherPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerPublisherTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};


/** Reseller company operating a white-label ad platform with publishers and advertisers */
export type ResellerSalesArgs = {
  status?: InputMaybe<UserStatus>;
};

export type ResellerAdvertiserPerformanceStats = {
  advertisers: Array<AdvertiserWithPerformance>;
  devices: Array<AdvertiserDeviceCost>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

export type ResellerPublisherPerformanceStats = {
  advertiserResellers: Array<PublisherResellerCost>;
  devices: Array<PublisherDeviceCost>;
  publishers: Array<PublisherWithPerformance>;
  stats: PublisherCostDetails;
  zones: Array<PublisherZoneCost>;
};

/** Reseller-specific settings (SuperAdmin only) */
export type ResellerSettings = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
};

export type ResellerSettingsInput = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: InputMaybe<Scalars['PwsID']['input']>;
};

export type RichText = {
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  border: BorderRadius;
  font: FontConfiguration;
  height: Scalars['Int']['output'];
  horizontalAlign: HorizontalAlign;
  left: Scalars['Int']['output'];
  overrides: Array<FontOverride>;
  text: Scalars['String']['output'];
  top: Scalars['Int']['output'];
  type: Element;
  verticalAlign: VerticalAlign;
  width: Scalars['Int']['output'];
};

export type RichTextInput = {
  backgroundColor?: InputMaybe<Scalars['Color']['input']>;
  border?: BorderRadiusInput;
  font?: FontConfigurationInput;
  height?: Scalars['Int']['input'];
  horizontalAlign?: HorizontalAlign;
  left?: Scalars['Int']['input'];
  overrides?: Array<FontOverrideInput>;
  text?: Scalars['String']['input'];
  top?: Scalars['Int']['input'];
  type: Element;
  verticalAlign?: VerticalAlign;
  width?: Scalars['Int']['input'];
};

export enum RuleType {
  NotVisitedUrl = 'NotVisitedUrl',
  NotVisitedUrlContaining = 'NotVisitedUrlContaining',
  VisitedUrl = 'VisitedUrl',
  VisitedUrlContaining = 'VisitedUrlContaining',
  VisitedWebsite = 'VisitedWebsite'
}

/** Trading desk seat association with DSP for programmatic buying, representing buyer identity in RTB auctions */
export type Seat = {
  dsp: Scalars['String']['output'];
  seat: Scalars['String']['output'];
};

/** Union type representing audience segments: either CRM segments (from uploaded user lists) or behavioral segments (based on user actions and rules) */
export type Segment = SegmentBehavioural | SegmentCrm;

/** Behavioral segment based on user actions and rules, dynamically updated as users match criteria */
export type SegmentBehavioural = {
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Duration in seconds that users remain in this segment after matching rules */
  duration?: Maybe<Scalars['Int']['output']>;
  errorReason?: Maybe<Scalars['String']['output']>;
  /** Number of profiles already existing in the system */
  existingProfiles?: Maybe<Scalars['Int']['output']>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  nbProfiles?: Maybe<Scalars['Int']['output']>;
  /** Estimated reach as percentage of targetable audience */
  reach?: Maybe<Scalars['Float']['output']>;
  /** Behavioral rules that define when users match this segment (URL visits, page views, etc.) */
  rules: Array<SegmentBehaviouralRule>;
  status: SegmentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SegmentBehaviouralInput = {
  archived: Scalars['Boolean']['input'];
  createdAt: Scalars['DateTime']['input'];
  /** Duration in seconds that users remain in this segment after matching rules */
  duration?: InputMaybe<Scalars['Int']['input']>;
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /** Number of profiles already existing in the system */
  existingProfiles?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  nbProfiles?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated reach as percentage of targetable audience */
  reach?: InputMaybe<Scalars['Float']['input']>;
  status: SegmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SegmentBehaviouralRule = {
  /** Type of behavioral rule determining how URLs are matched (visited, not visited, containing pattern, etc.) */
  type: RuleType;
  urls: Array<Scalars['String']['output']>;
};

export type SegmentBehaviouralRuleInput = {
  /** Type of behavioral rule determining how URLs are matched (visited, not visited, containing pattern, etc.) */
  type: RuleType;
  urls: Array<Scalars['String']['input']>;
};

export type SegmentCrmInput = {
  archived: Scalars['Boolean']['input'];
  createdAt: Scalars['DateTime']['input'];
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /** Number of profiles already existing in the system */
  existingProfiles?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  nbProfiles?: InputMaybe<Scalars['Int']['input']>;
  /** Original filename of the uploaded CRM list */
  originalFilename: Scalars['String']['input'];
  /** Estimated reach as percentage of targetable audience */
  reach?: InputMaybe<Scalars['Float']['input']>;
  status: SegmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** CRM segment from uploaded file containing user emails or identifiers for targeted advertising */
export type SegmentCrm = {
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
  /** Number of profiles already existing in the system */
  existingProfiles?: Maybe<Scalars['Int']['output']>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  nbProfiles?: Maybe<Scalars['Int']['output']>;
  /** Original filename of the uploaded CRM list */
  originalFilename: Scalars['String']['output'];
  /** Estimated reach as percentage of targetable audience */
  reach?: Maybe<Scalars['Float']['output']>;
  status: SegmentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Segment processing status: created (initialized), uploading (data transfer), pending (queued), processed (ready), error (failed), deleting (removal in progress), deleted (removed) */
export enum SegmentStatus {
  Created = 'Created',
  Deleted = 'Deleted',
  Deleting = 'Deleting',
  Error = 'Error',
  Pending = 'Pending',
  Processed = 'Processed',
  Uploading = 'Uploading'
}

/** Mailjet send record and delivery status for a single recipient */
export type SentEmail = {
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailDoesNotExist: Scalars['Boolean']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceId?: Maybe<Scalars['PwsID']['output']>;
  mailjetStatus?: Maybe<Scalars['String']['output']>;
  /** Null while delivery status is pending */
  received?: Maybe<Scalars['Boolean']['output']>;
  recipientEmail: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  type: SentEmailType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter sent emails by recipient address and/or invoice reference (at least one required) */
export type SentEmailSearchQuery = {
  /** Filter by publisher invoice reference */
  invoiceReference?: InputMaybe<Scalars['InvoiceReference']['input']>;
  /** Filter by recipient email address */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Category of transactional email sent through Mailjet */
export enum SentEmailType {
  Invite = 'Invite',
  Invoice = 'Invoice',
  ResetPassword = 'ResetPassword'
}

/** Image dimensions specification for ad templates and ad copies */
export type Size = {
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

/** Image dimensions specification for ad templates and ad copies */
export type SizeInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

/** Provisioning progress for a custom domain */
export enum SslCreationProgress {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Ready = 'Ready',
  Renewing = 'Renewing'
}

/** Current SSL validity status for a custom domain */
export enum SslStatus {
  Expired = 'Expired',
  Invalid = 'Invalid',
  NotLinked = 'NotLinked',
  Pending = 'Pending',
  Valid = 'Valid'
}

export enum Status {
  Active = 'Active',
  Archived = 'Archived',
  Inactive = 'Inactive'
}

/** White-label styling configuration for reseller branding with colors and logo */
export type Style = {
  logoUrl: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  secondaryColor: Scalars['String']['output'];
  tertiaryColor: Scalars['String']['output'];
};

/** Specific placement context within a channel (newsletter, confirmation page, product listing, order confirmation email) */
export enum SubChannelType {
  ConfirmationPage = 'ConfirmationPage',
  Newsletter = 'Newsletter',
  OrderConfirmationEmail = 'OrderConfirmationEmail',
  ProductListing = 'ProductListing'
}

export type TargetingBox = {
  northeast: GeoLocation;
  southwest: GeoLocation;
};

export type TargetingBoxInput = {
  northeast?: GeoLocationInput;
  southwest?: GeoLocationInput;
};

export type TargetingCircle = {
  location: GeoLocation;
  name: Scalars['String']['output'];
  radius: Scalars['Int']['output'];
};

export type TargetingCircleInput = {
  location?: GeoLocationInput;
  name?: Scalars['String']['input'];
  radius?: Scalars['Int']['input'];
};

export type TargetingZone = {
  geometry: TargetingBox;
  name: Scalars['String']['output'];
};

export type TargetingZoneInput = {
  geometry?: TargetingBoxInput;
  name?: Scalars['String']['input'];
};

/** Tax calculation details for an invoice */
export type Tax = {
  amount: Scalars['Float']['output'];
  percentage: Scalars['Percentage']['output'];
};

export type TermsAndConditionApproval = {
  acceptedAt: Scalars['DateTime']['output'];
  companyId: Scalars['PwsID']['output'];
  /** User who accepted these terms and conditions */
  user: User;
  userId: Scalars['PwsID']['output'];
  version: Scalars['String']['output'];
};

export type TermsAndConditionApprovalCreateInput = {
  version: Scalars['String']['input'];
};

export type TimeTargeting = {
  days: Array<Day>;
  hours: Array<Scalars['Int']['output']>;
};

export type TimeTargetingInput = {
  days?: Array<Day>;
  hours?: Array<Scalars['Int']['input']>;
};

/** Trading desk company executing programmatic ad campaigns */
export type TradingDesk = {
  /** Account manager user ID (Powerspace reseller only) */
  accountManagerId?: Maybe<Scalars['PwsID']['output']>;
  accountingId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Agency>;
  agencyId?: Maybe<Scalars['PwsID']['output']>;
  /** API tokens for this company. Requires API permission. */
  apiTokens: Array<CompanyApiToken>;
  approvedTerms?: Maybe<TermsAndConditionApproval>;
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing contacts for this company. Requires admin access. */
  billingContacts: Array<BillingContact>;
  /** Programmatic campaigns executed by this trading desk */
  campaigns: Array<CampaignProgrammatic>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Country where this company is registered */
  country: Country;
  /** The currency for company invoices */
  currency?: Maybe<Currency>;
  fax?: Maybe<Scalars['String']['output']>;
  genericName: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['PwsID']['output'];
  invoiceLanguage?: Maybe<InvoiceLanguage>;
  invoicingCompany?: Maybe<InvoicingCompany>;
  kpis?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The payment terms of the company */
  paymentTerm?: Maybe<PaymentTerm>;
  /** Trading desk performance stats with full campaign details and totals-only inventory breakdowns. */
  performanceStats: TradingDeskPerformanceStats;
  permissions: CompanyPermission;
  phone?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  /** Reseller this trading desk belongs to */
  reseller: Reseller;
  resellerId: Scalars['PwsID']['output'];
  rootDomain?: Maybe<Scalars['String']['output']>;
  /** Sales manager user ID (Powerspace reseller only) */
  salesManagerId?: Maybe<Scalars['PwsID']['output']>;
  seats: Array<Seat>;
  slug: Scalars['String']['output'];
  status: Status;
  /** Branding and styling configuration for this company's reseller */
  style?: Maybe<Style>;
  swift?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** Time-series performance metrics for this trading desk over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  /** The type of the company */
  type: CompanyType;
  /** Current user permissions for this trading desk (read, edit, admin) */
  userPermissions: UserPermission;
  vatId?: Maybe<Scalars['String']['output']>;
  /** Webhooks configured for this company. Requires API permission. */
  webhooks: Array<CompanyWebhook>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


/** Trading desk company executing programmatic ad campaigns */
export type TradingDeskPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Trading desk company executing programmatic ad campaigns */
export type TradingDeskTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type TradingDeskPerformanceStats = {
  campaigns: Array<CampaignProgrammaticWithPerformance>;
  devices: Array<AdvertiserDeviceCost>;
  publisherResellers: Array<AdvertiserResellerCost>;
  stats: AdvertiserCostDetails;
};

export type Triangle = {
  backgroundColor?: Maybe<Scalars['Color']['output']>;
  border: Border;
  height: Scalars['Int']['output'];
  left: Scalars['Int']['output'];
  top: Scalars['Int']['output'];
  type: Element;
  width: Scalars['Int']['output'];
};

export type TriangleInput = {
  backgroundColor?: InputMaybe<Scalars['Color']['input']>;
  border?: BorderInput;
  height?: Scalars['Int']['input'];
  left?: Scalars['Int']['input'];
  top?: Scalars['Int']['input'];
  type: Element;
  width?: Scalars['Int']['input'];
};

export type UpdateAssistantRuleInput = {
  conditions?: InputMaybe<AssistantRuleConditionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  executionOrder?: InputMaybe<Scalars['Int']['input']>;
  importance?: InputMaybe<AssistantRuleImportance>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recommendedChanges?: InputMaybe<AssistantRuleRecommendationInput>;
  resellerId: Scalars['PwsID']['input'];
  ruleId?: InputMaybe<Scalars['PwsID']['input']>;
};

/** Platform user with authentication, profile, and access control */
export type User = {
  accessType: AccessType;
  /** Advertisers associated with this account. Only returns advertisers for Powerspace accounts (company ID 1). */
  advertisers: Array<Advertiser>;
  /** The company this user belongs to */
  company: Company;
  companyId: Scalars['PwsID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['Email']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['PwsID']['output'];
  invitationDoneAt?: Maybe<Scalars['DateTime']['output']>;
  invitationToken?: Maybe<Scalars['String']['output']>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  invitedBy?: Maybe<Scalars['Int']['output']>;
  isPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  landline?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  market?: Maybe<Market>;
  marketId?: Maybe<Scalars['PwsID']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** Account performance stats with full advertiser details and totals-only campaign/ad group/ad copy breakdowns. */
  performanceStats: AdvertisersPerformanceStats;
  /** Reseller associated with this account */
  reseller: Reseller;
  resetToken?: Maybe<Scalars['String']['output']>;
  resetTokenAt?: Maybe<Scalars['DateTime']['output']>;
  resetTokenDoneAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UserRole>;
  slackId?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  /** Time-series performance metrics aggregated across all advertisers associated with this account over a date range */
  timeseries: AdvertiserTimeseriesTotal;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Platform user with authentication, profile, and access control */
export type UserPerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Platform user with authentication, profile, and access control */
export type UserTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

/** Frequency capping type: uncapped (no limit), impression (limit ad views per user), click (limit clicks per user) */
export enum UserCapping {
  Click = 'Click',
  Impression = 'Impression',
  Uncapped = 'Uncapped'
}

export type UserCreateInput = {
  accessType?: AccessType;
  companyId: Scalars['PwsID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  language?: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  status?: UserStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UserInput = {
  accessType: AccessType;
  companyId: Scalars['PwsID']['input'];
  createdAt: Scalars['DateTime']['input'];
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['PwsID']['input'];
  invitationDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  invitedBy?: InputMaybe<Scalars['Int']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  landline?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['PwsID']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  resetToken?: InputMaybe<Scalars['String']['input']>;
  resetTokenAt?: InputMaybe<Scalars['DateTime']['input']>;
  resetTokenDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<UserRole>;
  slackId?: InputMaybe<Scalars['String']['input']>;
  status: UserStatus;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserInviteInput = {
  accessType: AccessType;
  companyId: Scalars['PwsID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  status: UserStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UserPermission = {
  adCopyDates: Scalars['Boolean']['output'];
  /** Permission to validate and approve ad copy submissions */
  adCopyValidation: Scalars['Boolean']['output'];
  adgroupAutoSegments: Scalars['Boolean']['output'];
  /** Allow budget capping on ad groups. */
  adgroupBudgetCapping: Scalars['Boolean']['output'];
  adgroupCpl: Scalars['Boolean']['output'];
  adgroupCpm: Scalars['Boolean']['output'];
  adgroupCustomcpcs: Scalars['Boolean']['output'];
  /** Require a start date and an end date on ad groups. */
  adgroupDatesRequired: Scalars['Boolean']['output'];
  adgroupDevicetargeting: Scalars['Boolean']['output'];
  adgroupExclusions: Scalars['Boolean']['output'];
  adgroupGeotargeting: Scalars['Boolean']['output'];
  /** Allow monthly budget capping on ad groups. */
  adgroupMonthlyBudgetCapping: Scalars['Boolean']['output'];
  /** Allow open (unlimited) budget capping on ad groups. */
  adgroupOpenBudgetCapping: Scalars['Boolean']['output'];
  /** Allow open daily budget on ad groups. */
  adgroupOpenDailyBudget: Scalars['Boolean']['output'];
  /** Allow overall budget capping on ad groups. */
  adgroupOverallBudgetCapping: Scalars['Boolean']['output'];
  adgroupPriority: Scalars['Boolean']['output'];
  adgroupReportwebsites: Scalars['Boolean']['output'];
  adgroupSegments: Scalars['Boolean']['output'];
  adgroupTimetargeting: Scalars['Boolean']['output'];
  adgroupUsertargeting: Scalars['Boolean']['output'];
  admin: Scalars['Boolean']['output'];
  /** Access to advertiser directory presets. */
  advertiserDirectoryPresets: Scalars['Boolean']['output'];
  /** Access to AI assistant suggestions for ad groups. */
  aiAssistant: Scalars['Boolean']['output'];
  api: Scalars['Boolean']['output'];
  /** Access to the assistant. */
  assistant: Scalars['Boolean']['output'];
  banner: Scalars['Boolean']['output'];
  companyType: CompanyType;
  /** Access to cost history. */
  costHistory: Scalars['Boolean']['output'];
  /** Access to cost recommendation. */
  costRecommendation: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  /** Whether feature permissions can be updated on this company (false when inherited from a parent company). */
  editable: Scalars['Boolean']['output'];
  positionAdvancedsettings: Scalars['Boolean']['output'];
  /** Access to publisher blacklist presets. */
  publisherBlacklistPresets: Scalars['Boolean']['output'];
  read: Scalars['Boolean']['output'];
  superAdmin: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
  websiteExclusions: Scalars['Boolean']['output'];
};

/** User role within their company (finance, marketing, sales, tech, traffic, publisher account) */
export enum UserRole {
  Finance = 'Finance',
  Marketing = 'Marketing',
  PublisherAccount = 'PublisherAccount',
  Sales = 'Sales',
  Tech = 'Tech',
  Traffic = 'Traffic'
}

/** Search criteria for filtering users */
export type UserSearchQuery = {
  /** Filter users by company ID */
  companyId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter users by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter users by reseller ID */
  resellerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter users by status */
  status?: InputMaybe<Array<UserStatus>>;
};

/** User account status (enabled, disabled, deleted) */
export enum UserStatus {
  Deleted = 'Deleted',
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export enum VerticalAlign {
  Bottom = 'Bottom',
  Middle = 'Middle',
  Top = 'Top'
}

export type WebhookExample = {
  /** Sample webhook request body for the given type and version */
  payload: Scalars['JSON']['output'];
  type: CompanyWebhookType;
  version: Scalars['Int']['output'];
};

/** Publisher website containing ad positions with exclusion rules and performance tracking */
export type Website = {
  /** List of specific advertisers excluded from running on this website, with creation date */
  advertiserExclusions: Array<AdvertiserExclusionItem>;
  /** Exclusion presets assigned to this website */
  assignedExclusionPresets: Array<PublisherExclusionPreset>;
  /** List of specific campaigns excluded from running on this website, with creation date */
  campaignExclusions: Array<CampaignExclusionItem>;
  /** List of excluded advertiser domains that cannot run on this website, with creation date */
  domainExclusions: Array<DomainExclusionItem>;
  /** Whether site URL verification reported an error */
  hasUrlVerificationError: Scalars['Boolean']['output'];
  iabCategory: Iab;
  /** List of excluded IAB categories that cannot run on this website, with creation date */
  iabExclusions: Array<IabExclusionItem>;
  id: Scalars['PwsID']['output'];
  market: Market;
  marketId: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** Website performance stats with totals-only position/ad template breakdowns. */
  performanceStats: WebsitePerformanceStats;
  /** Audience demographics and population statistics for this website */
  population: PublisherPopulation;
  /** Ad positions available on this website */
  positions: Array<Position>;
  publisher: Publisher;
  publisherId: Scalars['PwsID']['output'];
  /** IAB category suggested from the IAB content tiers of the website (majority vote). Null when there is no suggestion or it matches the category already set on the website. Includes the tiers of the suggested category. */
  recommendedIabCategory?: Maybe<WebsiteIabCategoryRecommendation>;
  /** Website status (active, paused, archived, etc.) */
  status: Status;
  /** Time-series revenue metrics for this website over a date range */
  timeseries: PublisherTimeseriesTotal;
  url: Scalars['String']['output'];
};


/** Publisher website containing ad positions with exclusion rules and performance tracking */
export type WebsitePerformanceStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['String']['input'];
};


/** Publisher website containing ad positions with exclusion rules and performance tracking */
export type WebsitePositionsArgs = {
  status?: InputMaybe<Array<Status>>;
};


/** Publisher website containing ad positions with exclusion rules and performance tracking */
export type WebsiteTimeseriesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Array<CostDetailsFilter>>;
  granularity: GraphGranularity;
  startDate: Scalars['DateTime']['input'];
};

export type WebsiteAdjustment = {
  iabCategory?: Maybe<Iab>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  /** List of ad positions with their individual adjustment settings */
  positions: Array<PositionAdjustment>;
  /** Actual applied revenue adjustment percentage for this website */
  realAdjustment?: Maybe<Scalars['Percentage']['output']>;
  /** Reseller company that manages this website */
  reseller: WebsiteAdjustmentReseller;
  url: Scalars['String']['output'];
  /** Desired revenue adjustment percentage for this website */
  wantedAdjustment?: Maybe<Scalars['Percentage']['output']>;
};

export type WebsiteAdjustmentInput = {
  iabCategory?: InputMaybe<Iab>;
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  /** List of ad positions with their individual adjustment settings */
  positions: Array<PositionAdjustmentInput>;
  /** Actual applied revenue adjustment percentage for this website */
  realAdjustment?: InputMaybe<Scalars['Percentage']['input']>;
  /** Reseller company that manages this website */
  reseller: WebsiteAdjustmentResellerInput;
  url: Scalars['String']['input'];
  /** Desired revenue adjustment percentage for this website */
  wantedAdjustment?: InputMaybe<Scalars['Percentage']['input']>;
};

export type WebsiteAdjustmentReseller = {
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
};

export type WebsiteAdjustmentResellerInput = {
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
};

export type WebsiteCreateInput = {
  iabCategory?: Iab;
  marketId: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  publisherId: Scalars['PwsID']['input'];
  url: Scalars['String']['input'];
};

export type WebsiteDirectory = {
  iabCategory?: Maybe<Iab>;
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  positions: Array<PositionDirectory>;
  reseller: WebsiteDirectoryReseller;
  url: Scalars['String']['output'];
};

export type WebsiteDirectoryInput = {
  iabCategory?: InputMaybe<Iab>;
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  positions: Array<PositionDirectoryInput>;
  reseller: WebsiteDirectoryResellerInput;
  url: Scalars['String']['input'];
};

export type WebsiteDirectoryReseller = {
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
};

export type WebsiteDirectoryResellerInput = {
  id: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
};

/** IAB category suggested for a website, together with the content tiers of that category */
export type WebsiteIabCategoryRecommendation = {
  /** Suggested IAB category */
  iabCategory: Iab;
  /** Content tiers of the suggested category */
  iabTiers: IabTiers;
};

export type WebsiteInput = {
  iabCategory: Iab;
  id: Scalars['PwsID']['input'];
  marketId: Scalars['PwsID']['input'];
  name: Scalars['String']['input'];
  publisherId: Scalars['PwsID']['input'];
  url: Scalars['String']['input'];
};

export type WebsitePerformanceStats = {
  advertiserResellers: Array<PublisherResellerCost>;
  devices: Array<PublisherDeviceCost>;
  positions: Array<PositionWithPerformance>;
  stats: PublisherCostDetails;
  zones: Array<PublisherZoneCost>;
};

/** Search criteria for filtering websites */
export type WebsiteSearchQuery = {
  /** Filter websites by publisher company ID */
  companyId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter websites by IAB category */
  iabCategory?: InputMaybe<Iab>;
  /** Filter websites by market ID */
  marketId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter websites by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter websites by reseller ID */
  resellerId?: InputMaybe<Scalars['PwsID']['input']>;
  /** Filter websites by status */
  status?: InputMaybe<Array<Status>>;
};

export type WebsiteWithPerformance = {
  id: Scalars['PwsID']['output'];
  name: Scalars['String']['output'];
  positions: Array<PositionWithPerformance>;
  stats: PublisherCostDetails;
  url: Scalars['String']['output'];
};
